export const FilterItemsPropsDefault = [
    {
        "ID": "109",
        "NAME": "Цвет",
        "CODE": "ORGANZA_COLOR",
        "PROPERTY_TYPE": "S",
        "LIST_TYPE": "S",
        "DISPLAY_TYPE": "G",
        "PROPERTY_VALUE": {
            "HighloadBlock": [
                {
                    "nameValeu": "a02020",
                    "countfiltr": 1047,
                    "ID": 66349,
                    "UF_HEX": "#a02020"
                },
                {
                    "nameValeu": "c04040",
                    "countfiltr": 841,
                    "ID": 66350,
                    "UF_HEX": "#c04040"
                },
                {
                    "nameValeu": "c06040",
                    "countfiltr": 1058,
                    "ID": 66351,
                    "UF_HEX": "#c06040"
                },
                {
                    "nameValeu": "c06060",
                    "countfiltr": 1113,
                    "ID": 66352,
                    "UF_HEX": "#c06060"
                },
                {
                    "nameValeu": "c02020",
                    "countfiltr": 468,
                    "ID": 66353,
                    "UF_HEX": "#c02020"
                },
                {
                    "nameValeu": "c02040",
                    "countfiltr": 392,
                    "ID": 66354,
                    "UF_HEX": "#c02040"
                },
                {
                    "nameValeu": "a04020",
                    "countfiltr": 1083,
                    "ID": 66355,
                    "UF_HEX": "#a04020"
                },
                {
                    "nameValeu": "a02040",
                    "countfiltr": 701,
                    "ID": 66356,
                    "UF_HEX": "#a02040"
                },
                {
                    "nameValeu": "a04040",
                    "countfiltr": 1788,
                    "ID": 66357,
                    "UF_HEX": "#a04040"
                },
                {
                    "nameValeu": "c04020",
                    "countfiltr": 499,
                    "ID": 66358,
                    "UF_HEX": "#c04020"
                },
                {
                    "nameValeu": "e08060",
                    "countfiltr": 518,
                    "ID": 66359,
                    "UF_HEX": "#e08060"
                },
                {
                    "nameValeu": "e06060",
                    "countfiltr": 341,
                    "ID": 66360,
                    "UF_HEX": "#e06060"
                },
                {
                    "nameValeu": "c04060",
                    "countfiltr": 385,
                    "ID": 66361,
                    "UF_HEX": "#c04060"
                },
                {
                    "nameValeu": "802020",
                    "countfiltr": 1760,
                    "ID": 66362,
                    "UF_HEX": "#802020"
                },
                {
                    "nameValeu": "c08060",
                    "countfiltr": 3050,
                    "ID": 66363,
                    "UF_HEX": "#c08060"
                },
                {
                    "nameValeu": "e08080",
                    "countfiltr": 517,
                    "ID": 66364,
                    "UF_HEX": "#e08080"
                },
                {
                    "nameValeu": "202020",
                    "countfiltr": 8924,
                    "ID": 66394,
                    "UF_HEX": "#202020"
                },
                {
                    "nameValeu": "404040",
                    "countfiltr": 14238,
                    "ID": 66395,
                    "UF_HEX": "#404040"
                },
                {
                    "nameValeu": "606060",
                    "countfiltr": 19987,
                    "ID": 66402,
                    "UF_HEX": "#606060"
                },
                {
                    "nameValeu": "000020",
                    "countfiltr": 1286,
                    "ID": 66566,
                    "UF_HEX": "#000020"
                },
                {
                    "nameValeu": "202000",
                    "countfiltr": 1965,
                    "ID": 66396,
                    "UF_HEX": "#202000"
                },
                {
                    "nameValeu": "200000",
                    "countfiltr": 1948,
                    "ID": 66506,
                    "UF_HEX": "#200000"
                },
                {
                    "nameValeu": "202040",
                    "countfiltr": 4292,
                    "ID": 66400,
                    "UF_HEX": "#202040"
                },
                {
                    "nameValeu": "002020",
                    "countfiltr": 1218,
                    "ID": 66427,
                    "UF_HEX": "#002020"
                },
                {
                    "nameValeu": "200020",
                    "countfiltr": 1529,
                    "ID": 66569,
                    "UF_HEX": "#200020"
                },
                {
                    "nameValeu": "404060",
                    "countfiltr": 6325,
                    "ID": 66428,
                    "UF_HEX": "#404060"
                },
                {
                    "nameValeu": "606080",
                    "countfiltr": 7863,
                    "ID": 66469,
                    "UF_HEX": "#606080"
                },
                {
                    "nameValeu": "204040",
                    "countfiltr": 3643,
                    "ID": 66401,
                    "UF_HEX": "#204040"
                },
                {
                    "nameValeu": "406060",
                    "countfiltr": 5405,
                    "ID": 66426,
                    "UF_HEX": "#406060"
                },
                {
                    "nameValeu": "404020",
                    "countfiltr": 6310,
                    "ID": 66365,
                    "UF_HEX": "#404020"
                },
                {
                    "nameValeu": "a06080",
                    "countfiltr": 1328,
                    "ID": 66379,
                    "UF_HEX": "#a06080"
                },
                {
                    "nameValeu": "804060",
                    "countfiltr": 1381,
                    "ID": 66405,
                    "UF_HEX": "#804060"
                },
                {
                    "nameValeu": "602040",
                    "countfiltr": 1366,
                    "ID": 66404,
                    "UF_HEX": "#602040"
                },
                {
                    "nameValeu": "804040",
                    "countfiltr": 3525,
                    "ID": 66410,
                    "UF_HEX": "#804040"
                },
                {
                    "nameValeu": "806060",
                    "countfiltr": 18048,
                    "ID": 66403,
                    "UF_HEX": "#806060"
                },
                {
                    "nameValeu": "a06060",
                    "countfiltr": 3430,
                    "ID": 66374,
                    "UF_HEX": "#a06060"
                },
                {
                    "nameValeu": "a04060",
                    "countfiltr": 776,
                    "ID": 66376,
                    "UF_HEX": "#a04060"
                },
                {
                    "nameValeu": "802040",
                    "countfiltr": 1004,
                    "ID": 66411,
                    "UF_HEX": "#802040"
                },
                {
                    "nameValeu": "806080",
                    "countfiltr": 6849,
                    "ID": 66408,
                    "UF_HEX": "#806080"
                },
                {
                    "nameValeu": "604040",
                    "countfiltr": 12476,
                    "ID": 66397,
                    "UF_HEX": "#604040"
                },
                {
                    "nameValeu": "a04080",
                    "countfiltr": 190,
                    "ID": 66412,
                    "UF_HEX": "#a04080"
                },
                {
                    "nameValeu": "402020",
                    "countfiltr": 7224,
                    "ID": 66393,
                    "UF_HEX": "#402020"
                },
                {
                    "nameValeu": "a080a0",
                    "countfiltr": 7522,
                    "ID": 66413,
                    "UF_HEX": "#a080a0"
                },
                {
                    "nameValeu": "602020",
                    "countfiltr": 2784,
                    "ID": 66414,
                    "UF_HEX": "#602020"
                },
                {
                    "nameValeu": "a060a0",
                    "countfiltr": 170,
                    "ID": 66415,
                    "UF_HEX": "#a060a0"
                },
                {
                    "nameValeu": "604060",
                    "countfiltr": 5463,
                    "ID": 66406,
                    "UF_HEX": "#604060"
                },
                {
                    "nameValeu": "204060",
                    "countfiltr": 1887,
                    "ID": 66419,
                    "UF_HEX": "#204060"
                },
                {
                    "nameValeu": "202060",
                    "countfiltr": 532,
                    "ID": 66425,
                    "UF_HEX": "#202060"
                },
                {
                    "nameValeu": "206080",
                    "countfiltr": 585,
                    "ID": 66429,
                    "UF_HEX": "#206080"
                },
                {
                    "nameValeu": "402040",
                    "countfiltr": 3760,
                    "ID": 66398,
                    "UF_HEX": "#402040"
                },
                {
                    "nameValeu": "400020",
                    "countfiltr": 611,
                    "ID": 66478,
                    "UF_HEX": "#400020"
                },
                {
                    "nameValeu": "602060",
                    "countfiltr": 203,
                    "ID": 66407,
                    "UF_HEX": "#602060"
                },
                {
                    "nameValeu": "a04000",
                    "countfiltr": 143,
                    "ID": 66444,
                    "UF_HEX": "#a04000"
                },
                {
                    "nameValeu": "c06020",
                    "countfiltr": 492,
                    "ID": 66499,
                    "UF_HEX": "#c06020"
                },
                {
                    "nameValeu": "c08020",
                    "countfiltr": 574,
                    "ID": 66443,
                    "UF_HEX": "#c08020"
                },
                {
                    "nameValeu": "c04000",
                    "countfiltr": 78,
                    "ID": 66705,
                    "UF_HEX": "#c04000"
                },
                {
                    "nameValeu": "c06000",
                    "countfiltr": 87,
                    "ID": 66441,
                    "UF_HEX": "#c06000"
                },
                {
                    "nameValeu": "a06020",
                    "countfiltr": 1164,
                    "ID": 66451,
                    "UF_HEX": "#a06020"
                },
                {
                    "nameValeu": "c0a020",
                    "countfiltr": 356,
                    "ID": 66460,
                    "UF_HEX": "#c0a020"
                },
                {
                    "nameValeu": "a06000",
                    "countfiltr": 192,
                    "ID": 66436,
                    "UF_HEX": "#a06000"
                },
                {
                    "nameValeu": "e0a020",
                    "countfiltr": 239,
                    "ID": 66438,
                    "UF_HEX": "#e0a020"
                },
                {
                    "nameValeu": "e08020",
                    "countfiltr": 203,
                    "ID": 66503,
                    "UF_HEX": "#e08020"
                },
                {
                    "nameValeu": "c08000",
                    "countfiltr": 133,
                    "ID": 66437,
                    "UF_HEX": "#c08000"
                },
                {
                    "nameValeu": "804000",
                    "countfiltr": 265,
                    "ID": 66439,
                    "UF_HEX": "#804000"
                },
                {
                    "nameValeu": "e06020",
                    "countfiltr": 187,
                    "ID": 66501,
                    "UF_HEX": "#e06020"
                },
                {
                    "nameValeu": "804020",
                    "countfiltr": 2089,
                    "ID": 66504,
                    "UF_HEX": "#804020"
                },
                {
                    "nameValeu": "e0ffff",
                    "countfiltr": 3042,
                    "ID": 66706,
                    "UF_HEX": "#e0ffff"
                },
                {
                    "nameValeu": "e0e0e0",
                    "countfiltr": 22894,
                    "ID": 66333,
                    "UF_HEX": "#e0e0e0"
                },
                {
                    "nameValeu": "e0e0ff",
                    "countfiltr": 3909,
                    "ID": 66575,
                    "UF_HEX": "#e0e0ff"
                },
                {
                    "nameValeu": "ffffff",
                    "countfiltr": 11200,
                    "ID": 66703,
                    "UF_HEX": "#ffffff"
                },
                {
                    "nameValeu": "c0c0c0",
                    "countfiltr": 28457,
                    "ID": 66701,
                    "UF_HEX": "#c0c0c0"
                },
                {
                    "nameValeu": "c0e0e0",
                    "countfiltr": 5070,
                    "ID": 66491,
                    "UF_HEX": "#c0e0e0"
                },
                {
                    "nameValeu": "808060",
                    "countfiltr": 18152,
                    "ID": 66430,
                    "UF_HEX": "#808060"
                },
                {
                    "nameValeu": "a0a0a0",
                    "countfiltr": 28517,
                    "ID": 66341,
                    "UF_HEX": "#a0a0a0"
                },
                {
                    "nameValeu": "c0c0e0",
                    "countfiltr": 6007,
                    "ID": 66514,
                    "UF_HEX": "#c0c0e0"
                },
                {
                    "nameValeu": "c0c0a0",
                    "countfiltr": 24382,
                    "ID": 66386,
                    "UF_HEX": "#c0c0a0"
                },
                {
                    "nameValeu": "a0a080",
                    "countfiltr": 23445,
                    "ID": 66344,
                    "UF_HEX": "#a0a080"
                },
                {
                    "nameValeu": "a08080",
                    "countfiltr": 22542,
                    "ID": 66378,
                    "UF_HEX": "#a08080"
                },
                {
                    "nameValeu": "a0a0c0",
                    "countfiltr": 8109,
                    "ID": 66471,
                    "UF_HEX": "#a0a0c0"
                },
                {
                    "nameValeu": "e0c0e0",
                    "countfiltr": 4077,
                    "ID": 66522,
                    "UF_HEX": "#e0c0e0"
                },
                {
                    "nameValeu": "e0e0c0",
                    "countfiltr": 18207,
                    "ID": 66384,
                    "UF_HEX": "#e0e0c0"
                },
                {
                    "nameValeu": "c0a0a0",
                    "countfiltr": 23671,
                    "ID": 66347,
                    "UF_HEX": "#c0a0a0"
                },
                {
                    "nameValeu": "e0c0c0",
                    "countfiltr": 18467,
                    "ID": 66458,
                    "UF_HEX": "#e0c0c0"
                },
                {
                    "nameValeu": "80a0a0",
                    "countfiltr": 7769,
                    "ID": 66467,
                    "UF_HEX": "#80a0a0"
                },
                {
                    "nameValeu": "a0c0c0",
                    "countfiltr": 7358,
                    "ID": 66476,
                    "UF_HEX": "#a0c0c0"
                },
                {
                    "nameValeu": "80a080",
                    "countfiltr": 4872,
                    "ID": 66432,
                    "UF_HEX": "#80a080"
                },
                {
                    "nameValeu": "608080",
                    "countfiltr": 6939,
                    "ID": 66472,
                    "UF_HEX": "#608080"
                },
                {
                    "nameValeu": "a0c0a0",
                    "countfiltr": 5592,
                    "ID": 66435,
                    "UF_HEX": "#a0c0a0"
                },
                {
                    "nameValeu": "80a060",
                    "countfiltr": 787,
                    "ID": 66338,
                    "UF_HEX": "#80a060"
                },
                {
                    "nameValeu": "a0c080",
                    "countfiltr": 690,
                    "ID": 66541,
                    "UF_HEX": "#a0c080"
                },
                {
                    "nameValeu": "a0a060",
                    "countfiltr": 4452,
                    "ID": 66389,
                    "UF_HEX": "#a0a060"
                },
                {
                    "nameValeu": "808040",
                    "countfiltr": 2995,
                    "ID": 66342,
                    "UF_HEX": "#808040"
                },
                {
                    "nameValeu": "c0e0c0",
                    "countfiltr": 4394,
                    "ID": 66525,
                    "UF_HEX": "#c0e0c0"
                },
                {
                    "nameValeu": "c0a0c0",
                    "countfiltr": 6480,
                    "ID": 66554,
                    "UF_HEX": "#c0a0c0"
                },
                {
                    "nameValeu": "8080a0",
                    "countfiltr": 8543,
                    "ID": 66465,
                    "UF_HEX": "#8080a0"
                },
                {
                    "nameValeu": "c080a0",
                    "countfiltr": 1066,
                    "ID": 66375,
                    "UF_HEX": "#c080a0"
                },
                {
                    "nameValeu": "a08060",
                    "countfiltr": 11999,
                    "ID": 66490,
                    "UF_HEX": "#a08060"
                },
                {
                    "nameValeu": "806040",
                    "countfiltr": 8720,
                    "ID": 66371,
                    "UF_HEX": "#806040"
                },
                {
                    "nameValeu": "608060",
                    "countfiltr": 3363,
                    "ID": 66431,
                    "UF_HEX": "#608060"
                },
                {
                    "nameValeu": "ffe0e0",
                    "countfiltr": 8406,
                    "ID": 66492,
                    "UF_HEX": "#ffe0e0"
                },
                {
                    "nameValeu": "ffe0ff",
                    "countfiltr": 2401,
                    "ID": 66656,
                    "UF_HEX": "#ffe0ff"
                },
                {
                    "nameValeu": "c0c080",
                    "countfiltr": 4388,
                    "ID": 66387,
                    "UF_HEX": "#c0c080"
                },
                {
                    "nameValeu": "a0c060",
                    "countfiltr": 255,
                    "ID": 66388,
                    "UF_HEX": "#a0c060"
                },
                {
                    "nameValeu": "606040",
                    "countfiltr": 12041,
                    "ID": 66370,
                    "UF_HEX": "#606040"
                },
                {
                    "nameValeu": "406080",
                    "countfiltr": 2353,
                    "ID": 66464,
                    "UF_HEX": "#406080"
                },
                {
                    "nameValeu": "c0a080",
                    "countfiltr": 12406,
                    "ID": 66377,
                    "UF_HEX": "#c0a080"
                },
                {
                    "nameValeu": "e0c0a0",
                    "countfiltr": 8314,
                    "ID": 66454,
                    "UF_HEX": "#e0c0a0"
                },
                {
                    "nameValeu": "e0c080",
                    "countfiltr": 2889,
                    "ID": 66452,
                    "UF_HEX": "#e0c080"
                },
                {
                    "nameValeu": "a06040",
                    "countfiltr": 3210,
                    "ID": 66488,
                    "UF_HEX": "#a06040"
                },
                {
                    "nameValeu": "e0e0a0",
                    "countfiltr": 2366,
                    "ID": 66385,
                    "UF_HEX": "#e0e0a0"
                },
                {
                    "nameValeu": "604020",
                    "countfiltr": 4512,
                    "ID": 66367,
                    "UF_HEX": "#604020"
                },
                {
                    "nameValeu": "e0a080",
                    "countfiltr": 1769,
                    "ID": 66482,
                    "UF_HEX": "#e0a080"
                },
                {
                    "nameValeu": "ffffe0",
                    "countfiltr": 7371,
                    "ID": 66702,
                    "UF_HEX": "#ffffe0"
                },
                {
                    "nameValeu": "c08080",
                    "countfiltr": 2897,
                    "ID": 66373,
                    "UF_HEX": "#c08080"
                },
                {
                    "nameValeu": "400000",
                    "countfiltr": 670,
                    "ID": 66493,
                    "UF_HEX": "#400000"
                },
                {
                    "nameValeu": "406040",
                    "countfiltr": 2156,
                    "ID": 66433,
                    "UF_HEX": "#406040"
                },
                {
                    "nameValeu": "c0a060",
                    "countfiltr": 4308,
                    "ID": 66457,
                    "UF_HEX": "#c0a060"
                },
                {
                    "nameValeu": "a08040",
                    "countfiltr": 3686,
                    "ID": 66700,
                    "UF_HEX": "#a08040"
                },
                {
                    "nameValeu": "ffe0c0",
                    "countfiltr": 2120,
                    "ID": 66494,
                    "UF_HEX": "#ffe0c0"
                },
                {
                    "nameValeu": "ff8080",
                    "countfiltr": 68,
                    "ID": 66487,
                    "UF_HEX": "#ff8080"
                },
                {
                    "nameValeu": "ffa080",
                    "countfiltr": 102,
                    "ID": 66484,
                    "UF_HEX": "#ffa080"
                },
                {
                    "nameValeu": "e0a060",
                    "countfiltr": 1277,
                    "ID": 66456,
                    "UF_HEX": "#e0a060"
                },
                {
                    "nameValeu": "e06040",
                    "countfiltr": 345,
                    "ID": 66483,
                    "UF_HEX": "#e06040"
                },
                {
                    "nameValeu": "600000",
                    "countfiltr": 462,
                    "ID": 66500,
                    "UF_HEX": "#600000"
                },
                {
                    "nameValeu": "e08040",
                    "countfiltr": 400,
                    "ID": 66495,
                    "UF_HEX": "#e08040"
                },
                {
                    "nameValeu": "802000",
                    "countfiltr": 289,
                    "ID": 66551,
                    "UF_HEX": "#802000"
                },
                {
                    "nameValeu": "c08040",
                    "countfiltr": 1719,
                    "ID": 66497,
                    "UF_HEX": "#c08040"
                },
                {
                    "nameValeu": "806020",
                    "countfiltr": 1768,
                    "ID": 66368,
                    "UF_HEX": "#806020"
                },
                {
                    "nameValeu": "602000",
                    "countfiltr": 515,
                    "ID": 66507,
                    "UF_HEX": "#602000"
                },
                {
                    "nameValeu": "402000",
                    "countfiltr": 1035,
                    "ID": 66399,
                    "UF_HEX": "#402000"
                },
                {
                    "nameValeu": "e0a0a0",
                    "countfiltr": 1551,
                    "ID": 66417,
                    "UF_HEX": "#e0a0a0"
                },
                {
                    "nameValeu": "606020",
                    "countfiltr": 1279,
                    "ID": 66345,
                    "UF_HEX": "#606020"
                },
                {
                    "nameValeu": "a08020",
                    "countfiltr": 732,
                    "ID": 66580,
                    "UF_HEX": "#a08020"
                },
                {
                    "nameValeu": "20e020",
                    "countfiltr": 1,
                    "ID": 66710,
                    "UF_HEX": "#20e020"
                },
                {
                    "nameValeu": "ffe0a0",
                    "countfiltr": 716,
                    "ID": 66461,
                    "UF_HEX": "#ffe0a0"
                },
                {
                    "nameValeu": "c0c060",
                    "countfiltr": 929,
                    "ID": 66383,
                    "UF_HEX": "#c0c060"
                },
                {
                    "nameValeu": "c0a040",
                    "countfiltr": 1318,
                    "ID": 66455,
                    "UF_HEX": "#c0a040"
                },
                {
                    "nameValeu": "a0a040",
                    "countfiltr": 858,
                    "ID": 66380,
                    "UF_HEX": "#a0a040"
                },
                {
                    "nameValeu": "204020",
                    "countfiltr": 1191,
                    "ID": 66434,
                    "UF_HEX": "#204020"
                },
                {
                    "nameValeu": "20a0a0",
                    "countfiltr": 89,
                    "ID": 66511,
                    "UF_HEX": "#20a0a0"
                },
                {
                    "nameValeu": "80a0c0",
                    "countfiltr": 1543,
                    "ID": 66348,
                    "UF_HEX": "#80a0c0"
                },
                {
                    "nameValeu": "a0e0e0",
                    "countfiltr": 325,
                    "ID": 66512,
                    "UF_HEX": "#a0e0e0"
                },
                {
                    "nameValeu": "80c0c0",
                    "countfiltr": 752,
                    "ID": 66346,
                    "UF_HEX": "#80c0c0"
                },
                {
                    "nameValeu": "80e0e0",
                    "countfiltr": 89,
                    "ID": 66513,
                    "UF_HEX": "#80e0e0"
                },
                {
                    "nameValeu": "80a0e0",
                    "countfiltr": 99,
                    "ID": 66515,
                    "UF_HEX": "#80a0e0"
                },
                {
                    "nameValeu": "2080a0",
                    "countfiltr": 207,
                    "ID": 66516,
                    "UF_HEX": "#2080a0"
                },
                {
                    "nameValeu": "a0a0e0",
                    "countfiltr": 77,
                    "ID": 66517,
                    "UF_HEX": "#a0a0e0"
                },
                {
                    "nameValeu": "a0c0e0",
                    "countfiltr": 702,
                    "ID": 66340,
                    "UF_HEX": "#a0c0e0"
                },
                {
                    "nameValeu": "e04020",
                    "countfiltr": 156,
                    "ID": 66616,
                    "UF_HEX": "#e04020"
                },
                {
                    "nameValeu": "a00020",
                    "countfiltr": 277,
                    "ID": 66520,
                    "UF_HEX": "#a00020"
                },
                {
                    "nameValeu": "e0a040",
                    "countfiltr": 637,
                    "ID": 66449,
                    "UF_HEX": "#e0a040"
                },
                {
                    "nameValeu": "e02020",
                    "countfiltr": 155,
                    "ID": 66545,
                    "UF_HEX": "#e02020"
                },
                {
                    "nameValeu": "c00020",
                    "countfiltr": 168,
                    "ID": 66546,
                    "UF_HEX": "#c00020"
                },
                {
                    "nameValeu": "c0a0e0",
                    "countfiltr": 63,
                    "ID": 66518,
                    "UF_HEX": "#c0a0e0"
                },
                {
                    "nameValeu": "8060c0",
                    "countfiltr": 7,
                    "ID": 66519,
                    "UF_HEX": "#8060c0"
                },
                {
                    "nameValeu": "8060a0",
                    "countfiltr": 176,
                    "ID": 66481,
                    "UF_HEX": "#8060a0"
                },
                {
                    "nameValeu": "e04040",
                    "countfiltr": 276,
                    "ID": 66485,
                    "UF_HEX": "#e04040"
                },
                {
                    "nameValeu": "a080c0",
                    "countfiltr": 108,
                    "ID": 66521,
                    "UF_HEX": "#a080c0"
                },
                {
                    "nameValeu": "e04060",
                    "countfiltr": 161,
                    "ID": 66489,
                    "UF_HEX": "#e04060"
                },
                {
                    "nameValeu": "608040",
                    "countfiltr": 591,
                    "ID": 66334,
                    "UF_HEX": "#608040"
                },
                {
                    "nameValeu": "6080a0",
                    "countfiltr": 2219,
                    "ID": 66463,
                    "UF_HEX": "#6080a0"
                },
                {
                    "nameValeu": "e0c060",
                    "countfiltr": 1068,
                    "ID": 66453,
                    "UF_HEX": "#e0c060"
                },
                {
                    "nameValeu": "800020",
                    "countfiltr": 436,
                    "ID": 66508,
                    "UF_HEX": "#800020"
                },
                {
                    "nameValeu": "60a0a0",
                    "countfiltr": 1074,
                    "ID": 66475,
                    "UF_HEX": "#60a0a0"
                },
                {
                    "nameValeu": "60a0c0",
                    "countfiltr": 491,
                    "ID": 66477,
                    "UF_HEX": "#60a0c0"
                },
                {
                    "nameValeu": "408080",
                    "countfiltr": 1028,
                    "ID": 66479,
                    "UF_HEX": "#408080"
                },
                {
                    "nameValeu": "80c0a0",
                    "countfiltr": 323,
                    "ID": 66637,
                    "UF_HEX": "#80c0a0"
                },
                {
                    "nameValeu": "ff8040",
                    "countfiltr": 71,
                    "ID": 66498,
                    "UF_HEX": "#ff8040"
                },
                {
                    "nameValeu": "e0c020",
                    "countfiltr": 116,
                    "ID": 66528,
                    "UF_HEX": "#e0c020"
                },
                {
                    "nameValeu": "808020",
                    "countfiltr": 448,
                    "ID": 66366,
                    "UF_HEX": "#808020"
                },
                {
                    "nameValeu": "e0c040",
                    "countfiltr": 356,
                    "ID": 66459,
                    "UF_HEX": "#e0c040"
                },
                {
                    "nameValeu": "c0c040",
                    "countfiltr": 267,
                    "ID": 66382,
                    "UF_HEX": "#c0c040"
                },
                {
                    "nameValeu": "4080a0",
                    "countfiltr": 664,
                    "ID": 66562,
                    "UF_HEX": "#4080a0"
                },
                {
                    "nameValeu": "4080c0",
                    "countfiltr": 118,
                    "ID": 66538,
                    "UF_HEX": "#4080c0"
                },
                {
                    "nameValeu": "206060",
                    "countfiltr": 760,
                    "ID": 66424,
                    "UF_HEX": "#206060"
                },
                {
                    "nameValeu": "ffc0a0",
                    "countfiltr": 350,
                    "ID": 66523,
                    "UF_HEX": "#ffc0a0"
                },
                {
                    "nameValeu": "ffc060",
                    "countfiltr": 201,
                    "ID": 66505,
                    "UF_HEX": "#ffc060"
                },
                {
                    "nameValeu": "e0ffe0",
                    "countfiltr": 2480,
                    "ID": 66526,
                    "UF_HEX": "#e0ffe0"
                },
                {
                    "nameValeu": "c0ffe0",
                    "countfiltr": 29,
                    "ID": 66527,
                    "UF_HEX": "#c0ffe0"
                },
                {
                    "nameValeu": "e0e080",
                    "countfiltr": 515,
                    "ID": 66391,
                    "UF_HEX": "#e0e080"
                },
                {
                    "nameValeu": "604000",
                    "countfiltr": 349,
                    "ID": 66445,
                    "UF_HEX": "#604000"
                },
                {
                    "nameValeu": "600020",
                    "countfiltr": 579,
                    "ID": 66509,
                    "UF_HEX": "#600020"
                },
                {
                    "nameValeu": "c06080",
                    "countfiltr": 558,
                    "ID": 66416,
                    "UF_HEX": "#c06080"
                },
                {
                    "nameValeu": "e02040",
                    "countfiltr": 149,
                    "ID": 66529,
                    "UF_HEX": "#e02040"
                },
                {
                    "nameValeu": "e06080",
                    "countfiltr": 171,
                    "ID": 66486,
                    "UF_HEX": "#e06080"
                },
                {
                    "nameValeu": "ff2040",
                    "countfiltr": 19,
                    "ID": 66530,
                    "UF_HEX": "#ff2040"
                },
                {
                    "nameValeu": "e080a0",
                    "countfiltr": 302,
                    "ID": 66418,
                    "UF_HEX": "#e080a0"
                },
                {
                    "nameValeu": "204080",
                    "countfiltr": 415,
                    "ID": 66462,
                    "UF_HEX": "#204080"
                },
                {
                    "nameValeu": "004080",
                    "countfiltr": 77,
                    "ID": 66531,
                    "UF_HEX": "#004080"
                },
                {
                    "nameValeu": "4080e0",
                    "countfiltr": 77,
                    "ID": 66660,
                    "UF_HEX": "#4080e0"
                },
                {
                    "nameValeu": "2040a0",
                    "countfiltr": 49,
                    "ID": 66532,
                    "UF_HEX": "#2040a0"
                },
                {
                    "nameValeu": "002060",
                    "countfiltr": 149,
                    "ID": 66422,
                    "UF_HEX": "#002060"
                },
                {
                    "nameValeu": "2060e0",
                    "countfiltr": 149,
                    "ID": 66690,
                    "UF_HEX": "#2060e0"
                },
                {
                    "nameValeu": "002080",
                    "countfiltr": 29,
                    "ID": 66533,
                    "UF_HEX": "#002080"
                },
                {
                    "nameValeu": "2080e0",
                    "countfiltr": 29,
                    "ID": 66691,
                    "UF_HEX": "#2080e0"
                },
                {
                    "nameValeu": "2060a0",
                    "countfiltr": 145,
                    "ID": 66534,
                    "UF_HEX": "#2060a0"
                },
                {
                    "nameValeu": "4060a0",
                    "countfiltr": 385,
                    "ID": 66468,
                    "UF_HEX": "#4060a0"
                },
                {
                    "nameValeu": "202080",
                    "countfiltr": 59,
                    "ID": 66535,
                    "UF_HEX": "#202080"
                },
                {
                    "nameValeu": "2060c0",
                    "countfiltr": 17,
                    "ID": 66536,
                    "UF_HEX": "#2060c0"
                },
                {
                    "nameValeu": "4060c0",
                    "countfiltr": 31,
                    "ID": 66537,
                    "UF_HEX": "#4060c0"
                },
                {
                    "nameValeu": "004060",
                    "countfiltr": 225,
                    "ID": 66420,
                    "UF_HEX": "#004060"
                },
                {
                    "nameValeu": "4060e0",
                    "countfiltr": 225,
                    "ID": 66792,
                    "UF_HEX": "#4060e0"
                },
                {
                    "nameValeu": "0040a0",
                    "countfiltr": 12,
                    "ID": 66539,
                    "UF_HEX": "#0040a0"
                },
                {
                    "nameValeu": "006080",
                    "countfiltr": 16,
                    "ID": 66743,
                    "UF_HEX": "#006080"
                },
                {
                    "nameValeu": "6080e0",
                    "countfiltr": 16,
                    "ID": 66540,
                    "UF_HEX": "#6080e0"
                },
                {
                    "nameValeu": "6060a0",
                    "countfiltr": 387,
                    "ID": 66470,
                    "UF_HEX": "#6060a0"
                },
                {
                    "nameValeu": "404080",
                    "countfiltr": 569,
                    "ID": 66466,
                    "UF_HEX": "#404080"
                },
                {
                    "nameValeu": "8080c0",
                    "countfiltr": 198,
                    "ID": 66510,
                    "UF_HEX": "#8080c0"
                },
                {
                    "nameValeu": "80c080",
                    "countfiltr": 58,
                    "ID": 66542,
                    "UF_HEX": "#80c080"
                },
                {
                    "nameValeu": "60a060",
                    "countfiltr": 95,
                    "ID": 66543,
                    "UF_HEX": "#60a060"
                },
                {
                    "nameValeu": "a0e0a0",
                    "countfiltr": 27,
                    "ID": 66544,
                    "UF_HEX": "#a0e0a0"
                },
                {
                    "nameValeu": "406020",
                    "countfiltr": 302,
                    "ID": 66335,
                    "UF_HEX": "#406020"
                },
                {
                    "nameValeu": "c0e0a0",
                    "countfiltr": 365,
                    "ID": 66390,
                    "UF_HEX": "#c0e0a0"
                },
                {
                    "nameValeu": "c0e080",
                    "countfiltr": 139,
                    "ID": 66392,
                    "UF_HEX": "#c0e080"
                },
                {
                    "nameValeu": "c0e060",
                    "countfiltr": 62,
                    "ID": 66547,
                    "UF_HEX": "#c0e060"
                },
                {
                    "nameValeu": "a0c040",
                    "countfiltr": 92,
                    "ID": 66381,
                    "UF_HEX": "#a0c040"
                },
                {
                    "nameValeu": "80a040",
                    "countfiltr": 269,
                    "ID": 66336,
                    "UF_HEX": "#80a040"
                },
                {
                    "nameValeu": "208080",
                    "countfiltr": 235,
                    "ID": 66563,
                    "UF_HEX": "#208080"
                },
                {
                    "nameValeu": "40a0a0",
                    "countfiltr": 282,
                    "ID": 66564,
                    "UF_HEX": "#40a0a0"
                },
                {
                    "nameValeu": "60a080",
                    "countfiltr": 388,
                    "ID": 66553,
                    "UF_HEX": "#60a080"
                },
                {
                    "nameValeu": "408060",
                    "countfiltr": 367,
                    "ID": 66552,
                    "UF_HEX": "#408060"
                },
                {
                    "nameValeu": "80a020",
                    "countfiltr": 75,
                    "ID": 66372,
                    "UF_HEX": "#80a020"
                },
                {
                    "nameValeu": "a0a020",
                    "countfiltr": 201,
                    "ID": 66567,
                    "UF_HEX": "#a0a020"
                },
                {
                    "nameValeu": "608020",
                    "countfiltr": 152,
                    "ID": 66339,
                    "UF_HEX": "#608020"
                },
                {
                    "nameValeu": "404000",
                    "countfiltr": 245,
                    "ID": 66369,
                    "UF_HEX": "#404000"
                },
                {
                    "nameValeu": "606000",
                    "countfiltr": 101,
                    "ID": 66583,
                    "UF_HEX": "#606000"
                },
                {
                    "nameValeu": "204000",
                    "countfiltr": 53,
                    "ID": 66568,
                    "UF_HEX": "#204000"
                },
                {
                    "nameValeu": "e0e060",
                    "countfiltr": 179,
                    "ID": 66473,
                    "UF_HEX": "#e0e060"
                },
                {
                    "nameValeu": "ffe060",
                    "countfiltr": 155,
                    "ID": 66555,
                    "UF_HEX": "#ffe060"
                },
                {
                    "nameValeu": "c0e0ff",
                    "countfiltr": 118,
                    "ID": 66576,
                    "UF_HEX": "#c0e0ff"
                },
                {
                    "nameValeu": "c0c0ff",
                    "countfiltr": 14,
                    "ID": 66577,
                    "UF_HEX": "#c0c0ff"
                },
                {
                    "nameValeu": "c0c020",
                    "countfiltr": 82,
                    "ID": 66593,
                    "UF_HEX": "#c0c020"
                },
                {
                    "nameValeu": "c060a0",
                    "countfiltr": 136,
                    "ID": 66556,
                    "UF_HEX": "#c060a0"
                },
                {
                    "nameValeu": "c04080",
                    "countfiltr": 146,
                    "ID": 66558,
                    "UF_HEX": "#c04080"
                },
                {
                    "nameValeu": "a02060",
                    "countfiltr": 143,
                    "ID": 66581,
                    "UF_HEX": "#a02060"
                },
                {
                    "nameValeu": "e080c0",
                    "countfiltr": 77,
                    "ID": 66559,
                    "UF_HEX": "#e080c0"
                },
                {
                    "nameValeu": "c02060",
                    "countfiltr": 109,
                    "ID": 66594,
                    "UF_HEX": "#c02060"
                },
                {
                    "nameValeu": "e0a0c0",
                    "countfiltr": 588,
                    "ID": 66578,
                    "UF_HEX": "#e0a0c0"
                },
                {
                    "nameValeu": "e060a0",
                    "countfiltr": 85,
                    "ID": 66557,
                    "UF_HEX": "#e060a0"
                },
                {
                    "nameValeu": "c02080",
                    "countfiltr": 25,
                    "ID": 66595,
                    "UF_HEX": "#c02080"
                },
                {
                    "nameValeu": "402060",
                    "countfiltr": 192,
                    "ID": 66597,
                    "UF_HEX": "#402060"
                },
                {
                    "nameValeu": "ffc080",
                    "countfiltr": 314,
                    "ID": 66565,
                    "UF_HEX": "#ffc080"
                },
                {
                    "nameValeu": "804080",
                    "countfiltr": 217,
                    "ID": 66409,
                    "UF_HEX": "#804080"
                },
                {
                    "nameValeu": "c080c0",
                    "countfiltr": 105,
                    "ID": 66574,
                    "UF_HEX": "#c080c0"
                },
                {
                    "nameValeu": "ffe080",
                    "countfiltr": 321,
                    "ID": 66474,
                    "UF_HEX": "#ffe080"
                },
                {
                    "nameValeu": "002040",
                    "countfiltr": 505,
                    "ID": 66421,
                    "UF_HEX": "#002040"
                },
                {
                    "nameValeu": "2040e0",
                    "countfiltr": 505,
                    "ID": 66826,
                    "UF_HEX": "#2040e0"
                },
                {
                    "nameValeu": "004040",
                    "countfiltr": 285,
                    "ID": 66423,
                    "UF_HEX": "#004040"
                },
                {
                    "nameValeu": "ffc0e0",
                    "countfiltr": 142,
                    "ID": 66621,
                    "UF_HEX": "#ffc0e0"
                },
                {
                    "nameValeu": "ffc0c0",
                    "countfiltr": 387,
                    "ID": 66524,
                    "UF_HEX": "#ffc0c0"
                },
                {
                    "nameValeu": "ffa0c0",
                    "countfiltr": 81,
                    "ID": 66573,
                    "UF_HEX": "#ffa0c0"
                },
                {
                    "nameValeu": "ff80c0",
                    "countfiltr": 22,
                    "ID": 66648,
                    "UF_HEX": "#ff80c0"
                },
                {
                    "nameValeu": "ffa0e0",
                    "countfiltr": 25,
                    "ID": 66620,
                    "UF_HEX": "#ffa0e0"
                },
                {
                    "nameValeu": "604080",
                    "countfiltr": 226,
                    "ID": 66480,
                    "UF_HEX": "#604080"
                },
                {
                    "nameValeu": "e0c0ff",
                    "countfiltr": 12,
                    "ID": 66714,
                    "UF_HEX": "#e0c0ff"
                },
                {
                    "nameValeu": "e0a0e0",
                    "countfiltr": 45,
                    "ID": 66619,
                    "UF_HEX": "#e0a0e0"
                },
                {
                    "nameValeu": "ff80a0",
                    "countfiltr": 43,
                    "ID": 66570,
                    "UF_HEX": "#ff80a0"
                },
                {
                    "nameValeu": "ff60a0",
                    "countfiltr": 13,
                    "ID": 66650,
                    "UF_HEX": "#ff60a0"
                },
                {
                    "nameValeu": "6080c0",
                    "countfiltr": 231,
                    "ID": 66615,
                    "UF_HEX": "#6080c0"
                },
                {
                    "nameValeu": "802060",
                    "countfiltr": 169,
                    "ID": 66614,
                    "UF_HEX": "#802060"
                },
                {
                    "nameValeu": "80c020",
                    "countfiltr": 14,
                    "ID": 66599,
                    "UF_HEX": "#80c020"
                },
                {
                    "nameValeu": "60a020",
                    "countfiltr": 26,
                    "ID": 66600,
                    "UF_HEX": "#60a020"
                },
                {
                    "nameValeu": "a0c020",
                    "countfiltr": 34,
                    "ID": 66601,
                    "UF_HEX": "#a0c020"
                },
                {
                    "nameValeu": "e06000",
                    "countfiltr": 33,
                    "ID": 66602,
                    "UF_HEX": "#e06000"
                },
                {
                    "nameValeu": "408040",
                    "countfiltr": 78,
                    "ID": 66603,
                    "UF_HEX": "#408040"
                },
                {
                    "nameValeu": "20a0c0",
                    "countfiltr": 73,
                    "ID": 66604,
                    "UF_HEX": "#20a0c0"
                },
                {
                    "nameValeu": "ffc020",
                    "countfiltr": 60,
                    "ID": 66450,
                    "UF_HEX": "#ffc020"
                },
                {
                    "nameValeu": "e0a000",
                    "countfiltr": 69,
                    "ID": 66440,
                    "UF_HEX": "#e0a000"
                },
                {
                    "nameValeu": "806000",
                    "countfiltr": 203,
                    "ID": 66447,
                    "UF_HEX": "#806000"
                },
                {
                    "nameValeu": "ffffc0",
                    "countfiltr": 394,
                    "ID": 66548,
                    "UF_HEX": "#ffffc0"
                },
                {
                    "nameValeu": "ffffa0",
                    "countfiltr": 94,
                    "ID": 66588,
                    "UF_HEX": "#ffffa0"
                },
                {
                    "nameValeu": "ffff80",
                    "countfiltr": 49,
                    "ID": 66585,
                    "UF_HEX": "#ffff80"
                },
                {
                    "nameValeu": "008080",
                    "countfiltr": 6,
                    "ID": 66262,
                    "UF_HEX": "#008080"
                },
                {
                    "nameValeu": "8080e0",
                    "countfiltr": 6,
                    "ID": 66715,
                    "UF_HEX": "#8080e0"
                },
                {
                    "nameValeu": "ffa060",
                    "countfiltr": 103,
                    "ID": 66496,
                    "UF_HEX": "#ffa060"
                },
                {
                    "nameValeu": "ff6040",
                    "countfiltr": 50,
                    "ID": 66617,
                    "UF_HEX": "#ff6040"
                },
                {
                    "nameValeu": "ff4040",
                    "countfiltr": 47,
                    "ID": 66712,
                    "UF_HEX": "#ff4040"
                },
                {
                    "nameValeu": "ff4020",
                    "countfiltr": 13,
                    "ID": 66657,
                    "UF_HEX": "#ff4020"
                },
                {
                    "nameValeu": "ff6020",
                    "countfiltr": 33,
                    "ID": 66629,
                    "UF_HEX": "#ff6020"
                },
                {
                    "nameValeu": "ff8060",
                    "countfiltr": 69,
                    "ID": 66630,
                    "UF_HEX": "#ff8060"
                },
                {
                    "nameValeu": "ffa0a0",
                    "countfiltr": 125,
                    "ID": 66571,
                    "UF_HEX": "#ffa0a0"
                },
                {
                    "nameValeu": "a00000",
                    "countfiltr": 128,
                    "ID": 66686,
                    "UF_HEX": "#a00000"
                },
                {
                    "nameValeu": "c02000",
                    "countfiltr": 54,
                    "ID": 66704,
                    "UF_HEX": "#c02000"
                },
                {
                    "nameValeu": "e0e040",
                    "countfiltr": 71,
                    "ID": 66590,
                    "UF_HEX": "#e0e040"
                },
                {
                    "nameValeu": "c0e040",
                    "countfiltr": 33,
                    "ID": 66591,
                    "UF_HEX": "#c0e040"
                },
                {
                    "nameValeu": "ffa020",
                    "countfiltr": 36,
                    "ID": 66640,
                    "UF_HEX": "#ffa020"
                },
                {
                    "nameValeu": "ffc040",
                    "countfiltr": 108,
                    "ID": 66448,
                    "UF_HEX": "#ffc040"
                },
                {
                    "nameValeu": "ffc000",
                    "countfiltr": 27,
                    "ID": 66626,
                    "UF_HEX": "#ffc000"
                },
                {
                    "nameValeu": "ffa000",
                    "countfiltr": 19,
                    "ID": 66716,
                    "UF_HEX": "#ffa000"
                },
                {
                    "nameValeu": "ffe040",
                    "countfiltr": 68,
                    "ID": 66584,
                    "UF_HEX": "#ffe040"
                },
                {
                    "nameValeu": "ffa040",
                    "countfiltr": 80,
                    "ID": 66502,
                    "UF_HEX": "#ffa040"
                },
                {
                    "nameValeu": "ff8020",
                    "countfiltr": 39,
                    "ID": 66628,
                    "UF_HEX": "#ff8020"
                },
                {
                    "nameValeu": "ff6060",
                    "countfiltr": 63,
                    "ID": 66631,
                    "UF_HEX": "#ff6060"
                },
                {
                    "nameValeu": "ff4060",
                    "countfiltr": 27,
                    "ID": 66717,
                    "UF_HEX": "#ff4060"
                },
                {
                    "nameValeu": "ff6080",
                    "countfiltr": 31,
                    "ID": 66572,
                    "UF_HEX": "#ff6080"
                },
                {
                    "nameValeu": "a00040",
                    "countfiltr": 56,
                    "ID": 66632,
                    "UF_HEX": "#a00040"
                },
                {
                    "nameValeu": "e04080",
                    "countfiltr": 68,
                    "ID": 66633,
                    "UF_HEX": "#e04080"
                },
                {
                    "nameValeu": "800040",
                    "countfiltr": 61,
                    "ID": 66634,
                    "UF_HEX": "#800040"
                },
                {
                    "nameValeu": "402080",
                    "countfiltr": 14,
                    "ID": 66635,
                    "UF_HEX": "#402080"
                },
                {
                    "nameValeu": "60c0e0",
                    "countfiltr": 97,
                    "ID": 66636,
                    "UF_HEX": "#60c0e0"
                },
                {
                    "nameValeu": "40c0c0",
                    "countfiltr": 70,
                    "ID": 66608,
                    "UF_HEX": "#40c0c0"
                },
                {
                    "nameValeu": "40c0e0",
                    "countfiltr": 50,
                    "ID": 66605,
                    "UF_HEX": "#40c0e0"
                },
                {
                    "nameValeu": "40a0c0",
                    "countfiltr": 170,
                    "ID": 66607,
                    "UF_HEX": "#40a0c0"
                },
                {
                    "nameValeu": "60c0c0",
                    "countfiltr": 198,
                    "ID": 66579,
                    "UF_HEX": "#60c0c0"
                },
                {
                    "nameValeu": "80c0e0",
                    "countfiltr": 241,
                    "ID": 66598,
                    "UF_HEX": "#80c0e0"
                },
                {
                    "nameValeu": "a0e0c0",
                    "countfiltr": 155,
                    "ID": 66638,
                    "UF_HEX": "#a0e0c0"
                },
                {
                    "nameValeu": "206040",
                    "countfiltr": 284,
                    "ID": 66612,
                    "UF_HEX": "#206040"
                },
                {
                    "nameValeu": "a060e0",
                    "countfiltr": 2,
                    "ID": 66718,
                    "UF_HEX": "#a060e0"
                },
                {
                    "nameValeu": "008060",
                    "countfiltr": 1,
                    "ID": 66749,
                    "UF_HEX": "#008060"
                },
                {
                    "nameValeu": "8060e0",
                    "countfiltr": 1,
                    "ID": 66719,
                    "UF_HEX": "#8060e0"
                },
                {
                    "nameValeu": "a080e0",
                    "countfiltr": 4,
                    "ID": 66720,
                    "UF_HEX": "#a080e0"
                },
                {
                    "nameValeu": "8040c0",
                    "countfiltr": 2,
                    "ID": 66721,
                    "UF_HEX": "#8040c0"
                },
                {
                    "nameValeu": "6040a0",
                    "countfiltr": 14,
                    "ID": 66722,
                    "UF_HEX": "#6040a0"
                },
                {
                    "nameValeu": "6040c0",
                    "countfiltr": 2,
                    "ID": 66723,
                    "UF_HEX": "#6040c0"
                },
                {
                    "nameValeu": "4040a0",
                    "countfiltr": 47,
                    "ID": 66679,
                    "UF_HEX": "#4040a0"
                },
                {
                    "nameValeu": "000040",
                    "countfiltr": 85,
                    "ID": 66724,
                    "UF_HEX": "#000040"
                },
                {
                    "nameValeu": "c040a0",
                    "countfiltr": 26,
                    "ID": 66560,
                    "UF_HEX": "#c040a0"
                },
                {
                    "nameValeu": "a02080",
                    "countfiltr": 25,
                    "ID": 66639,
                    "UF_HEX": "#a02080"
                },
                {
                    "nameValeu": "a040a0",
                    "countfiltr": 23,
                    "ID": 66642,
                    "UF_HEX": "#a040a0"
                },
                {
                    "nameValeu": "8040a0",
                    "countfiltr": 30,
                    "ID": 66596,
                    "UF_HEX": "#8040a0"
                },
                {
                    "nameValeu": "c060c0",
                    "countfiltr": 11,
                    "ID": 66646,
                    "UF_HEX": "#c060c0"
                },
                {
                    "nameValeu": "a060c0",
                    "countfiltr": 20,
                    "ID": 66645,
                    "UF_HEX": "#a060c0"
                },
                {
                    "nameValeu": "ff2060",
                    "countfiltr": 5,
                    "ID": 66725,
                    "UF_HEX": "#ff2060"
                },
                {
                    "nameValeu": "e00020",
                    "countfiltr": 62,
                    "ID": 66665,
                    "UF_HEX": "#e00020"
                },
                {
                    "nameValeu": "ff4080",
                    "countfiltr": 12,
                    "ID": 66726,
                    "UF_HEX": "#ff4080"
                },
                {
                    "nameValeu": "e02060",
                    "countfiltr": 49,
                    "ID": 66618,
                    "UF_HEX": "#e02060"
                },
                {
                    "nameValeu": "e00040",
                    "countfiltr": 26,
                    "ID": 66694,
                    "UF_HEX": "#e00040"
                },
                {
                    "nameValeu": "c00040",
                    "countfiltr": 42,
                    "ID": 66685,
                    "UF_HEX": "#c00040"
                },
                {
                    "nameValeu": "40c0a0",
                    "countfiltr": 13,
                    "ID": 66674,
                    "UF_HEX": "#40c0a0"
                },
                {
                    "nameValeu": "60c0a0",
                    "countfiltr": 57,
                    "ID": 66672,
                    "UF_HEX": "#60c0a0"
                },
                {
                    "nameValeu": "40a080",
                    "countfiltr": 85,
                    "ID": 66610,
                    "UF_HEX": "#40a080"
                },
                {
                    "nameValeu": "a0e0ff",
                    "countfiltr": 47,
                    "ID": 66622,
                    "UF_HEX": "#a0e0ff"
                },
                {
                    "nameValeu": "400040",
                    "countfiltr": 28,
                    "ID": 66641,
                    "UF_HEX": "#400040"
                },
                {
                    "nameValeu": "e060c0",
                    "countfiltr": 16,
                    "ID": 66561,
                    "UF_HEX": "#e060c0"
                },
                {
                    "nameValeu": "e040a0",
                    "countfiltr": 51,
                    "ID": 66643,
                    "UF_HEX": "#e040a0"
                },
                {
                    "nameValeu": "e040c0",
                    "countfiltr": 5,
                    "ID": 66644,
                    "UF_HEX": "#e040c0"
                },
                {
                    "nameValeu": "ff8000",
                    "countfiltr": 9,
                    "ID": 66729,
                    "UF_HEX": "#ff8000"
                },
                {
                    "nameValeu": "ff6000",
                    "countfiltr": 9,
                    "ID": 66730,
                    "UF_HEX": "#ff6000"
                },
                {
                    "nameValeu": "ff60c0",
                    "countfiltr": 7,
                    "ID": 66649,
                    "UF_HEX": "#ff60c0"
                },
                {
                    "nameValeu": "ff80e0",
                    "countfiltr": 3,
                    "ID": 66651,
                    "UF_HEX": "#ff80e0"
                },
                {
                    "nameValeu": "20c0c0",
                    "countfiltr": 24,
                    "ID": 66611,
                    "UF_HEX": "#20c0c0"
                },
                {
                    "nameValeu": "60e0e0",
                    "countfiltr": 39,
                    "ID": 66652,
                    "UF_HEX": "#60e0e0"
                },
                {
                    "nameValeu": "60e0c0",
                    "countfiltr": 17,
                    "ID": 66653,
                    "UF_HEX": "#60e0c0"
                },
                {
                    "nameValeu": "00a0a0",
                    "countfiltr": 35,
                    "ID": 66654,
                    "UF_HEX": "#00a0a0"
                },
                {
                    "nameValeu": "2080c0",
                    "countfiltr": 58,
                    "ID": 66647,
                    "UF_HEX": "#2080c0"
                },
                {
                    "nameValeu": "40e0e0",
                    "countfiltr": 21,
                    "ID": 66609,
                    "UF_HEX": "#40e0e0"
                },
                {
                    "nameValeu": "60a0e0",
                    "countfiltr": 57,
                    "ID": 66659,
                    "UF_HEX": "#60a0e0"
                },
                {
                    "nameValeu": "c0ffff",
                    "countfiltr": 25,
                    "ID": 66623,
                    "UF_HEX": "#c0ffff"
                },
                {
                    "nameValeu": "ffe020",
                    "countfiltr": 33,
                    "ID": 66586,
                    "UF_HEX": "#ffe020"
                },
                {
                    "nameValeu": "c0e020",
                    "countfiltr": 8,
                    "ID": 66661,
                    "UF_HEX": "#c0e020"
                },
                {
                    "nameValeu": "e0e020",
                    "countfiltr": 30,
                    "ID": 66662,
                    "UF_HEX": "#e0e020"
                },
                {
                    "nameValeu": "60a040",
                    "countfiltr": 49,
                    "ID": 66343,
                    "UF_HEX": "#60a040"
                },
                {
                    "nameValeu": "408020",
                    "countfiltr": 21,
                    "ID": 66337,
                    "UF_HEX": "#408020"
                },
                {
                    "nameValeu": "608000",
                    "countfiltr": 18,
                    "ID": 66732,
                    "UF_HEX": "#608000"
                },
                {
                    "nameValeu": "80a000",
                    "countfiltr": 9,
                    "ID": 66733,
                    "UF_HEX": "#80a000"
                },
                {
                    "nameValeu": "a0a000",
                    "countfiltr": 35,
                    "ID": 66734,
                    "UF_HEX": "#a0a000"
                },
                {
                    "nameValeu": "406000",
                    "countfiltr": 35,
                    "ID": 66582,
                    "UF_HEX": "#406000"
                },
                {
                    "nameValeu": "ffe000",
                    "countfiltr": 13,
                    "ID": 66627,
                    "UF_HEX": "#ffe000"
                },
                {
                    "nameValeu": "ffff20",
                    "countfiltr": 8,
                    "ID": 66678,
                    "UF_HEX": "#ffff20"
                },
                {
                    "nameValeu": "ffff00",
                    "countfiltr": 4,
                    "ID": 66735,
                    "UF_HEX": "#ffff00"
                },
                {
                    "nameValeu": "600040",
                    "countfiltr": 49,
                    "ID": 66666,
                    "UF_HEX": "#600040"
                },
                {
                    "nameValeu": "2040c0",
                    "countfiltr": 8,
                    "ID": 66668,
                    "UF_HEX": "#2040c0"
                },
                {
                    "nameValeu": "0020a0",
                    "countfiltr": 5,
                    "ID": 66669,
                    "UF_HEX": "#0020a0"
                },
                {
                    "nameValeu": "0040c0",
                    "countfiltr": 2,
                    "ID": 66670,
                    "UF_HEX": "#0040c0"
                },
                {
                    "nameValeu": "2020a0",
                    "countfiltr": 5,
                    "ID": 66671,
                    "UF_HEX": "#2020a0"
                },
                {
                    "nameValeu": "60c080",
                    "countfiltr": 18,
                    "ID": 66675,
                    "UF_HEX": "#60c080"
                },
                {
                    "nameValeu": "206020",
                    "countfiltr": 28,
                    "ID": 66677,
                    "UF_HEX": "#206020"
                },
                {
                    "nameValeu": "4040c0",
                    "countfiltr": 2,
                    "ID": 66680,
                    "UF_HEX": "#4040c0"
                },
                {
                    "nameValeu": "000060",
                    "countfiltr": 18,
                    "ID": 66681,
                    "UF_HEX": "#000060"
                },
                {
                    "nameValeu": "6060c0",
                    "countfiltr": 21,
                    "ID": 66682,
                    "UF_HEX": "#6060c0"
                },
                {
                    "nameValeu": "ffff40",
                    "countfiltr": 12,
                    "ID": 66589,
                    "UF_HEX": "#ffff40"
                },
                {
                    "nameValeu": "200040",
                    "countfiltr": 40,
                    "ID": 66667,
                    "UF_HEX": "#200040"
                },
                {
                    "nameValeu": "a02000",
                    "countfiltr": 136,
                    "ID": 66550,
                    "UF_HEX": "#a02000"
                },
                {
                    "nameValeu": "c00000",
                    "countfiltr": 59,
                    "ID": 66687,
                    "UF_HEX": "#c00000"
                },
                {
                    "nameValeu": "0060c0",
                    "countfiltr": 6,
                    "ID": 66689,
                    "UF_HEX": "#0060c0"
                },
                {
                    "nameValeu": "002060",
                    "countfiltr": 4,
                    "ID": 66422,
                    "UF_HEX": "#002060"
                },
                {
                    "nameValeu": "2060e0",
                    "countfiltr": 4,
                    "ID": 66690,
                    "UF_HEX": "#2060e0"
                },
                {
                    "nameValeu": "002080",
                    "countfiltr": 6,
                    "ID": 66533,
                    "UF_HEX": "#002080"
                },
                {
                    "nameValeu": "2080e0",
                    "countfiltr": 6,
                    "ID": 66691,
                    "UF_HEX": "#2080e0"
                },
                {
                    "nameValeu": "e00060",
                    "countfiltr": 8,
                    "ID": 66695,
                    "UF_HEX": "#e00060"
                },
                {
                    "nameValeu": "802080",
                    "countfiltr": 28,
                    "ID": 66658,
                    "UF_HEX": "#802080"
                },
                {
                    "nameValeu": "602080",
                    "countfiltr": 29,
                    "ID": 66696,
                    "UF_HEX": "#602080"
                },
                {
                    "nameValeu": "e0ffc0",
                    "countfiltr": 77,
                    "ID": 66549,
                    "UF_HEX": "#e0ffc0"
                },
                {
                    "nameValeu": "e04000",
                    "countfiltr": 26,
                    "ID": 66664,
                    "UF_HEX": "#e04000"
                },
                {
                    "nameValeu": "a0c0ff",
                    "countfiltr": 9,
                    "ID": 66625,
                    "UF_HEX": "#a0c0ff"
                },
                {
                    "nameValeu": "c0ffc0",
                    "countfiltr": 10,
                    "ID": 66738,
                    "UF_HEX": "#c0ffc0"
                },
                {
                    "nameValeu": "c0ffa0",
                    "countfiltr": 10,
                    "ID": 66739,
                    "UF_HEX": "#c0ffa0"
                },
                {
                    "nameValeu": "e0ffa0",
                    "countfiltr": 24,
                    "ID": 66676,
                    "UF_HEX": "#e0ffa0"
                },
                {
                    "nameValeu": "e0ff80",
                    "countfiltr": 16,
                    "ID": 66592,
                    "UF_HEX": "#e0ff80"
                },
                {
                    "nameValeu": "ffff60",
                    "countfiltr": 27,
                    "ID": 66587,
                    "UF_HEX": "#ffff60"
                },
                {
                    "nameValeu": "40a0e0",
                    "countfiltr": 36,
                    "ID": 66728,
                    "UF_HEX": "#40a0e0"
                },
                {
                    "nameValeu": "004080",
                    "countfiltr": 12,
                    "ID": 66531,
                    "UF_HEX": "#004080"
                },
                {
                    "nameValeu": "4080e0",
                    "countfiltr": 12,
                    "ID": 66660,
                    "UF_HEX": "#4080e0"
                },
                {
                    "nameValeu": "80c060",
                    "countfiltr": 38,
                    "ID": 66655,
                    "UF_HEX": "#80c060"
                },
                {
                    "nameValeu": "e02080",
                    "countfiltr": 24,
                    "ID": 66697,
                    "UF_HEX": "#e02080"
                },
                {
                    "nameValeu": "e0ff60",
                    "countfiltr": 10,
                    "ID": 66731,
                    "UF_HEX": "#e0ff60"
                },
                {
                    "nameValeu": "20c0e0",
                    "countfiltr": 30,
                    "ID": 66606,
                    "UF_HEX": "#20c0e0"
                },
                {
                    "nameValeu": "20a0e0",
                    "countfiltr": 22,
                    "ID": 66740,
                    "UF_HEX": "#20a0e0"
                },
                {
                    "nameValeu": "a00060",
                    "countfiltr": 11,
                    "ID": 66741,
                    "UF_HEX": "#a00060"
                },
                {
                    "nameValeu": "c00060",
                    "countfiltr": 10,
                    "ID": 66742,
                    "UF_HEX": "#c00060"
                },
                {
                    "nameValeu": "ff4000",
                    "countfiltr": 4,
                    "ID": 66663,
                    "UF_HEX": "#ff4000"
                },
                {
                    "nameValeu": "006080",
                    "countfiltr": 108,
                    "ID": 66743,
                    "UF_HEX": "#006080"
                },
                {
                    "nameValeu": "6080e0",
                    "countfiltr": 108,
                    "ID": 66540,
                    "UF_HEX": "#6080e0"
                },
                {
                    "nameValeu": "0080a0",
                    "countfiltr": 62,
                    "ID": 66744,
                    "UF_HEX": "#0080a0"
                },
                {
                    "nameValeu": "006060",
                    "countfiltr": 117,
                    "ID": 66688,
                    "UF_HEX": "#006060"
                },
                {
                    "nameValeu": "6060e0",
                    "countfiltr": 117,
                    "ID": 66793,
                    "UF_HEX": "#6060e0"
                },
                {
                    "nameValeu": "a08000",
                    "countfiltr": 113,
                    "ID": 66446,
                    "UF_HEX": "#a08000"
                },
                {
                    "nameValeu": "e02000",
                    "countfiltr": 10,
                    "ID": 66711,
                    "UF_HEX": "#e02000"
                },
                {
                    "nameValeu": "e08000",
                    "countfiltr": 43,
                    "ID": 66442,
                    "UF_HEX": "#e08000"
                },
                {
                    "nameValeu": "40a040",
                    "countfiltr": 8,
                    "ID": 66745,
                    "UF_HEX": "#40a040"
                },
                {
                    "nameValeu": "208060",
                    "countfiltr": 77,
                    "ID": 66684,
                    "UF_HEX": "#208060"
                },
                {
                    "nameValeu": "c0a000",
                    "countfiltr": 80,
                    "ID": 66746,
                    "UF_HEX": "#c0a000"
                },
                {
                    "nameValeu": "e0c000",
                    "countfiltr": 44,
                    "ID": 66692,
                    "UF_HEX": "#e0c000"
                },
                {
                    "nameValeu": "408000",
                    "countfiltr": 5,
                    "ID": 66747,
                    "UF_HEX": "#408000"
                },
                {
                    "nameValeu": "0060a0",
                    "countfiltr": 46,
                    "ID": 66713,
                    "UF_HEX": "#0060a0"
                },
                {
                    "nameValeu": "0080c0",
                    "countfiltr": 27,
                    "ID": 66748,
                    "UF_HEX": "#0080c0"
                },
                {
                    "nameValeu": "80c040",
                    "countfiltr": 27,
                    "ID": 66737,
                    "UF_HEX": "#80c040"
                },
                {
                    "nameValeu": "008060",
                    "countfiltr": 20,
                    "ID": 66749,
                    "UF_HEX": "#008060"
                },
                {
                    "nameValeu": "8060e0",
                    "countfiltr": 20,
                    "ID": 66719,
                    "UF_HEX": "#8060e0"
                },
                {
                    "nameValeu": "00a060",
                    "countfiltr": 4,
                    "ID": 66750,
                    "UF_HEX": "#00a060"
                },
                {
                    "nameValeu": "20a060",
                    "countfiltr": 9,
                    "ID": 66751,
                    "UF_HEX": "#20a060"
                },
                {
                    "nameValeu": "008040",
                    "countfiltr": 5,
                    "ID": 66752,
                    "UF_HEX": "#008040"
                },
                {
                    "nameValeu": "8040e0",
                    "countfiltr": 5,
                    "ID": 66863,
                    "UF_HEX": "#8040e0"
                },
                {
                    "nameValeu": "208040",
                    "countfiltr": 24,
                    "ID": 66753,
                    "UF_HEX": "#208040"
                },
                {
                    "nameValeu": "00a040",
                    "countfiltr": 2,
                    "ID": 66754,
                    "UF_HEX": "#00a040"
                },
                {
                    "nameValeu": "20a080",
                    "countfiltr": 28,
                    "ID": 66673,
                    "UF_HEX": "#20a080"
                },
                {
                    "nameValeu": "20a040",
                    "countfiltr": 4,
                    "ID": 66755,
                    "UF_HEX": "#20a040"
                },
                {
                    "nameValeu": "00a0c0",
                    "countfiltr": 27,
                    "ID": 66756,
                    "UF_HEX": "#00a0c0"
                },
                {
                    "nameValeu": "c0c000",
                    "countfiltr": 28,
                    "ID": 66693,
                    "UF_HEX": "#c0c000"
                },
                {
                    "nameValeu": "006020",
                    "countfiltr": 7,
                    "ID": 66757,
                    "UF_HEX": "#006020"
                },
                {
                    "nameValeu": "60a000",
                    "countfiltr": 1,
                    "ID": 66758,
                    "UF_HEX": "#60a000"
                },
                {
                    "nameValeu": "80c000",
                    "countfiltr": 1,
                    "ID": 66759,
                    "UF_HEX": "#80c000"
                },
                {
                    "nameValeu": "00c0e0",
                    "countfiltr": 9,
                    "ID": 66763,
                    "UF_HEX": "#00c0e0"
                },
                {
                    "nameValeu": "80e0c0",
                    "countfiltr": 21,
                    "ID": 66683,
                    "UF_HEX": "#80e0c0"
                },
                {
                    "nameValeu": "e00000",
                    "countfiltr": 20,
                    "ID": 66708,
                    "UF_HEX": "#e00000"
                },
                {
                    "nameValeu": "400060",
                    "countfiltr": 3,
                    "ID": 66771,
                    "UF_HEX": "#400060"
                },
                {
                    "nameValeu": "60e0ff",
                    "countfiltr": 10,
                    "ID": 66727,
                    "UF_HEX": "#60e0ff"
                },
                {
                    "nameValeu": "80e0ff",
                    "countfiltr": 16,
                    "ID": 66624,
                    "UF_HEX": "#80e0ff"
                },
                {
                    "nameValeu": "40e0ff",
                    "countfiltr": 6,
                    "ID": 66772,
                    "UF_HEX": "#40e0ff"
                },
                {
                    "nameValeu": "004020",
                    "countfiltr": 92,
                    "ID": 66613,
                    "UF_HEX": "#004020"
                },
                {
                    "nameValeu": "006040",
                    "countfiltr": 43,
                    "ID": 66773,
                    "UF_HEX": "#006040"
                },
                {
                    "nameValeu": "00c0c0",
                    "countfiltr": 13,
                    "ID": 66764,
                    "UF_HEX": "#00c0c0"
                },
                {
                    "nameValeu": "00a0e0",
                    "countfiltr": 12,
                    "ID": 66767,
                    "UF_HEX": "#00a0e0"
                },
                {
                    "nameValeu": "20c0ff",
                    "countfiltr": 2,
                    "ID": 66774,
                    "UF_HEX": "#20c0ff"
                },
                {
                    "nameValeu": "60c040",
                    "countfiltr": 7,
                    "ID": 66775,
                    "UF_HEX": "#60c040"
                },
                {
                    "nameValeu": "60e080",
                    "countfiltr": 2,
                    "ID": 66776,
                    "UF_HEX": "#60e080"
                },
                {
                    "nameValeu": "20c060",
                    "countfiltr": 1,
                    "ID": 66777,
                    "UF_HEX": "#20c060"
                },
                {
                    "nameValeu": "40c080",
                    "countfiltr": 3,
                    "ID": 66778,
                    "UF_HEX": "#40c080"
                },
                {
                    "nameValeu": "40c060",
                    "countfiltr": 1,
                    "ID": 66779,
                    "UF_HEX": "#40c060"
                },
                {
                    "nameValeu": "80e0a0",
                    "countfiltr": 5,
                    "ID": 66780,
                    "UF_HEX": "#80e0a0"
                },
                {
                    "nameValeu": "80e080",
                    "countfiltr": 6,
                    "ID": 66769,
                    "UF_HEX": "#80e080"
                },
                {
                    "nameValeu": "40a020",
                    "countfiltr": 3,
                    "ID": 66781,
                    "UF_HEX": "#40a020"
                },
                {
                    "nameValeu": "80e040",
                    "countfiltr": 1,
                    "ID": 66782,
                    "UF_HEX": "#80e040"
                },
                {
                    "nameValeu": "60c020",
                    "countfiltr": 3,
                    "ID": 66783,
                    "UF_HEX": "#60c020"
                },
                {
                    "nameValeu": "a0e040",
                    "countfiltr": 9,
                    "ID": 66784,
                    "UF_HEX": "#a0e040"
                },
                {
                    "nameValeu": "ff2020",
                    "countfiltr": 19,
                    "ID": 66736,
                    "UF_HEX": "#ff2020"
                },
                {
                    "nameValeu": "40e0c0",
                    "countfiltr": 7,
                    "ID": 66785,
                    "UF_HEX": "#40e0c0"
                },
                {
                    "nameValeu": "e0ff20",
                    "countfiltr": 2,
                    "ID": 66762,
                    "UF_HEX": "#e0ff20"
                },
                {
                    "nameValeu": "e0ff00",
                    "countfiltr": 1,
                    "ID": 66786,
                    "UF_HEX": "#e0ff00"
                },
                {
                    "nameValeu": "c020a0",
                    "countfiltr": 3,
                    "ID": 66787,
                    "UF_HEX": "#c020a0"
                },
                {
                    "nameValeu": "a0ffff",
                    "countfiltr": 9,
                    "ID": 66699,
                    "UF_HEX": "#a0ffff"
                },
                {
                    "nameValeu": "ff40a0",
                    "countfiltr": 5,
                    "ID": 66760,
                    "UF_HEX": "#ff40a0"
                },
                {
                    "nameValeu": "ff2080",
                    "countfiltr": 6,
                    "ID": 66788,
                    "UF_HEX": "#ff2080"
                },
                {
                    "nameValeu": "80ffff",
                    "countfiltr": 2,
                    "ID": 66789,
                    "UF_HEX": "#80ffff"
                },
                {
                    "nameValeu": "60ffff",
                    "countfiltr": 1,
                    "ID": 66790,
                    "UF_HEX": "#60ffff"
                },
                {
                    "nameValeu": "e0ff40",
                    "countfiltr": 6,
                    "ID": 66761,
                    "UF_HEX": "#e0ff40"
                },
                {
                    "nameValeu": "006060",
                    "countfiltr": 1,
                    "ID": 66688,
                    "UF_HEX": "#006060"
                },
                {
                    "nameValeu": "6060e0",
                    "countfiltr": 1,
                    "ID": 66793,
                    "UF_HEX": "#6060e0"
                },
                {
                    "nameValeu": "80a0ff",
                    "countfiltr": 2,
                    "ID": 66794,
                    "UF_HEX": "#80a0ff"
                },
                {
                    "nameValeu": "a0a0ff",
                    "countfiltr": 2,
                    "ID": 66795,
                    "UF_HEX": "#a0a0ff"
                },
                {
                    "nameValeu": "200060",
                    "countfiltr": 4,
                    "ID": 66796,
                    "UF_HEX": "#200060"
                },
                {
                    "nameValeu": "ffc0ff",
                    "countfiltr": 3,
                    "ID": 66797,
                    "UF_HEX": "#ffc0ff"
                },
                {
                    "nameValeu": "e080e0",
                    "countfiltr": 3,
                    "ID": 66798,
                    "UF_HEX": "#e080e0"
                },
                {
                    "nameValeu": "e0a0ff",
                    "countfiltr": 3,
                    "ID": 66799,
                    "UF_HEX": "#e0a0ff"
                },
                {
                    "nameValeu": "c080e0",
                    "countfiltr": 7,
                    "ID": 66770,
                    "UF_HEX": "#c080e0"
                },
                {
                    "nameValeu": "a0e060",
                    "countfiltr": 22,
                    "ID": 66800,
                    "UF_HEX": "#a0e060"
                },
                {
                    "nameValeu": "a0ffe0",
                    "countfiltr": 7,
                    "ID": 66801,
                    "UF_HEX": "#a0ffe0"
                },
                {
                    "nameValeu": "80ffe0",
                    "countfiltr": 4,
                    "ID": 66802,
                    "UF_HEX": "#80ffe0"
                },
                {
                    "nameValeu": "a0ffa0",
                    "countfiltr": 2,
                    "ID": 66803,
                    "UF_HEX": "#a0ffa0"
                },
                {
                    "nameValeu": "a0ff80",
                    "countfiltr": 4,
                    "ID": 66804,
                    "UF_HEX": "#a0ff80"
                },
                {
                    "nameValeu": "a0ffc0",
                    "countfiltr": 3,
                    "ID": 66805,
                    "UF_HEX": "#a0ffc0"
                },
                {
                    "nameValeu": "60e0a0",
                    "countfiltr": 5,
                    "ID": 66806,
                    "UF_HEX": "#60e0a0"
                },
                {
                    "nameValeu": "80ff80",
                    "countfiltr": 1,
                    "ID": 66807,
                    "UF_HEX": "#80ff80"
                },
                {
                    "nameValeu": "80ffc0",
                    "countfiltr": 3,
                    "ID": 66808,
                    "UF_HEX": "#80ffc0"
                },
                {
                    "nameValeu": "60e060",
                    "countfiltr": 2,
                    "ID": 66809,
                    "UF_HEX": "#60e060"
                },
                {
                    "nameValeu": "800060",
                    "countfiltr": 5,
                    "ID": 66810,
                    "UF_HEX": "#800060"
                },
                {
                    "nameValeu": "e020c0",
                    "countfiltr": 1,
                    "ID": 66811,
                    "UF_HEX": "#e020c0"
                },
                {
                    "nameValeu": "e040e0",
                    "countfiltr": 2,
                    "ID": 66812,
                    "UF_HEX": "#e040e0"
                },
                {
                    "nameValeu": "ff40e0",
                    "countfiltr": 1,
                    "ID": 66813,
                    "UF_HEX": "#ff40e0"
                },
                {
                    "nameValeu": "c0ff80",
                    "countfiltr": 11,
                    "ID": 66814,
                    "UF_HEX": "#c0ff80"
                },
                {
                    "nameValeu": "60ffc0",
                    "countfiltr": 1,
                    "ID": 66815,
                    "UF_HEX": "#60ffc0"
                },
                {
                    "nameValeu": "60ffa0",
                    "countfiltr": 1,
                    "ID": 66816,
                    "UF_HEX": "#60ffa0"
                },
                {
                    "nameValeu": "ffa0ff",
                    "countfiltr": 3,
                    "ID": 66817,
                    "UF_HEX": "#ffa0ff"
                },
                {
                    "nameValeu": "ff80ff",
                    "countfiltr": 1,
                    "ID": 66818,
                    "UF_HEX": "#ff80ff"
                },
                {
                    "nameValeu": "80ff60",
                    "countfiltr": 1,
                    "ID": 66819,
                    "UF_HEX": "#80ff60"
                },
                {
                    "nameValeu": "a0e080",
                    "countfiltr": 18,
                    "ID": 66820,
                    "UF_HEX": "#a0e080"
                },
                {
                    "nameValeu": "40e040",
                    "countfiltr": 2,
                    "ID": 66821,
                    "UF_HEX": "#40e040"
                },
                {
                    "nameValeu": "4080ff",
                    "countfiltr": 3,
                    "ID": 66822,
                    "UF_HEX": "#4080ff"
                },
                {
                    "nameValeu": "4020a0",
                    "countfiltr": 1,
                    "ID": 66823,
                    "UF_HEX": "#4020a0"
                },
                {
                    "nameValeu": "60ffe0",
                    "countfiltr": 1,
                    "ID": 66824,
                    "UF_HEX": "#60ffe0"
                },
                {
                    "nameValeu": "c0ff60",
                    "countfiltr": 3,
                    "ID": 66825,
                    "UF_HEX": "#c0ff60"
                },
                {
                    "nameValeu": "004060",
                    "countfiltr": 1,
                    "ID": 66420,
                    "UF_HEX": "#004060"
                },
                {
                    "nameValeu": "4060e0",
                    "countfiltr": 1,
                    "ID": 66792,
                    "UF_HEX": "#4060e0"
                },
                {
                    "nameValeu": "002040",
                    "countfiltr": 2,
                    "ID": 66421,
                    "UF_HEX": "#002040"
                },
                {
                    "nameValeu": "2040e0",
                    "countfiltr": 2,
                    "ID": 66826,
                    "UF_HEX": "#2040e0"
                },
                {
                    "nameValeu": "40c040",
                    "countfiltr": 1,
                    "ID": 66827,
                    "UF_HEX": "#40c040"
                },
                {
                    "nameValeu": "c060e0",
                    "countfiltr": 2,
                    "ID": 66828,
                    "UF_HEX": "#c060e0"
                },
                {
                    "nameValeu": "a040e0",
                    "countfiltr": 1,
                    "ID": 66829,
                    "UF_HEX": "#a040e0"
                },
                {
                    "nameValeu": "c080ff",
                    "countfiltr": 1,
                    "ID": 66830,
                    "UF_HEX": "#c080ff"
                },
                {
                    "nameValeu": "a040c0",
                    "countfiltr": 1,
                    "ID": 66831,
                    "UF_HEX": "#a040c0"
                },
                {
                    "nameValeu": "600060",
                    "countfiltr": 4,
                    "ID": 66791,
                    "UF_HEX": "#600060"
                },
                {
                    "nameValeu": "600080",
                    "countfiltr": 1,
                    "ID": 66832,
                    "UF_HEX": "#600080"
                },
                {
                    "nameValeu": "a020a0",
                    "countfiltr": 3,
                    "ID": 66833,
                    "UF_HEX": "#a020a0"
                },
                {
                    "nameValeu": "8020a0",
                    "countfiltr": 2,
                    "ID": 66834,
                    "UF_HEX": "#8020a0"
                },
                {
                    "nameValeu": "a020c0",
                    "countfiltr": 1,
                    "ID": 66835,
                    "UF_HEX": "#a020c0"
                },
                {
                    "nameValeu": "60e040",
                    "countfiltr": 1,
                    "ID": 66836,
                    "UF_HEX": "#60e040"
                },
                {
                    "nameValeu": "60e020",
                    "countfiltr": 1,
                    "ID": 66837,
                    "UF_HEX": "#60e020"
                },
                {
                    "nameValeu": "40c020",
                    "countfiltr": 1,
                    "ID": 66838,
                    "UF_HEX": "#40c020"
                },
                {
                    "nameValeu": "6020a0",
                    "countfiltr": 1,
                    "ID": 66839,
                    "UF_HEX": "#6020a0"
                },
                {
                    "nameValeu": "40e0a0",
                    "countfiltr": 2,
                    "ID": 66840,
                    "UF_HEX": "#40e0a0"
                },
                {
                    "nameValeu": "208020",
                    "countfiltr": 2,
                    "ID": 66841,
                    "UF_HEX": "#208020"
                },
                {
                    "nameValeu": "a0ff60",
                    "countfiltr": 3,
                    "ID": 66842,
                    "UF_HEX": "#a0ff60"
                },
                {
                    "nameValeu": "60c060",
                    "countfiltr": 4,
                    "ID": 66843,
                    "UF_HEX": "#60c060"
                },
                {
                    "nameValeu": "00c0a0",
                    "countfiltr": 5,
                    "ID": 66844,
                    "UF_HEX": "#00c0a0"
                },
                {
                    "nameValeu": "c040c0",
                    "countfiltr": 2,
                    "ID": 66851,
                    "UF_HEX": "#c040c0"
                },
                {
                    "nameValeu": "ff0040",
                    "countfiltr": 4,
                    "ID": 66852,
                    "UF_HEX": "#ff0040"
                },
                {
                    "nameValeu": "c0a0ff",
                    "countfiltr": 1,
                    "ID": 66854,
                    "UF_HEX": "#c0a0ff"
                },
                {
                    "nameValeu": "20c0a0",
                    "countfiltr": 10,
                    "ID": 66846,
                    "UF_HEX": "#20c0a0"
                },
                {
                    "nameValeu": "000080",
                    "countfiltr": 4,
                    "ID": 66112,
                    "UF_HEX": "#000080"
                },
                {
                    "nameValeu": "0080e0",
                    "countfiltr": 4,
                    "ID": 66768,
                    "UF_HEX": "#0080e0"
                },
                {
                    "nameValeu": "a0e020",
                    "countfiltr": 3,
                    "ID": 66765,
                    "UF_HEX": "#a0e020"
                },
                {
                    "nameValeu": "e0e000",
                    "countfiltr": 9,
                    "ID": 66855,
                    "UF_HEX": "#e0e000"
                },
                {
                    "nameValeu": "ff0020",
                    "countfiltr": 3,
                    "ID": 66856,
                    "UF_HEX": "#ff0020"
                },
                {
                    "nameValeu": "ff0060",
                    "countfiltr": 1,
                    "ID": 66853,
                    "UF_HEX": "#ff0060"
                },
                {
                    "nameValeu": "ff0080",
                    "countfiltr": 1,
                    "ID": 66857,
                    "UF_HEX": "#ff0080"
                },
                {
                    "nameValeu": "20a020",
                    "countfiltr": 1,
                    "ID": 66848,
                    "UF_HEX": "#20a020"
                },
                {
                    "nameValeu": "008020",
                    "countfiltr": 1,
                    "ID": 66850,
                    "UF_HEX": "#008020"
                },
                {
                    "nameValeu": "8020e0",
                    "countfiltr": 1,
                    "ID": 66867,
                    "UF_HEX": "#8020e0"
                },
                {
                    "nameValeu": "20e0e0",
                    "countfiltr": 10,
                    "ID": 66870,
                    "UF_HEX": "#20e0e0"
                },
                {
                    "nameValeu": "20e0c0",
                    "countfiltr": 2,
                    "ID": 66871,
                    "UF_HEX": "#20e0c0"
                },
                {
                    "nameValeu": "00a080",
                    "countfiltr": 12,
                    "ID": 66847,
                    "UF_HEX": "#00a080"
                },
                {
                    "nameValeu": "002000",
                    "countfiltr": 121,
                    "ID": 66707,
                    "UF_HEX": "#002000"
                },
                {
                    "nameValeu": "40a060",
                    "countfiltr": 24,
                    "ID": 66872,
                    "UF_HEX": "#40a060"
                },
                {
                    "nameValeu": "20c080",
                    "countfiltr": 2,
                    "ID": 66873,
                    "UF_HEX": "#20c080"
                },
                {
                    "nameValeu": "a0c000",
                    "countfiltr": 3,
                    "ID": 66766,
                    "UF_HEX": "#a0c000"
                },
                {
                    "nameValeu": "c0e000",
                    "countfiltr": 3,
                    "ID": 66874,
                    "UF_HEX": "#c0e000"
                },
                {
                    "nameValeu": "ff2000",
                    "countfiltr": 2,
                    "ID": 66875,
                    "UF_HEX": "#ff2000"
                },
                {
                    "nameValeu": "004000",
                    "countfiltr": 4,
                    "ID": 66845,
                    "UF_HEX": "#004000"
                },
                {
                    "nameValeu": "e020a0",
                    "countfiltr": 13,
                    "ID": 66698,
                    "UF_HEX": "#e020a0"
                }
            ],
            "HighloadBlockValue": [
                "#a02020",
                "#c04040",
                "#c06040",
                "#c06060",
                "#c02020",
                "#c02040",
                "#a04020",
                "#a02040",
                "#a04040",
                "#c04020",
                "#e08060",
                "#e06060",
                "#c04060",
                "#802020",
                "#c08060",
                "#e08080",
                "#202020",
                "#404040",
                "#606060",
                "#000020",
                "#202000",
                "#200000",
                "#202040",
                "#002020",
                "#200020",
                "#404060",
                "#606080",
                "#204040",
                "#406060",
                "#404020",
                "#a06080",
                "#804060",
                "#602040",
                "#804040",
                "#806060",
                "#a06060",
                "#a04060",
                "#802040",
                "#806080",
                "#604040",
                "#a04080",
                "#402020",
                "#a080a0",
                "#602020",
                "#a060a0",
                "#604060",
                "#204060",
                "#202060",
                "#206080",
                "#402040",
                "#400020",
                "#602060",
                "#a04000",
                "#c06020",
                "#c08020",
                "#c04000",
                "#c06000",
                "#a06020",
                "#c0a020",
                "#a06000",
                "#e0a020",
                "#e08020",
                "#c08000",
                "#804000",
                "#e06020",
                "#804020",
                "#e0ffff",
                "#e0e0e0",
                "#e0e0ff",
                "#ffffff",
                "#c0c0c0",
                "#c0e0e0",
                "#808060",
                "#a0a0a0",
                "#c0c0e0",
                "#c0c0a0",
                "#a0a080",
                "#a08080",
                "#a0a0c0",
                "#e0c0e0",
                "#e0e0c0",
                "#c0a0a0",
                "#e0c0c0",
                "#80a0a0",
                "#a0c0c0",
                "#80a080",
                "#608080",
                "#a0c0a0",
                "#80a060",
                "#a0c080",
                "#a0a060",
                "#808040",
                "#c0e0c0",
                "#c0a0c0",
                "#8080a0",
                "#c080a0",
                "#a08060",
                "#806040",
                "#608060",
                "#ffe0e0",
                "#ffe0ff",
                "#c0c080",
                "#a0c060",
                "#606040",
                "#406080",
                "#c0a080",
                "#e0c0a0",
                "#e0c080",
                "#a06040",
                "#e0e0a0",
                "#604020",
                "#e0a080",
                "#ffffe0",
                "#c08080",
                "#400000",
                "#406040",
                "#c0a060",
                "#a08040",
                "#ffe0c0",
                "#ff8080",
                "#ffa080",
                "#e0a060",
                "#e06040",
                "#600000",
                "#e08040",
                "#802000",
                "#c08040",
                "#806020",
                "#602000",
                "#402000",
                "#e0a0a0",
                "#606020",
                "#a08020",
                "#20e020",
                "#ffe0a0",
                "#c0c060",
                "#c0a040",
                "#a0a040",
                "#204020",
                "#20a0a0",
                "#80a0c0",
                "#a0e0e0",
                "#80c0c0",
                "#80e0e0",
                "#80a0e0",
                "#2080a0",
                "#a0a0e0",
                "#a0c0e0",
                "#e04020",
                "#a00020",
                "#e0a040",
                "#e02020",
                "#c00020",
                "#c0a0e0",
                "#8060c0",
                "#8060a0",
                "#e04040",
                "#a080c0",
                "#e04060",
                "#608040",
                "#6080a0",
                "#e0c060",
                "#800020",
                "#60a0a0",
                "#60a0c0",
                "#408080",
                "#80c0a0",
                "#ff8040",
                "#e0c020",
                "#808020",
                "#e0c040",
                "#c0c040",
                "#4080a0",
                "#4080c0",
                "#206060",
                "#ffc0a0",
                "#ffc060",
                "#e0ffe0",
                "#c0ffe0",
                "#e0e080",
                "#604000",
                "#600020",
                "#c06080",
                "#e02040",
                "#e06080",
                "#ff2040",
                "#e080a0",
                "#204080",
                "#004080",
                "#4080e0",
                "#2040a0",
                "#002060",
                "#2060e0",
                "#002080",
                "#2080e0",
                "#2060a0",
                "#4060a0",
                "#202080",
                "#2060c0",
                "#4060c0",
                "#004060",
                "#4060e0",
                "#0040a0",
                "#006080",
                "#6080e0",
                "#6060a0",
                "#404080",
                "#8080c0",
                "#80c080",
                "#60a060",
                "#a0e0a0",
                "#406020",
                "#c0e0a0",
                "#c0e080",
                "#c0e060",
                "#a0c040",
                "#80a040",
                "#208080",
                "#40a0a0",
                "#60a080",
                "#408060",
                "#80a020",
                "#a0a020",
                "#608020",
                "#404000",
                "#606000",
                "#204000",
                "#e0e060",
                "#ffe060",
                "#c0e0ff",
                "#c0c0ff",
                "#c0c020",
                "#c060a0",
                "#c04080",
                "#a02060",
                "#e080c0",
                "#c02060",
                "#e0a0c0",
                "#e060a0",
                "#c02080",
                "#402060",
                "#ffc080",
                "#804080",
                "#c080c0",
                "#ffe080",
                "#002040",
                "#2040e0",
                "#004040",
                "#ffc0e0",
                "#ffc0c0",
                "#ffa0c0",
                "#ff80c0",
                "#ffa0e0",
                "#604080",
                "#e0c0ff",
                "#e0a0e0",
                "#ff80a0",
                "#ff60a0",
                "#6080c0",
                "#802060",
                "#80c020",
                "#60a020",
                "#a0c020",
                "#e06000",
                "#408040",
                "#20a0c0",
                "#ffc020",
                "#e0a000",
                "#806000",
                "#ffffc0",
                "#ffffa0",
                "#ffff80",
                "#008080",
                "#8080e0",
                "#ffa060",
                "#ff6040",
                "#ff4040",
                "#ff4020",
                "#ff6020",
                "#ff8060",
                "#ffa0a0",
                "#a00000",
                "#c02000",
                "#e0e040",
                "#c0e040",
                "#ffa020",
                "#ffc040",
                "#ffc000",
                "#ffa000",
                "#ffe040",
                "#ffa040",
                "#ff8020",
                "#ff6060",
                "#ff4060",
                "#ff6080",
                "#a00040",
                "#e04080",
                "#800040",
                "#402080",
                "#60c0e0",
                "#40c0c0",
                "#40c0e0",
                "#40a0c0",
                "#60c0c0",
                "#80c0e0",
                "#a0e0c0",
                "#206040",
                "#a060e0",
                "#008060",
                "#8060e0",
                "#a080e0",
                "#8040c0",
                "#6040a0",
                "#6040c0",
                "#4040a0",
                "#000040",
                "#c040a0",
                "#a02080",
                "#a040a0",
                "#8040a0",
                "#c060c0",
                "#a060c0",
                "#ff2060",
                "#e00020",
                "#ff4080",
                "#e02060",
                "#e00040",
                "#c00040",
                "#40c0a0",
                "#60c0a0",
                "#40a080",
                "#a0e0ff",
                "#400040",
                "#e060c0",
                "#e040a0",
                "#e040c0",
                "#ff8000",
                "#ff6000",
                "#ff60c0",
                "#ff80e0",
                "#20c0c0",
                "#60e0e0",
                "#60e0c0",
                "#00a0a0",
                "#2080c0",
                "#40e0e0",
                "#60a0e0",
                "#c0ffff",
                "#ffe020",
                "#c0e020",
                "#e0e020",
                "#60a040",
                "#408020",
                "#608000",
                "#80a000",
                "#a0a000",
                "#406000",
                "#ffe000",
                "#ffff20",
                "#ffff00",
                "#600040",
                "#2040c0",
                "#0020a0",
                "#0040c0",
                "#2020a0",
                "#60c080",
                "#206020",
                "#4040c0",
                "#000060",
                "#6060c0",
                "#ffff40",
                "#200040",
                "#a02000",
                "#c00000",
                "#0060c0",
                "#002060",
                "#2060e0",
                "#002080",
                "#2080e0",
                "#e00060",
                "#802080",
                "#602080",
                "#e0ffc0",
                "#e04000",
                "#a0c0ff",
                "#c0ffc0",
                "#c0ffa0",
                "#e0ffa0",
                "#e0ff80",
                "#ffff60",
                "#40a0e0",
                "#004080",
                "#4080e0",
                "#80c060",
                "#e02080",
                "#e0ff60",
                "#20c0e0",
                "#20a0e0",
                "#a00060",
                "#c00060",
                "#ff4000",
                "#006080",
                "#6080e0",
                "#0080a0",
                "#006060",
                "#6060e0",
                "#a08000",
                "#e02000",
                "#e08000",
                "#40a040",
                "#208060",
                "#c0a000",
                "#e0c000",
                "#408000",
                "#0060a0",
                "#0080c0",
                "#80c040",
                "#008060",
                "#8060e0",
                "#00a060",
                "#20a060",
                "#008040",
                "#8040e0",
                "#208040",
                "#00a040",
                "#20a080",
                "#20a040",
                "#00a0c0",
                "#c0c000",
                "#006020",
                "#60a000",
                "#80c000",
                "#00c0e0",
                "#80e0c0",
                "#e00000",
                "#400060",
                "#60e0ff",
                "#80e0ff",
                "#40e0ff",
                "#004020",
                "#006040",
                "#00c0c0",
                "#00a0e0",
                "#20c0ff",
                "#60c040",
                "#60e080",
                "#20c060",
                "#40c080",
                "#40c060",
                "#80e0a0",
                "#80e080",
                "#40a020",
                "#80e040",
                "#60c020",
                "#a0e040",
                "#ff2020",
                "#40e0c0",
                "#e0ff20",
                "#e0ff00",
                "#c020a0",
                "#a0ffff",
                "#ff40a0",
                "#ff2080",
                "#80ffff",
                "#60ffff",
                "#e0ff40",
                "#006060",
                "#6060e0",
                "#80a0ff",
                "#a0a0ff",
                "#200060",
                "#ffc0ff",
                "#e080e0",
                "#e0a0ff",
                "#c080e0",
                "#a0e060",
                "#a0ffe0",
                "#80ffe0",
                "#a0ffa0",
                "#a0ff80",
                "#a0ffc0",
                "#60e0a0",
                "#80ff80",
                "#80ffc0",
                "#60e060",
                "#800060",
                "#e020c0",
                "#e040e0",
                "#ff40e0",
                "#c0ff80",
                "#60ffc0",
                "#60ffa0",
                "#ffa0ff",
                "#ff80ff",
                "#80ff60",
                "#a0e080",
                "#40e040",
                "#4080ff",
                "#4020a0",
                "#60ffe0",
                "#c0ff60",
                "#004060",
                "#4060e0",
                "#002040",
                "#2040e0",
                "#40c040",
                "#c060e0",
                "#a040e0",
                "#c080ff",
                "#a040c0",
                "#600060",
                "#600080",
                "#a020a0",
                "#8020a0",
                "#a020c0",
                "#60e040",
                "#60e020",
                "#40c020",
                "#6020a0",
                "#40e0a0",
                "#208020",
                "#a0ff60",
                "#60c060",
                "#00c0a0",
                "#c040c0",
                "#ff0040",
                "#c0a0ff",
                "#20c0a0",
                "#000080",
                "#0080e0",
                "#a0e020",
                "#e0e000",
                "#ff0020",
                "#ff0060",
                "#ff0080",
                "#20a020",
                "#008020",
                "#8020e0",
                "#20e0e0",
                "#20e0c0",
                "#00a080",
                "#002000",
                "#40a060",
                "#20c080",
                "#a0c000",
                "#c0e000",
                "#ff2000",
                "#004000",
                "#e020a0"
            ]
        }
    },
    {
        "ID": "44",
        "NAME": "Ширина рулона",
        "CODE": "width",
        "PROPERTY_TYPE": "N",
        "LIST_TYPE": "N",
        "DISPLAY_TYPE": "A",
        "PROPERTY_VALUE": [
            1,
            420
        ]
    },
    {
        "ID": "59",
        "NAME": "Категория",
        "CODE": "cathegory",
        "PROPERTY_TYPE": "L",
        "LIST_TYPE": "L",
        "DISPLAY_TYPE": "F",
        "PROPERTY_VALUE": [
            {
                "nameValeu": "Мебельная",
                "countfiltr": 16868,
                "ID": 340
            },
            {
                "nameValeu": "Портьерная",
                "countfiltr": 44601,
                "ID": 338
            },
            {
                "nameValeu": "Для покрывала",
                "countfiltr": 1426,
                "ID": 1135
            },
            {
                "nameValeu": "Для скатерти",
                "countfiltr": 1281,
                "ID": 1285
            },
            {
                "nameValeu": "Тюлевая",
                "countfiltr": 14913,
                "ID": 339
            },
            {
                "nameValeu": "Подкладочная",
                "countfiltr": 1256,
                "ID": 341
            },
            {
                "nameValeu": "Уличная",
                "countfiltr": 1386,
                "ID": 4889
            }
        ]
    },
    {
        "ID": "65",
        "NAME": "Выделка",
        "CODE": "technology",
        "PROPERTY_TYPE": "L",
        "LIST_TYPE": "L",
        "DISPLAY_TYPE": "F",
        "PROPERTY_VALUE": [
            {
                "nameValeu": "Жаккард",
                "countfiltr": 17686,
                "ID": 369
            },
            {
                "nameValeu": "Принт",
                "countfiltr": 4575,
                "ID": 377
            },
            {
                "nameValeu": "Репс",
                "countfiltr": 484,
                "ID": 378
            },
            {
                "nameValeu": "Гобелен",
                "countfiltr": 193,
                "ID": 368
            },
            {
                "nameValeu": "Сатин",
                "countfiltr": 3395,
                "ID": 380
            },
            {
                "nameValeu": "Димаут",
                "countfiltr": 3782,
                "ID": 937
            },
            {
                "nameValeu": "Батист",
                "countfiltr": 187,
                "ID": 443
            },
            {
                "nameValeu": "Атлас",
                "countfiltr": 1304,
                "ID": 363
            },
            {
                "nameValeu": "Тафта",
                "countfiltr": 649,
                "ID": 383
            },
            {
                "nameValeu": "Многослойная",
                "countfiltr": 12,
                "ID": 452
            },
            {
                "nameValeu": "Шёлк",
                "countfiltr": 393,
                "ID": 453
            },
            {
                "nameValeu": "Рогожка",
                "countfiltr": 6932,
                "ID": 379
            },
            {
                "nameValeu": "Бархат",
                "countfiltr": 4023,
                "ID": 364
            },
            {
                "nameValeu": "Лён",
                "countfiltr": 2652,
                "ID": 374
            },
            {
                "nameValeu": "Вуаль",
                "countfiltr": 1817,
                "ID": 408
            },
            {
                "nameValeu": "Органза",
                "countfiltr": 2496,
                "ID": 407
            },
            {
                "nameValeu": "Жатая",
                "countfiltr": 891,
                "ID": 370
            },
            {
                "nameValeu": "Тюль",
                "countfiltr": 6254,
                "ID": 656
            },
            {
                "nameValeu": "Деворе",
                "countfiltr": 1456,
                "ID": 639
            },
            {
                "nameValeu": "Сетка",
                "countfiltr": 3451,
                "ID": 381
            },
            {
                "nameValeu": "Кружево",
                "countfiltr": 180,
                "ID": 709
            },
            {
                "nameValeu": "Шенилл",
                "countfiltr": 3297,
                "ID": 385
            },
            {
                "nameValeu": "Софт",
                "countfiltr": 1483,
                "ID": 1736
            },
            {
                "nameValeu": "Полуорганза",
                "countfiltr": 422,
                "ID": 410
            },
            {
                "nameValeu": "Креп",
                "countfiltr": 819,
                "ID": 409
            },
            {
                "nameValeu": "Велюр",
                "countfiltr": 1220,
                "ID": 366
            },
            {
                "nameValeu": "Вышивка",
                "countfiltr": 1683,
                "ID": 367
            },
            {
                "nameValeu": "Перфорация",
                "countfiltr": 114,
                "ID": 1021
            },
            {
                "nameValeu": "Тиснение",
                "countfiltr": 146,
                "ID": 1280
            },
            {
                "nameValeu": "Букле",
                "countfiltr": 1069,
                "ID": 365
            },
            {
                "nameValeu": "Блэкаут",
                "countfiltr": 788,
                "ID": 413
            },
            {
                "nameValeu": "Саржа",
                "countfiltr": 2531,
                "ID": 678
            },
            {
                "nameValeu": "Люрекс",
                "countfiltr": 601,
                "ID": 375
            },
            {
                "nameValeu": "Канвас",
                "countfiltr": 439,
                "ID": 4891
            },
            {
                "nameValeu": "Стёганая",
                "countfiltr": 162,
                "ID": 382
            },
            {
                "nameValeu": "Шифон",
                "countfiltr": 36,
                "ID": 1447
            },
            {
                "nameValeu": "Полотно",
                "countfiltr": 4360,
                "ID": 1506
            },
            {
                "nameValeu": "Декоративные нити",
                "countfiltr": 341,
                "ID": 1507
            },
            {
                "nameValeu": "Набивная",
                "countfiltr": 71,
                "ID": 762
            },
            {
                "nameValeu": "Флок",
                "countfiltr": 118,
                "ID": 384
            },
            {
                "nameValeu": "Микровуаль",
                "countfiltr": 158,
                "ID": 1508
            },
            {
                "nameValeu": "Искусственная замша",
                "countfiltr": 597,
                "ID": 371
            },
            {
                "nameValeu": "Аппликация",
                "countfiltr": 144,
                "ID": 362
            },
            {
                "nameValeu": "Металлизация",
                "countfiltr": 695,
                "ID": 1509
            },
            {
                "nameValeu": "Искусственная кожа",
                "countfiltr": 481,
                "ID": 372
            },
            {
                "nameValeu": "Дикий шёлк",
                "countfiltr": 126,
                "ID": 1589
            },
            {
                "nameValeu": "Плюш",
                "countfiltr": 65,
                "ID": 1723
            },
            {
                "nameValeu": "Добби",
                "countfiltr": 122,
                "ID": 1282
            },
            {
                "nameValeu": "Армюр",
                "countfiltr": 36,
                "ID": 1281
            },
            {
                "nameValeu": "Меланж",
                "countfiltr": 2266,
                "ID": 1936
            },
            {
                "nameValeu": "Рэйон",
                "countfiltr": 728,
                "ID": 1480
            },
            {
                "nameValeu": "Вельвет",
                "countfiltr": 316,
                "ID": 444
            },
            {
                "nameValeu": "Алькантара",
                "countfiltr": 92,
                "ID": 1476
            },
            {
                "nameValeu": "Микрофибра",
                "countfiltr": 220,
                "ID": 2102
            },
            {
                "nameValeu": "Микровелюр",
                "countfiltr": 123,
                "ID": 2290
            },
            {
                "nameValeu": "Гипюр",
                "countfiltr": 72,
                "ID": 2417
            },
            {
                "nameValeu": "Флис",
                "countfiltr": 32,
                "ID": 2422
            },
            {
                "nameValeu": "Драп",
                "countfiltr": 8,
                "ID": 2418
            },
            {
                "nameValeu": "Искусственный мех",
                "countfiltr": 5,
                "ID": 6567
            }
        ]
    },
    {
        "ID": "13",
        "NAME": "Материал",
        "CODE": "material",
        "PROPERTY_TYPE": "L",
        "LIST_TYPE": "L",
        "DISPLAY_TYPE": "F",
        "PROPERTY_VALUE": [
            {
                "nameValeu": "Хлопок",
                "countfiltr": 14493,
                "ID": 8
            },
            {
                "nameValeu": "Полиэстер",
                "countfiltr": 60967,
                "ID": 416
            },
            {
                "nameValeu": "Акрил",
                "countfiltr": 4743,
                "ID": 417
            },
            {
                "nameValeu": "Вискоза",
                "countfiltr": 7265,
                "ID": 236
            },
            {
                "nameValeu": "Шёлк",
                "countfiltr": 316,
                "ID": 186
            },
            {
                "nameValeu": "Лён",
                "countfiltr": 3128,
                "ID": 51
            },
            {
                "nameValeu": "Шерсть",
                "countfiltr": 279,
                "ID": 657
            },
            {
                "nameValeu": "Нейлон",
                "countfiltr": 789,
                "ID": 658
            },
            {
                "nameValeu": "Бамбук",
                "countfiltr": 10,
                "ID": 913
            },
            {
                "nameValeu": "Металл",
                "countfiltr": 298,
                "ID": 1479
            },
            {
                "nameValeu": "Полипропилен",
                "countfiltr": 383,
                "ID": 1481
            },
            {
                "nameValeu": "Полиуретан",
                "countfiltr": 681,
                "ID": 1833
            },
            {
                "nameValeu": "Поливинилхлорид",
                "countfiltr": 152,
                "ID": 1832
            },
            {
                "nameValeu": "Эластан",
                "countfiltr": 133,
                "ID": 1940
            },
            {
                "nameValeu": "Джут",
                "countfiltr": 14,
                "ID": 187
            }
        ]
    },
    {
        "ID": "63",
        "NAME": "Класс",
        "CODE": "class",
        "PROPERTY_TYPE": "L",
        "LIST_TYPE": "L",
        "DISPLAY_TYPE": "F",
        "PROPERTY_VALUE": [
            {
                "nameValeu": "Sale",
                "countfiltr": 8875,
                "ID": 342
            },
            {
                "nameValeu": "Премиум",
                "countfiltr": 22294,
                "ID": 345
            },
            {
                "nameValeu": "Стандарт",
                "countfiltr": 31789,
                "ID": 344
            },
            {
                "nameValeu": "Эконом",
                "countfiltr": 2169,
                "ID": 343
            },
            {
                "nameValeu": "Сток",
                "countfiltr": 239,
                "ID": 6542
            }
        ]
    },
    {
        "ID": "64",
        "NAME": "Рисунок",
        "CODE": "print",
        "PROPERTY_TYPE": "L",
        "LIST_TYPE": "L",
        "DISPLAY_TYPE": "F",
        "PROPERTY_VALUE": [
            {
                "nameValeu": "Клетка",
                "countfiltr": 737,
                "ID": 354
            },
            {
                "nameValeu": "Однотонные",
                "countfiltr": 41866,
                "ID": 356
            },
            {
                "nameValeu": "Горошек-точки",
                "countfiltr": 709,
                "ID": 2304
            },
            {
                "nameValeu": "Полоска",
                "countfiltr": 5297,
                "ID": 358
            },
            {
                "nameValeu": "Цветы-растения",
                "countfiltr": 5760,
                "ID": 360
            },
            {
                "nameValeu": "Геометрия",
                "countfiltr": 4699,
                "ID": 349
            },
            {
                "nameValeu": "Море-корабли",
                "countfiltr": 70,
                "ID": 355
            },
            {
                "nameValeu": "Надписи-буквы",
                "countfiltr": 239,
                "ID": 435
            },
            {
                "nameValeu": "Волны",
                "countfiltr": 1191,
                "ID": 1498
            },
            {
                "nameValeu": "Графика",
                "countfiltr": 530,
                "ID": 1494
            },
            {
                "nameValeu": "Листья",
                "countfiltr": 1355,
                "ID": 1700
            },
            {
                "nameValeu": "Здания-архитектура",
                "countfiltr": 66,
                "ID": 352
            },
            {
                "nameValeu": "Игры-отдых-спорт",
                "countfiltr": 32,
                "ID": 353
            },
            {
                "nameValeu": "Страны-города",
                "countfiltr": 56,
                "ID": 359
            },
            {
                "nameValeu": "Предметы",
                "countfiltr": 217,
                "ID": 434
            },
            {
                "nameValeu": "Классика",
                "countfiltr": 1252,
                "ID": 450
            },
            {
                "nameValeu": "Вензель-дамаск",
                "countfiltr": 2891,
                "ID": 348
            },
            {
                "nameValeu": "Абстракция",
                "countfiltr": 2154,
                "ID": 347
            },
            {
                "nameValeu": "Этника",
                "countfiltr": 925,
                "ID": 361
            },
            {
                "nameValeu": "Персонажи-люди",
                "countfiltr": 132,
                "ID": 414
            },
            {
                "nameValeu": "Транспорт",
                "countfiltr": 44,
                "ID": 439
            },
            {
                "nameValeu": "Животные",
                "countfiltr": 663,
                "ID": 351
            },
            {
                "nameValeu": "Огурцы",
                "countfiltr": 245,
                "ID": 841
            },
            {
                "nameValeu": "Мелкий рисунок",
                "countfiltr": 1093,
                "ID": 448
            },
            {
                "nameValeu": "Муар",
                "countfiltr": 124,
                "ID": 2303
            },
            {
                "nameValeu": "Крупный рисунок",
                "countfiltr": 872,
                "ID": 449
            },
            {
                "nameValeu": "Пастораль",
                "countfiltr": 87,
                "ID": 357
            },
            {
                "nameValeu": "Ромб",
                "countfiltr": 1589,
                "ID": 1496
            },
            {
                "nameValeu": "Решётка",
                "countfiltr": 3016,
                "ID": 1497
            },
            {
                "nameValeu": "Орнамент",
                "countfiltr": 669,
                "ID": 1698
            },
            {
                "nameValeu": "Акварель",
                "countfiltr": 859,
                "ID": 1619
            },
            {
                "nameValeu": "Фактура",
                "countfiltr": 7837,
                "ID": 1493
            },
            {
                "nameValeu": "Квадраты",
                "countfiltr": 210,
                "ID": 1495
            },
            {
                "nameValeu": "Завитки",
                "countfiltr": 564,
                "ID": 1598
            },
            {
                "nameValeu": "Вазоны",
                "countfiltr": 238,
                "ID": 1597
            },
            {
                "nameValeu": "Круги",
                "countfiltr": 368,
                "ID": 1697
            },
            {
                "nameValeu": "Ёлочка",
                "countfiltr": 1227,
                "ID": 1699
            },
            {
                "nameValeu": "Градиент",
                "countfiltr": 310,
                "ID": 1790
            }
        ]
    },
    {
        "ID": "58",
        "NAME": "Стиль",
        "CODE": "style",
        "PROPERTY_TYPE": "L",
        "LIST_TYPE": "L",
        "DISPLAY_TYPE": "F",
        "PROPERTY_VALUE": [
            {
                "nameValeu": "Ар Деко",
                "countfiltr": 1946,
                "ID": 389
            },
            {
                "nameValeu": "Современный",
                "countfiltr": 13743,
                "ID": 395
            },
            {
                "nameValeu": "Ретро",
                "countfiltr": 1080,
                "ID": 440
            },
            {
                "nameValeu": "Фьюжн",
                "countfiltr": 419,
                "ID": 1783
            },
            {
                "nameValeu": "Английский",
                "countfiltr": 2326,
                "ID": 388
            },
            {
                "nameValeu": "Восток",
                "countfiltr": 2948,
                "ID": 391
            },
            {
                "nameValeu": "Классика",
                "countfiltr": 7975,
                "ID": 393
            },
            {
                "nameValeu": "Универсальный",
                "countfiltr": 43429,
                "ID": 396
            },
            {
                "nameValeu": "Кантри-прованс",
                "countfiltr": 4690,
                "ID": 392
            },
            {
                "nameValeu": "Ар Нуво (Модерн)",
                "countfiltr": 745,
                "ID": 390
            },
            {
                "nameValeu": "Эклектика",
                "countfiltr": 1138,
                "ID": 1782
            },
            {
                "nameValeu": "Китч",
                "countfiltr": 163,
                "ID": 1788
            },
            {
                "nameValeu": "Ампир",
                "countfiltr": 1534,
                "ID": 387
            },
            {
                "nameValeu": "Скандинавский",
                "countfiltr": 512,
                "ID": 1407
            },
            {
                "nameValeu": "Эко",
                "countfiltr": 1444,
                "ID": 1779
            },
            {
                "nameValeu": "Роккоко-барокко",
                "countfiltr": 1663,
                "ID": 394
            },
            {
                "nameValeu": "Винтаж",
                "countfiltr": 2726,
                "ID": 1503
            },
            {
                "nameValeu": "Колониальный",
                "countfiltr": 2210,
                "ID": 1502
            },
            {
                "nameValeu": "Хай-тек",
                "countfiltr": 1242,
                "ID": 1500
            },
            {
                "nameValeu": "Минимализм",
                "countfiltr": 1468,
                "ID": 1501
            },
            {
                "nameValeu": "Французкий",
                "countfiltr": 156,
                "ID": 1504
            },
            {
                "nameValeu": "Грандж",
                "countfiltr": 548,
                "ID": 1789
            },
            {
                "nameValeu": "Романтический",
                "countfiltr": 843,
                "ID": 1785
            },
            {
                "nameValeu": "Средиземноморский",
                "countfiltr": 518,
                "ID": 1786
            },
            {
                "nameValeu": "Лофт",
                "countfiltr": 2378,
                "ID": 1780
            },
            {
                "nameValeu": "Неоклассика",
                "countfiltr": 889,
                "ID": 1787
            },
            {
                "nameValeu": "Готика",
                "countfiltr": 144,
                "ID": 1781
            },
            {
                "nameValeu": "Японский",
                "countfiltr": 196,
                "ID": 1784
            }
        ]
    },
    {
        "ID": "31",
        "NAME": "Страна",
        "CODE": "country",
        "PROPERTY_TYPE": "L",
        "LIST_TYPE": "L",
        "DISPLAY_TYPE": "F",
        "PROPERTY_VALUE": [
            {
                "nameValeu": "Испания",
                "countfiltr": 6689,
                "ID": 109
            },
            {
                "nameValeu": "Турция",
                "countfiltr": 25680,
                "ID": 108
            },
            {
                "nameValeu": "Бельгия",
                "countfiltr": 9978,
                "ID": 324
            },
            {
                "nameValeu": "Италия",
                "countfiltr": 9194,
                "ID": 111
            },
            {
                "nameValeu": "Великобритания",
                "countfiltr": 92,
                "ID": 677
            },
            {
                "nameValeu": "США",
                "countfiltr": 826,
                "ID": 264
            },
            {
                "nameValeu": "Германия",
                "countfiltr": 5912,
                "ID": 110
            },
            {
                "nameValeu": "Малайзия",
                "countfiltr": 19,
                "ID": 952
            },
            {
                "nameValeu": "Марокко",
                "countfiltr": 10,
                "ID": 1037
            },
            {
                "nameValeu": "Нидерланды",
                "countfiltr": 50,
                "ID": 1328
            },
            {
                "nameValeu": "Франция",
                "countfiltr": 400,
                "ID": 268
            },
            {
                "nameValeu": "Китай",
                "countfiltr": 1680,
                "ID": 437
            },
            {
                "nameValeu": "Греция",
                "countfiltr": 121,
                "ID": 1769
            },
            {
                "nameValeu": "Индия",
                "countfiltr": 4418,
                "ID": 681
            },
            {
                "nameValeu": "Перу",
                "countfiltr": 5,
                "ID": 2051
            },
            {
                "nameValeu": "Тайвань",
                "countfiltr": 1,
                "ID": 2238
            },
            {
                "nameValeu": "Корея",
                "countfiltr": 34,
                "ID": 112
            },
            {
                "nameValeu": "Пакистан",
                "countfiltr": 36,
                "ID": 2236
            },
            {
                "nameValeu": "Израиль",
                "countfiltr": 104,
                "ID": 1260
            },
            {
                "nameValeu": "Польша",
                "countfiltr": 132,
                "ID": 2297
            },
            {
                "nameValeu": "Португалия",
                "countfiltr": 15,
                "ID": 4957
            },
            {
                "nameValeu": "Россия",
                "countfiltr": 96,
                "ID": 4963
            }
        ]
    },
    {
        "ID": "14",
        "NAME": "Поставщик",
        "CODE": "producer",
        "PROPERTY_TYPE": "L",
        "LIST_TYPE": "L",
        "DISPLAY_TYPE": "F",
        "PROPERTY_VALUE": [
            {
                "nameValeu": "Casablanca",
                "countfiltr": 1813,
                "ID": 6
            },
            {
                "nameValeu": "Valencia",
                "countfiltr": 134,
                "ID": 729
            },
            {
                "nameValeu": "Garden",
                "countfiltr": 463,
                "ID": 5
            },
            {
                "nameValeu": "Dr Deco",
                "countfiltr": 463,
                "ID": 1747
            },
            {
                "nameValeu": "Forever",
                "countfiltr": 2088,
                "ID": 4952
            },
            {
                "nameValeu": "Galleria Arben",
                "countfiltr": 3242,
                "ID": 611
            },
            {
                "nameValeu": "ViK",
                "countfiltr": 385,
                "ID": 1020
            },
            {
                "nameValeu": "Brutex",
                "countfiltr": 7940,
                "ID": 1144
            },
            {
                "nameValeu": "Dom Caro",
                "countfiltr": 2368,
                "ID": 1295
            },
            {
                "nameValeu": "Daylight",
                "countfiltr": 7072,
                "ID": 679
            },
            {
                "nameValeu": "Elegancia",
                "countfiltr": 7072,
                "ID": 680
            },
            {
                "nameValeu": "Kauffort",
                "countfiltr": 207,
                "ID": 911
            },
            {
                "nameValeu": "Rekron",
                "countfiltr": 39,
                "ID": 953
            },
            {
                "nameValeu": "Exterio",
                "countfiltr": 2067,
                "ID": 1474
            },
            {
                "nameValeu": "Anka",
                "countfiltr": 730,
                "ID": 37
            },
            {
                "nameValeu": "Windeco",
                "countfiltr": 1232,
                "ID": 1937
            },
            {
                "nameValeu": "5Avenue",
                "countfiltr": 7604,
                "ID": 1432
            },
            {
                "nameValeu": "Espocada",
                "countfiltr": 4736,
                "ID": 1487
            },
            {
                "nameValeu": "Venesto",
                "countfiltr": 676,
                "ID": 2337
            },
            {
                "nameValeu": "BC Fabrics",
                "countfiltr": 8,
                "ID": 1701
            },
            {
                "nameValeu": "TextilExpress",
                "countfiltr": 1021,
                "ID": 1806
            },
            {
                "nameValeu": "Arya",
                "countfiltr": 389,
                "ID": 1941
            },
            {
                "nameValeu": "Wiya",
                "countfiltr": 1056,
                "ID": 1951
            },
            {
                "nameValeu": "Liontex",
                "countfiltr": 3024,
                "ID": 1992
            },
            {
                "nameValeu": "Me Casa",
                "countfiltr": 1084,
                "ID": 1993
            },
            {
                "nameValeu": "Nevio",
                "countfiltr": 2094,
                "ID": 1994
            },
            {
                "nameValeu": "Alcantara",
                "countfiltr": 92,
                "ID": 1473
            },
            {
                "nameValeu": "Maisonin",
                "countfiltr": 223,
                "ID": 2073
            },
            {
                "nameValeu": "Trento",
                "countfiltr": 490,
                "ID": 2085
            },
            {
                "nameValeu": "Realia",
                "countfiltr": 924,
                "ID": 731
            },
            {
                "nameValeu": "Neville",
                "countfiltr": 163,
                "ID": 2089
            },
            {
                "nameValeu": "Esperanza",
                "countfiltr": 746,
                "ID": 2092
            },
            {
                "nameValeu": "Almatex",
                "countfiltr": 384,
                "ID": 2098
            },
            {
                "nameValeu": "Pina",
                "countfiltr": 125,
                "ID": 2130
            },
            {
                "nameValeu": "Vistex",
                "countfiltr": 663,
                "ID": 2153
            },
            {
                "nameValeu": "TD Collection",
                "countfiltr": 716,
                "ID": 2188
            },
            {
                "nameValeu": "ROF",
                "countfiltr": 663,
                "ID": 2189
            },
            {
                "nameValeu": "Dessange",
                "countfiltr": 792,
                "ID": 2190
            },
            {
                "nameValeu": "Vitex",
                "countfiltr": 596,
                "ID": 74
            },
            {
                "nameValeu": "Sapphire",
                "countfiltr": 634,
                "ID": 2389
            },
            {
                "nameValeu": "Mona Lisa",
                "countfiltr": 816,
                "ID": 2202
            },
            {
                "nameValeu": "Grada",
                "countfiltr": 813,
                "ID": 2205
            },
            {
                "nameValeu": "Pleasure",
                "countfiltr": 611,
                "ID": 2207
            },
            {
                "nameValeu": "VIP Dekor",
                "countfiltr": 1137,
                "ID": 2216
            },
            {
                "nameValeu": "Cosset",
                "countfiltr": 243,
                "ID": 2224
            },
            {
                "nameValeu": "Ultra",
                "countfiltr": 1809,
                "ID": 2225
            },
            {
                "nameValeu": "Dardeco",
                "countfiltr": 267,
                "ID": 2253
            },
            {
                "nameValeu": "Sofia",
                "countfiltr": 619,
                "ID": 2255
            },
            {
                "nameValeu": "Adeko",
                "countfiltr": 1605,
                "ID": 2256
            },
            {
                "nameValeu": "Park Deco",
                "countfiltr": 892,
                "ID": 2258
            },
            {
                "nameValeu": "TextileData",
                "countfiltr": 734,
                "ID": 2273
            },
            {
                "nameValeu": "Melange",
                "countfiltr": 636,
                "ID": 2274
            },
            {
                "nameValeu": "Artefact",
                "countfiltr": 784,
                "ID": 2291
            },
            {
                "nameValeu": "Bonlaif",
                "countfiltr": 612,
                "ID": 2293
            },
            {
                "nameValeu": "SG Hogar",
                "countfiltr": 259,
                "ID": 2275
            },
            {
                "nameValeu": "Tempotest",
                "countfiltr": 87,
                "ID": 2301
            },
            {
                "nameValeu": "Casa Favorita",
                "countfiltr": 376,
                "ID": 2306
            },
            {
                "nameValeu": "Sunbrella",
                "countfiltr": 198,
                "ID": 1335
            },
            {
                "nameValeu": "Livena",
                "countfiltr": 102,
                "ID": 2334
            },
            {
                "nameValeu": "Dana Panorama",
                "countfiltr": 294,
                "ID": 2336
            },
            {
                "nameValeu": "Chetintex",
                "countfiltr": 589,
                "ID": 2391
            },
            {
                "nameValeu": "Laime",
                "countfiltr": 583,
                "ID": 2393
            },
            {
                "nameValeu": "Vinaldi",
                "countfiltr": 632,
                "ID": 2395
            },
            {
                "nameValeu": "Nope",
                "countfiltr": 384,
                "ID": 2410
            },
            {
                "nameValeu": "Jolie",
                "countfiltr": 138,
                "ID": 2409
            },
            {
                "nameValeu": "Ecobella",
                "countfiltr": 905,
                "ID": 2424
            },
            {
                "nameValeu": "Ointerior",
                "countfiltr": 103,
                "ID": 4882
            },
            {
                "nameValeu": "Armana",
                "countfiltr": 122,
                "ID": 4886
            },
            {
                "nameValeu": "Fabric Club",
                "countfiltr": 333,
                "ID": 4887
            },
            {
                "nameValeu": "Hasbor",
                "countfiltr": 303,
                "ID": 4890
            },
            {
                "nameValeu": "Megara",
                "countfiltr": 1070,
                "ID": 4925
            },
            {
                "nameValeu": "Carrline",
                "countfiltr": 23,
                "ID": 4935
            },
            {
                "nameValeu": "Bayar",
                "countfiltr": 90,
                "ID": 4936
            },
            {
                "nameValeu": "Kerem",
                "countfiltr": 603,
                "ID": 4948
            },
            {
                "nameValeu": "WGArt",
                "countfiltr": 588,
                "ID": 4969
            },
            {
                "nameValeu": "VIP Camilla",
                "countfiltr": 396,
                "ID": 5003
            },
            {
                "nameValeu": "Aldo Tessuti",
                "countfiltr": 100,
                "ID": 6528
            },
            {
                "nameValeu": "Decolab",
                "countfiltr": 50,
                "ID": 6534
            },
            {
                "nameValeu": "MaruFabrics",
                "countfiltr": 80,
                "ID": 6549
            },
            {
                "nameValeu": "Breezz",
                "countfiltr": 61,
                "ID": 6570
            }
        ]
    },
    {
        "ID": "25",
        "NAME": "Коллекция",
        "CODE": "collection",
        "PROPERTY_TYPE": "L",
        "LIST_TYPE": "L",
        "DISPLAY_TYPE": "F",
        "PROPERTY_VALUE": [
            {
                "nameValeu": "Mars",
                "countfiltr": 6,
                "ID": 139
            },
            {
                "nameValeu": "Udaipur",
                "countfiltr": 12,
                "ID": 142
            },
            {
                "nameValeu": "Bateau",
                "countfiltr": 6,
                "ID": 149
            },
            {
                "nameValeu": "Creative Collection",
                "countfiltr": 30,
                "ID": 733
            },
            {
                "nameValeu": "Blackout 150",
                "countfiltr": 21,
                "ID": 243
            },
            {
                "nameValeu": "Art",
                "countfiltr": 10,
                "ID": 262
            },
            {
                "nameValeu": "Lorelei",
                "countfiltr": 4,
                "ID": 283
            },
            {
                "nameValeu": "Forever",
                "countfiltr": 846,
                "ID": 105
            },
            {
                "nameValeu": "ViK Disco",
                "countfiltr": 31,
                "ID": 1018
            },
            {
                "nameValeu": "Souffle GA",
                "countfiltr": 51,
                "ID": 1827
            },
            {
                "nameValeu": "Lola",
                "countfiltr": 4,
                "ID": 586
            },
            {
                "nameValeu": "Luxury",
                "countfiltr": 45,
                "ID": 588
            },
            {
                "nameValeu": "Luxury II",
                "countfiltr": 38,
                "ID": 589
            },
            {
                "nameValeu": "Azov Tintura Raya",
                "countfiltr": 25,
                "ID": 614
            },
            {
                "nameValeu": "Agata",
                "countfiltr": 21,
                "ID": 1288
            },
            {
                "nameValeu": "Katavi",
                "countfiltr": 4,
                "ID": 632
            },
            {
                "nameValeu": "Dynasty",
                "countfiltr": 16,
                "ID": 490
            },
            {
                "nameValeu": "Venturin",
                "countfiltr": 4,
                "ID": 1291
            },
            {
                "nameValeu": "Printemps",
                "countfiltr": 11,
                "ID": 1753
            },
            {
                "nameValeu": "Jaco",
                "countfiltr": 19,
                "ID": 1299
            },
            {
                "nameValeu": "Chic Flower",
                "countfiltr": 6,
                "ID": 951
            },
            {
                "nameValeu": "Clouds",
                "countfiltr": 5,
                "ID": 653
            },
            {
                "nameValeu": "Daynight",
                "countfiltr": 25,
                "ID": 654
            },
            {
                "nameValeu": "Simple Solutions",
                "countfiltr": 7,
                "ID": 671
            },
            {
                "nameValeu": "Otello",
                "countfiltr": 17,
                "ID": 631
            },
            {
                "nameValeu": "Paisley",
                "countfiltr": 20,
                "ID": 669
            },
            {
                "nameValeu": "Indira",
                "countfiltr": 4,
                "ID": 688
            },
            {
                "nameValeu": "Petra",
                "countfiltr": 6,
                "ID": 689
            },
            {
                "nameValeu": "Galaxy",
                "countfiltr": 10,
                "ID": 641
            },
            {
                "nameValeu": "Ambro",
                "countfiltr": 32,
                "ID": 713
            },
            {
                "nameValeu": "Arnedo",
                "countfiltr": 24,
                "ID": 714
            },
            {
                "nameValeu": "Estillo",
                "countfiltr": 11,
                "ID": 716
            },
            {
                "nameValeu": "Estillo DLT",
                "countfiltr": 19,
                "ID": 1639
            },
            {
                "nameValeu": "Fiera DLT",
                "countfiltr": 14,
                "ID": 1643
            },
            {
                "nameValeu": "La Villa",
                "countfiltr": 36,
                "ID": 718
            },
            {
                "nameValeu": "Lino",
                "countfiltr": 13,
                "ID": 719
            },
            {
                "nameValeu": "Meek Modest",
                "countfiltr": 32,
                "ID": 720
            },
            {
                "nameValeu": "Navarra",
                "countfiltr": 12,
                "ID": 721
            },
            {
                "nameValeu": "Navia",
                "countfiltr": 10,
                "ID": 722
            },
            {
                "nameValeu": "Salinas",
                "countfiltr": 1,
                "ID": 724
            },
            {
                "nameValeu": "Titulo",
                "countfiltr": 28,
                "ID": 727
            },
            {
                "nameValeu": "Segovia",
                "countfiltr": 47,
                "ID": 725
            },
            {
                "nameValeu": "Sencillo",
                "countfiltr": 42,
                "ID": 726
            },
            {
                "nameValeu": "Viana",
                "countfiltr": 40,
                "ID": 728
            },
            {
                "nameValeu": "Albo",
                "countfiltr": 6,
                "ID": 711
            },
            {
                "nameValeu": "Amaro",
                "countfiltr": 2,
                "ID": 712
            },
            {
                "nameValeu": "Paseo",
                "countfiltr": 14,
                "ID": 723
            },
            {
                "nameValeu": "Valencia Collection",
                "countfiltr": 30,
                "ID": 732
            },
            {
                "nameValeu": "Summer Collection",
                "countfiltr": 10,
                "ID": 736
            },
            {
                "nameValeu": "Flamenco Collection",
                "countfiltr": 20,
                "ID": 734
            },
            {
                "nameValeu": "Kitchen Collection",
                "countfiltr": 33,
                "ID": 735
            },
            {
                "nameValeu": "Amasra",
                "countfiltr": 4,
                "ID": 740
            },
            {
                "nameValeu": "Urla",
                "countfiltr": 10,
                "ID": 866
            },
            {
                "nameValeu": "Guido",
                "countfiltr": 1,
                "ID": 813
            },
            {
                "nameValeu": "Mia",
                "countfiltr": 3,
                "ID": 835
            },
            {
                "nameValeu": "Emmanuel",
                "countfiltr": 1,
                "ID": 752
            },
            {
                "nameValeu": "Avanos",
                "countfiltr": 7,
                "ID": 744
            },
            {
                "nameValeu": "Haymana",
                "countfiltr": 6,
                "ID": 816
            },
            {
                "nameValeu": "Buca",
                "countfiltr": 4,
                "ID": 822
            },
            {
                "nameValeu": "Japlin",
                "countfiltr": 6,
                "ID": 755
            },
            {
                "nameValeu": "Bridget",
                "countfiltr": 7,
                "ID": 748
            },
            {
                "nameValeu": "Gia",
                "countfiltr": 7,
                "ID": 753
            },
            {
                "nameValeu": "Datca",
                "countfiltr": 2,
                "ID": 749
            },
            {
                "nameValeu": "Toprak",
                "countfiltr": 1,
                "ID": 757
            },
            {
                "nameValeu": "Caledonia",
                "countfiltr": 4,
                "ID": 799
            },
            {
                "nameValeu": "Feeling",
                "countfiltr": 5,
                "ID": 808
            },
            {
                "nameValeu": "Mone",
                "countfiltr": 5,
                "ID": 836
            },
            {
                "nameValeu": "Sisley",
                "countfiltr": 5,
                "ID": 863
            },
            {
                "nameValeu": "Hals",
                "countfiltr": 2,
                "ID": 815
            },
            {
                "nameValeu": "Rubens",
                "countfiltr": 1,
                "ID": 862
            },
            {
                "nameValeu": "Mathilda",
                "countfiltr": 3,
                "ID": 1354
            },
            {
                "nameValeu": "Servi",
                "countfiltr": 1,
                "ID": 1333
            },
            {
                "nameValeu": "Tulupani",
                "countfiltr": 9,
                "ID": 865
            },
            {
                "nameValeu": "Jessica",
                "countfiltr": 3,
                "ID": 827
            },
            {
                "nameValeu": "Nicole",
                "countfiltr": 5,
                "ID": 838
            },
            {
                "nameValeu": "Watto",
                "countfiltr": 3,
                "ID": 868
            },
            {
                "nameValeu": "Raya",
                "countfiltr": 8,
                "ID": 859
            },
            {
                "nameValeu": "Vivaldi",
                "countfiltr": 8,
                "ID": 867
            },
            {
                "nameValeu": "Zambak",
                "countfiltr": 3,
                "ID": 869
            },
            {
                "nameValeu": "Storico-Freedom",
                "countfiltr": 3,
                "ID": 910
            },
            {
                "nameValeu": "Mini-Motif",
                "countfiltr": 8,
                "ID": 919
            },
            {
                "nameValeu": "Barolo",
                "countfiltr": 5,
                "ID": 982
            },
            {
                "nameValeu": "Africanos",
                "countfiltr": 2,
                "ID": 1000
            },
            {
                "nameValeu": "Camberley",
                "countfiltr": 6,
                "ID": 1001
            },
            {
                "nameValeu": "Effects",
                "countfiltr": 6,
                "ID": 1003
            },
            {
                "nameValeu": "Swan",
                "countfiltr": 6,
                "ID": 1004
            },
            {
                "nameValeu": "ViK Regular",
                "countfiltr": 36,
                "ID": 1019
            },
            {
                "nameValeu": "Gris",
                "countfiltr": 25,
                "ID": 1114
            },
            {
                "nameValeu": "Rolyef",
                "countfiltr": 1,
                "ID": 1117
            },
            {
                "nameValeu": "Algas",
                "countfiltr": 9,
                "ID": 1125
            },
            {
                "nameValeu": "Anka Corail",
                "countfiltr": 7,
                "ID": 1330
            },
            {
                "nameValeu": "Amore",
                "countfiltr": 1,
                "ID": 223
            },
            {
                "nameValeu": "Make Up",
                "countfiltr": 13,
                "ID": 1298
            },
            {
                "nameValeu": "Anka Frond",
                "countfiltr": 2,
                "ID": 1331
            },
            {
                "nameValeu": "Adele",
                "countfiltr": 40,
                "ID": 1311
            },
            {
                "nameValeu": "Tailandia",
                "countfiltr": 1,
                "ID": 1384
            },
            {
                "nameValeu": "Clikat",
                "countfiltr": 14,
                "ID": 1389
            },
            {
                "nameValeu": "New Hampton",
                "countfiltr": 10,
                "ID": 1404
            },
            {
                "nameValeu": "Muare and Saten",
                "countfiltr": 32,
                "ID": 1355
            },
            {
                "nameValeu": "Linex and Spirit",
                "countfiltr": 58,
                "ID": 1356
            },
            {
                "nameValeu": "Cachemire",
                "countfiltr": 15,
                "ID": 1361
            },
            {
                "nameValeu": "Divine",
                "countfiltr": 11,
                "ID": 1362
            },
            {
                "nameValeu": "Regency",
                "countfiltr": 19,
                "ID": 1363
            },
            {
                "nameValeu": "Rose",
                "countfiltr": 2,
                "ID": 1364
            },
            {
                "nameValeu": "Salvador Pablo",
                "countfiltr": 22,
                "ID": 1366
            },
            {
                "nameValeu": "Bambina",
                "countfiltr": 7,
                "ID": 1365
            },
            {
                "nameValeu": "Petalos",
                "countfiltr": 1,
                "ID": 137
            },
            {
                "nameValeu": "GA Monte Cristo",
                "countfiltr": 50,
                "ID": 1373
            },
            {
                "nameValeu": "Rio",
                "countfiltr": 89,
                "ID": 1438
            },
            {
                "nameValeu": "Gaudi",
                "countfiltr": 76,
                "ID": 1442
            },
            {
                "nameValeu": "5A Lino",
                "countfiltr": 61,
                "ID": 1443
            },
            {
                "nameValeu": "Giotto",
                "countfiltr": 77,
                "ID": 1444
            },
            {
                "nameValeu": "Wonderful",
                "countfiltr": 63,
                "ID": 1445
            },
            {
                "nameValeu": "Livorno",
                "countfiltr": 53,
                "ID": 1446
            },
            {
                "nameValeu": "Unito",
                "countfiltr": 85,
                "ID": 1454
            },
            {
                "nameValeu": "Neo 5 Avenue",
                "countfiltr": 85,
                "ID": 1455
            },
            {
                "nameValeu": "Siena",
                "countfiltr": 61,
                "ID": 1453
            },
            {
                "nameValeu": "Alassio",
                "countfiltr": 64,
                "ID": 1456
            },
            {
                "nameValeu": "Bravo",
                "countfiltr": 81,
                "ID": 1458
            },
            {
                "nameValeu": "Marella",
                "countfiltr": 4,
                "ID": 1459
            },
            {
                "nameValeu": "5Avenue Geo",
                "countfiltr": 85,
                "ID": 1462
            },
            {
                "nameValeu": "Caribe",
                "countfiltr": 48,
                "ID": 1464
            },
            {
                "nameValeu": "Solo",
                "countfiltr": 50,
                "ID": 1465
            },
            {
                "nameValeu": "Provenza",
                "countfiltr": 6,
                "ID": 1466
            },
            {
                "nameValeu": "Etna",
                "countfiltr": 54,
                "ID": 1467
            },
            {
                "nameValeu": "Casablanca LM",
                "countfiltr": 18,
                "ID": 1770
            },
            {
                "nameValeu": "EC Trimmings",
                "countfiltr": 202,
                "ID": 1489
            },
            {
                "nameValeu": "EC Trimmings Ar Deco",
                "countfiltr": 223,
                "ID": 1490
            },
            {
                "nameValeu": "Plain And Stripe part 8 EC",
                "countfiltr": 140,
                "ID": 1557
            },
            {
                "nameValeu": "Timeless Elegance EC",
                "countfiltr": 8,
                "ID": 1572
            },
            {
                "nameValeu": "Dauphine EC",
                "countfiltr": 6,
                "ID": 2184
            },
            {
                "nameValeu": "Espocada Uncatalogued 2",
                "countfiltr": 22,
                "ID": 1538
            },
            {
                "nameValeu": "Caprice EC",
                "countfiltr": 39,
                "ID": 1527
            },
            {
                "nameValeu": "La Manche EC",
                "countfiltr": 37,
                "ID": 1546
            },
            {
                "nameValeu": "Amberley EC",
                "countfiltr": 31,
                "ID": 1511
            },
            {
                "nameValeu": "Fancy EC",
                "countfiltr": 41,
                "ID": 1541
            },
            {
                "nameValeu": "Blackout EC",
                "countfiltr": 7,
                "ID": 1524
            },
            {
                "nameValeu": "Continent EC",
                "countfiltr": 8,
                "ID": 1532
            },
            {
                "nameValeu": "Twilight EC",
                "countfiltr": 45,
                "ID": 1574
            },
            {
                "nameValeu": "Shamrock EC",
                "countfiltr": 48,
                "ID": 1561
            },
            {
                "nameValeu": "Select EC",
                "countfiltr": 13,
                "ID": 1559
            },
            {
                "nameValeu": "Moonlight EC",
                "countfiltr": 10,
                "ID": 1549
            },
            {
                "nameValeu": "Avance EC",
                "countfiltr": 45,
                "ID": 1523
            },
            {
                "nameValeu": "Charm EC",
                "countfiltr": 85,
                "ID": 1528
            },
            {
                "nameValeu": "Sheers EC",
                "countfiltr": 75,
                "ID": 1562
            },
            {
                "nameValeu": "Aura EC",
                "countfiltr": 22,
                "ID": 1522
            },
            {
                "nameValeu": "Weekend EC",
                "countfiltr": 52,
                "ID": 1575
            },
            {
                "nameValeu": "Opera EC",
                "countfiltr": 76,
                "ID": 1553
            },
            {
                "nameValeu": "Ar Deco part 2 EC",
                "countfiltr": 7,
                "ID": 1514
            },
            {
                "nameValeu": "Ar Deco part 4 EC",
                "countfiltr": 5,
                "ID": 1516
            },
            {
                "nameValeu": "Ar Deco part 6 EC",
                "countfiltr": 5,
                "ID": 1518
            },
            {
                "nameValeu": "Ar Deco part 1 EC",
                "countfiltr": 6,
                "ID": 1513
            },
            {
                "nameValeu": "Ar Deco part 3 EC",
                "countfiltr": 4,
                "ID": 1515
            },
            {
                "nameValeu": "Ar Deco part 5 EC",
                "countfiltr": 2,
                "ID": 1517
            },
            {
                "nameValeu": "Ar Deco part 7 EC",
                "countfiltr": 6,
                "ID": 1519
            },
            {
                "nameValeu": "Ar Deco part 8 EC",
                "countfiltr": 5,
                "ID": 1520
            },
            {
                "nameValeu": "Ar Deco part 9 EC",
                "countfiltr": 1,
                "ID": 1521
            },
            {
                "nameValeu": "Gallant EC",
                "countfiltr": 11,
                "ID": 1544
            },
            {
                "nameValeu": "Duplex EC",
                "countfiltr": 13,
                "ID": 1534
            },
            {
                "nameValeu": "Louis de Or EC",
                "countfiltr": 7,
                "ID": 1547
            },
            {
                "nameValeu": "Fluid EC",
                "countfiltr": 52,
                "ID": 1543
            },
            {
                "nameValeu": "Royal EC",
                "countfiltr": 15,
                "ID": 1558
            },
            {
                "nameValeu": "Antique EC",
                "countfiltr": 24,
                "ID": 1512
            },
            {
                "nameValeu": "Liberty EC",
                "countfiltr": 114,
                "ID": 2066
            },
            {
                "nameValeu": "Elizabeth EC",
                "countfiltr": 12,
                "ID": 1536
            },
            {
                "nameValeu": "Palazzo EC",
                "countfiltr": 106,
                "ID": 1554
            },
            {
                "nameValeu": "New Look EC",
                "countfiltr": 22,
                "ID": 1551
            },
            {
                "nameValeu": "Soft EC",
                "countfiltr": 16,
                "ID": 1567
            },
            {
                "nameValeu": "Bloom EC",
                "countfiltr": 19,
                "ID": 1525
            },
            {
                "nameValeu": "Summerhouse EC",
                "countfiltr": 4,
                "ID": 1568
            },
            {
                "nameValeu": "The Best Plain part 4 EC",
                "countfiltr": 34,
                "ID": 1571
            },
            {
                "nameValeu": "Eternity EC",
                "countfiltr": 4,
                "ID": 1539
            },
            {
                "nameValeu": "Favorite EC",
                "countfiltr": 11,
                "ID": 1542
            },
            {
                "nameValeu": "Fairy Tale EC",
                "countfiltr": 1,
                "ID": 1540
            },
            {
                "nameValeu": "Evolution EC",
                "countfiltr": 131,
                "ID": 2038
            },
            {
                "nameValeu": "Duos EC",
                "countfiltr": 41,
                "ID": 1533
            },
            {
                "nameValeu": "Showroom collection Part 1 EC",
                "countfiltr": 30,
                "ID": 1563
            },
            {
                "nameValeu": "Espocada Uncatalogued 1",
                "countfiltr": 23,
                "ID": 1537
            },
            {
                "nameValeu": "DL Muse",
                "countfiltr": 33,
                "ID": 1484
            },
            {
                "nameValeu": "Pavilion EC",
                "countfiltr": 50,
                "ID": 1555
            },
            {
                "nameValeu": "Sunset EC",
                "countfiltr": 1,
                "ID": 1569
            },
            {
                "nameValeu": "Tempo EC",
                "countfiltr": 17,
                "ID": 1570
            },
            {
                "nameValeu": "Pirouette EC",
                "countfiltr": 15,
                "ID": 1556
            },
            {
                "nameValeu": "Showroom collection Part 3 EC",
                "countfiltr": 15,
                "ID": 1565
            },
            {
                "nameValeu": "Showroom collection Part 2 EC",
                "countfiltr": 10,
                "ID": 1564
            },
            {
                "nameValeu": "Skyline EC",
                "countfiltr": 18,
                "ID": 1566
            },
            {
                "nameValeu": "Bon Voyage EC",
                "countfiltr": 11,
                "ID": 1526
            },
            {
                "nameValeu": "Lounge Collection EC",
                "countfiltr": 18,
                "ID": 1548
            },
            {
                "nameValeu": "Contemporary Collection EC",
                "countfiltr": 5,
                "ID": 1531
            },
            {
                "nameValeu": "Classic Collection EC",
                "countfiltr": 8,
                "ID": 1529
            },
            {
                "nameValeu": "Natural Collection EC",
                "countfiltr": 2,
                "ID": 1550
            },
            {
                "nameValeu": "Colourfull Collection EC",
                "countfiltr": 11,
                "ID": 1530
            },
            {
                "nameValeu": "Harmony Collection EC",
                "countfiltr": 5,
                "ID": 1545
            },
            {
                "nameValeu": "Nuance Collection EC",
                "countfiltr": 10,
                "ID": 1552
            },
            {
                "nameValeu": "Shadow Collection EC",
                "countfiltr": 5,
                "ID": 1560
            },
            {
                "nameValeu": "London DL",
                "countfiltr": 3,
                "ID": 1576
            },
            {
                "nameValeu": "Ametrine",
                "countfiltr": 1,
                "ID": 1588
            },
            {
                "nameValeu": "Etno TT",
                "countfiltr": 5,
                "ID": 1590
            },
            {
                "nameValeu": "Oceana TT",
                "countfiltr": 34,
                "ID": 1591
            },
            {
                "nameValeu": "Adria 5A",
                "countfiltr": 58,
                "ID": 1594
            },
            {
                "nameValeu": "Romantic 5A",
                "countfiltr": 36,
                "ID": 1593
            },
            {
                "nameValeu": "Retro 5A",
                "countfiltr": 44,
                "ID": 1600
            },
            {
                "nameValeu": "Savoy 5A",
                "countfiltr": 64,
                "ID": 1601
            },
            {
                "nameValeu": "Altea GA",
                "countfiltr": 30,
                "ID": 1607
            },
            {
                "nameValeu": "Galaxy GA",
                "countfiltr": 9,
                "ID": 1608
            },
            {
                "nameValeu": "Amal GA",
                "countfiltr": 30,
                "ID": 1612
            },
            {
                "nameValeu": "Flores 5A",
                "countfiltr": 25,
                "ID": 1610
            },
            {
                "nameValeu": "Castello 5A",
                "countfiltr": 48,
                "ID": 1611
            },
            {
                "nameValeu": "Illusion GA",
                "countfiltr": 18,
                "ID": 1620
            },
            {
                "nameValeu": "Tropicana",
                "countfiltr": 45,
                "ID": 164
            },
            {
                "nameValeu": "Verano GA",
                "countfiltr": 40,
                "ID": 1621
            },
            {
                "nameValeu": "Muscato DLT",
                "countfiltr": 28,
                "ID": 1665
            },
            {
                "nameValeu": "Isadora DLT",
                "countfiltr": 49,
                "ID": 1650
            },
            {
                "nameValeu": "Ravenna DLT",
                "countfiltr": 47,
                "ID": 1676
            },
            {
                "nameValeu": "Valence DLT",
                "countfiltr": 107,
                "ID": 1683
            },
            {
                "nameValeu": "Frankston DLT",
                "countfiltr": 17,
                "ID": 1646
            },
            {
                "nameValeu": "Esperance DLT",
                "countfiltr": 24,
                "ID": 1638
            },
            {
                "nameValeu": "Quazar DLT",
                "countfiltr": 90,
                "ID": 2340
            },
            {
                "nameValeu": "Melbourne DLT",
                "countfiltr": 19,
                "ID": 1661
            },
            {
                "nameValeu": "Kingston DLT",
                "countfiltr": 90,
                "ID": 1653
            },
            {
                "nameValeu": "Lincerno DLT",
                "countfiltr": 54,
                "ID": 1654
            },
            {
                "nameValeu": "Benissa DLT",
                "countfiltr": 71,
                "ID": 1632
            },
            {
                "nameValeu": "Rosell DLT",
                "countfiltr": 56,
                "ID": 1678
            },
            {
                "nameValeu": "Marisol DLT",
                "countfiltr": 36,
                "ID": 1657
            },
            {
                "nameValeu": "Melianta DLT",
                "countfiltr": 22,
                "ID": 1662
            },
            {
                "nameValeu": "Sevilla DLT",
                "countfiltr": 40,
                "ID": 1679
            },
            {
                "nameValeu": "Toledo DLT",
                "countfiltr": 42,
                "ID": 1681
            },
            {
                "nameValeu": "Altissimo DLT",
                "countfiltr": 40,
                "ID": 1625
            },
            {
                "nameValeu": "Marineo DLT",
                "countfiltr": 28,
                "ID": 1656
            },
            {
                "nameValeu": "Felitto DLT",
                "countfiltr": 24,
                "ID": 1642
            },
            {
                "nameValeu": "Fabriano DLT",
                "countfiltr": 45,
                "ID": 1641
            },
            {
                "nameValeu": "Primiero DLT",
                "countfiltr": 91,
                "ID": 1675
            },
            {
                "nameValeu": "Mezzano DLT",
                "countfiltr": 78,
                "ID": 1663
            },
            {
                "nameValeu": "Novello DLT",
                "countfiltr": 104,
                "ID": 1667
            },
            {
                "nameValeu": "Neonelli DLT",
                "countfiltr": 35,
                "ID": 1666
            },
            {
                "nameValeu": "Palmira DLT",
                "countfiltr": 37,
                "ID": 1670
            },
            {
                "nameValeu": "Patrica DLT",
                "countfiltr": 19,
                "ID": 1672
            },
            {
                "nameValeu": "Alto DLT",
                "countfiltr": 42,
                "ID": 1626
            },
            {
                "nameValeu": "Armento DLT",
                "countfiltr": 34,
                "ID": 1629
            },
            {
                "nameValeu": "Alette DLT",
                "countfiltr": 40,
                "ID": 1624
            },
            {
                "nameValeu": "Amilly DLT",
                "countfiltr": 82,
                "ID": 1627
            },
            {
                "nameValeu": "Avy DLT",
                "countfiltr": 60,
                "ID": 1631
            },
            {
                "nameValeu": "Cassel DLT",
                "countfiltr": 28,
                "ID": 1635
            },
            {
                "nameValeu": "Juilly DLT",
                "countfiltr": 49,
                "ID": 1651
            },
            {
                "nameValeu": "Marie DLT",
                "countfiltr": 20,
                "ID": 1655
            },
            {
                "nameValeu": "Marques DLT",
                "countfiltr": 41,
                "ID": 1658
            },
            {
                "nameValeu": "Saint-Michel DLT",
                "countfiltr": 52,
                "ID": 2052
            },
            {
                "nameValeu": "Roanne DLT",
                "countfiltr": 47,
                "ID": 1677
            },
            {
                "nameValeu": "Sionne DLT",
                "countfiltr": 66,
                "ID": 1680
            },
            {
                "nameValeu": "Veronne DLT",
                "countfiltr": 37,
                "ID": 1684
            },
            {
                "nameValeu": "Florange DLT",
                "countfiltr": 42,
                "ID": 1645
            },
            {
                "nameValeu": "Estrella DLT",
                "countfiltr": 64,
                "ID": 1640
            },
            {
                "nameValeu": "Cielo DLT",
                "countfiltr": 72,
                "ID": 1636
            },
            {
                "nameValeu": "Osborne DLT",
                "countfiltr": 14,
                "ID": 1668
            },
            {
                "nameValeu": "My Flower",
                "countfiltr": 40,
                "ID": 1685
            },
            {
                "nameValeu": "Catalina",
                "countfiltr": 12,
                "ID": 1686
            },
            {
                "nameValeu": "Ballerina",
                "countfiltr": 9,
                "ID": 1687
            },
            {
                "nameValeu": "Canterbury",
                "countfiltr": 16,
                "ID": 1688
            },
            {
                "nameValeu": "Tiffany BC",
                "countfiltr": 43,
                "ID": 1772
            },
            {
                "nameValeu": "Blossom DLT",
                "countfiltr": 50,
                "ID": 1689
            },
            {
                "nameValeu": "Candy Stripes DLT",
                "countfiltr": 76,
                "ID": 1690
            },
            {
                "nameValeu": "Cashmere DLT",
                "countfiltr": 79,
                "ID": 1691
            },
            {
                "nameValeu": "Colorful DLT",
                "countfiltr": 62,
                "ID": 1692
            },
            {
                "nameValeu": "Fusion DLT",
                "countfiltr": 35,
                "ID": 1693
            },
            {
                "nameValeu": "J Air DLT",
                "countfiltr": 59,
                "ID": 1694
            },
            {
                "nameValeu": "Mezzano II DLT",
                "countfiltr": 72,
                "ID": 1695
            },
            {
                "nameValeu": "Monet BC",
                "countfiltr": 10,
                "ID": 1702
            },
            {
                "nameValeu": "Medina BC",
                "countfiltr": 15,
                "ID": 1704
            },
            {
                "nameValeu": "Adam BC",
                "countfiltr": 12,
                "ID": 1705
            },
            {
                "nameValeu": "Travel BC",
                "countfiltr": 8,
                "ID": 1707
            },
            {
                "nameValeu": "Supreme DLT",
                "countfiltr": 43,
                "ID": 1696
            },
            {
                "nameValeu": "Navarra GA",
                "countfiltr": 60,
                "ID": 1712
            },
            {
                "nameValeu": "Everyday Colors 1 Natural",
                "countfiltr": 30,
                "ID": 1716
            },
            {
                "nameValeu": "Lustre",
                "countfiltr": 8,
                "ID": 668
            },
            {
                "nameValeu": "Refresh",
                "countfiltr": 22,
                "ID": 518
            },
            {
                "nameValeu": "Sensei",
                "countfiltr": 8,
                "ID": 537
            },
            {
                "nameValeu": "Starlet",
                "countfiltr": 7,
                "ID": 936
            },
            {
                "nameValeu": "Everyday Colors 2 Grey",
                "countfiltr": 38,
                "ID": 1717
            },
            {
                "nameValeu": "Bombay II",
                "countfiltr": 5,
                "ID": 662
            },
            {
                "nameValeu": "Merino",
                "countfiltr": 1,
                "ID": 591
            },
            {
                "nameValeu": "Theatre",
                "countfiltr": 1,
                "ID": 551
            },
            {
                "nameValeu": "Everyday Colors 3 Brown",
                "countfiltr": 49,
                "ID": 1718
            },
            {
                "nameValeu": "Everyday Colors 4 Blue",
                "countfiltr": 39,
                "ID": 1719
            },
            {
                "nameValeu": "Everyday Colors 5 Red",
                "countfiltr": 35,
                "ID": 1720
            },
            {
                "nameValeu": "GA Stonewash",
                "countfiltr": 2,
                "ID": 1378
            },
            {
                "nameValeu": "Charade DC",
                "countfiltr": 12,
                "ID": 1726
            },
            {
                "nameValeu": "Waltz",
                "countfiltr": 21,
                "ID": 1732
            },
            {
                "nameValeu": "Mion",
                "countfiltr": 35,
                "ID": 1733
            },
            {
                "nameValeu": "Elegance ViK",
                "countfiltr": 2,
                "ID": 1734
            },
            {
                "nameValeu": "Phalaenopsis",
                "countfiltr": 15,
                "ID": 1735
            },
            {
                "nameValeu": "Floral Land",
                "countfiltr": 13,
                "ID": 1731
            },
            {
                "nameValeu": "IO Collection",
                "countfiltr": 81,
                "ID": 1748
            },
            {
                "nameValeu": "IO Lona",
                "countfiltr": 4,
                "ID": 1749
            },
            {
                "nameValeu": "IO Lace",
                "countfiltr": 18,
                "ID": 1750
            },
            {
                "nameValeu": "IO Unique",
                "countfiltr": 14,
                "ID": 1752
            },
            {
                "nameValeu": "Nello",
                "countfiltr": 11,
                "ID": 1754
            },
            {
                "nameValeu": "IO Provence",
                "countfiltr": 4,
                "ID": 1756
            },
            {
                "nameValeu": "Shadow DLX",
                "countfiltr": 21,
                "ID": 1768
            },
            {
                "nameValeu": "Blackout Fusion CSB",
                "countfiltr": 13,
                "ID": 2054
            },
            {
                "nameValeu": "Bellamy",
                "countfiltr": 9,
                "ID": 1773
            },
            {
                "nameValeu": "Out Of Mind",
                "countfiltr": 23,
                "ID": 1775
            },
            {
                "nameValeu": "TrueOutdoorStock",
                "countfiltr": 86,
                "ID": 2302
            },
            {
                "nameValeu": "Ibiza GA",
                "countfiltr": 69,
                "ID": 1794
            },
            {
                "nameValeu": "Elixir ECD",
                "countfiltr": 64,
                "ID": 1796
            },
            {
                "nameValeu": "Structure EC",
                "countfiltr": 45,
                "ID": 2039
            },
            {
                "nameValeu": "La Vita ECD",
                "countfiltr": 88,
                "ID": 1797
            },
            {
                "nameValeu": "Matrix ECD",
                "countfiltr": 58,
                "ID": 1798
            },
            {
                "nameValeu": "California 5A",
                "countfiltr": 50,
                "ID": 1812
            },
            {
                "nameValeu": "Samarkand 5A",
                "countfiltr": 42,
                "ID": 1818
            },
            {
                "nameValeu": "Malibu 5A",
                "countfiltr": 42,
                "ID": 1819
            },
            {
                "nameValeu": "Palmyra 5A",
                "countfiltr": 49,
                "ID": 1820
            },
            {
                "nameValeu": "Kashmir WDC",
                "countfiltr": 36,
                "ID": 1823
            },
            {
                "nameValeu": "Master GA",
                "countfiltr": 44,
                "ID": 1825
            },
            {
                "nameValeu": "Roma TE",
                "countfiltr": 55,
                "ID": 1828
            },
            {
                "nameValeu": "Antichi Ricami",
                "countfiltr": 16,
                "ID": 1829
            },
            {
                "nameValeu": "Anka Advantage",
                "countfiltr": 61,
                "ID": 1922
            },
            {
                "nameValeu": "Anka Showroom",
                "countfiltr": 1,
                "ID": 1275
            },
            {
                "nameValeu": "Anka Master",
                "countfiltr": 4,
                "ID": 1277
            },
            {
                "nameValeu": "Eclectic Dimout CSB",
                "countfiltr": 12,
                "ID": 2272
            },
            {
                "nameValeu": "Bergerac Scandinavia",
                "countfiltr": 15,
                "ID": 1931
            },
            {
                "nameValeu": "Symmetric Petalos",
                "countfiltr": 16,
                "ID": 1930
            },
            {
                "nameValeu": "Prestige EC",
                "countfiltr": 29,
                "ID": 1932
            },
            {
                "nameValeu": "Poem EC",
                "countfiltr": 32,
                "ID": 1933
            },
            {
                "nameValeu": "Impulse EC",
                "countfiltr": 49,
                "ID": 1934
            },
            {
                "nameValeu": "Pergamon GA",
                "countfiltr": 2,
                "ID": 1939
            },
            {
                "nameValeu": "Antique Accessories 5A",
                "countfiltr": 265,
                "ID": 1942
            },
            {
                "nameValeu": "Chenille Accessories 5A",
                "countfiltr": 202,
                "ID": 1943
            },
            {
                "nameValeu": "Manufacturers Accessories 5A",
                "countfiltr": 84,
                "ID": 1944
            },
            {
                "nameValeu": "Oriente Accessories 5A",
                "countfiltr": 329,
                "ID": 1945
            },
            {
                "nameValeu": "Trendy Accessories 5A",
                "countfiltr": 130,
                "ID": 1946
            },
            {
                "nameValeu": "Seduzioni TE",
                "countfiltr": 44,
                "ID": 1948
            },
            {
                "nameValeu": "Ocean Jacquard Trimmings",
                "countfiltr": 85,
                "ID": 1949
            },
            {
                "nameValeu": "Atlantic DLT",
                "countfiltr": 32,
                "ID": 1952
            },
            {
                "nameValeu": "Canvas DLT",
                "countfiltr": 50,
                "ID": 1953
            },
            {
                "nameValeu": "Falcon DLT",
                "countfiltr": 76,
                "ID": 1954
            },
            {
                "nameValeu": "Imperial DLT",
                "countfiltr": 25,
                "ID": 1955
            },
            {
                "nameValeu": "Nuance DLT",
                "countfiltr": 45,
                "ID": 1956
            },
            {
                "nameValeu": "Neufeld DLT",
                "countfiltr": 35,
                "ID": 2318
            },
            {
                "nameValeu": "Thermic DLT",
                "countfiltr": 52,
                "ID": 1957
            },
            {
                "nameValeu": "Truffle DLT",
                "countfiltr": 35,
                "ID": 1958
            },
            {
                "nameValeu": "Welt DLT",
                "countfiltr": 65,
                "ID": 1959
            },
            {
                "nameValeu": "Buckle DLT",
                "countfiltr": 60,
                "ID": 1962
            },
            {
                "nameValeu": "Pastel DLT",
                "countfiltr": 71,
                "ID": 1963
            },
            {
                "nameValeu": "Pure Saten DLT",
                "countfiltr": 79,
                "ID": 1964
            },
            {
                "nameValeu": "Reflection DLT",
                "countfiltr": 29,
                "ID": 1965
            },
            {
                "nameValeu": "Shanelly DLT",
                "countfiltr": 50,
                "ID": 1966
            },
            {
                "nameValeu": "Softly DLT",
                "countfiltr": 54,
                "ID": 1967
            },
            {
                "nameValeu": "Elite TE",
                "countfiltr": 32,
                "ID": 1970
            },
            {
                "nameValeu": "June DLT",
                "countfiltr": 46,
                "ID": 1968
            },
            {
                "nameValeu": "May DLT",
                "countfiltr": 84,
                "ID": 1969
            },
            {
                "nameValeu": "Mansion DLT",
                "countfiltr": 74,
                "ID": 2053
            },
            {
                "nameValeu": "Basic Linings DLT",
                "countfiltr": 36,
                "ID": 1971
            },
            {
                "nameValeu": "Geometric DLT",
                "countfiltr": 33,
                "ID": 1972
            },
            {
                "nameValeu": "Casa Nova EC",
                "countfiltr": 46,
                "ID": 1973
            },
            {
                "nameValeu": "Saint Tropez TE",
                "countfiltr": 108,
                "ID": 1976
            },
            {
                "nameValeu": "Bellini TE",
                "countfiltr": 114,
                "ID": 1977
            },
            {
                "nameValeu": "Resort Collection KFF",
                "countfiltr": 14,
                "ID": 1978
            },
            {
                "nameValeu": "San Francisco GA",
                "countfiltr": 43,
                "ID": 1979
            },
            {
                "nameValeu": "Fenton GA",
                "countfiltr": 24,
                "ID": 1980
            },
            {
                "nameValeu": "Calipso GA",
                "countfiltr": 42,
                "ID": 1981
            },
            {
                "nameValeu": "Dinastia",
                "countfiltr": 36,
                "ID": 1983
            },
            {
                "nameValeu": "Napoli GA",
                "countfiltr": 45,
                "ID": 1987
            },
            {
                "nameValeu": "EC Trimmings 3",
                "countfiltr": 200,
                "ID": 1991
            },
            {
                "nameValeu": "Me Casa 14",
                "countfiltr": 33,
                "ID": 1996
            },
            {
                "nameValeu": "Me Casa 15",
                "countfiltr": 35,
                "ID": 1997
            },
            {
                "nameValeu": "Yves GA",
                "countfiltr": 39,
                "ID": 1999
            },
            {
                "nameValeu": "Me Casa 16",
                "countfiltr": 34,
                "ID": 1998
            },
            {
                "nameValeu": "Me Casa 17",
                "countfiltr": 59,
                "ID": 2000
            },
            {
                "nameValeu": "Me Casa 18",
                "countfiltr": 60,
                "ID": 2001
            },
            {
                "nameValeu": "Me Casa 19",
                "countfiltr": 95,
                "ID": 2002
            },
            {
                "nameValeu": "Saga LTX",
                "countfiltr": 58,
                "ID": 2365
            },
            {
                "nameValeu": "Nevio Moonway",
                "countfiltr": 81,
                "ID": 2367
            },
            {
                "nameValeu": "Cinnia",
                "countfiltr": 12,
                "ID": 2003
            },
            {
                "nameValeu": "Summer Palace",
                "countfiltr": 16,
                "ID": 2004
            },
            {
                "nameValeu": "Jacobean",
                "countfiltr": 12,
                "ID": 2006
            },
            {
                "nameValeu": "Armonico GA",
                "countfiltr": 56,
                "ID": 2023
            },
            {
                "nameValeu": "Nevio Jersey",
                "countfiltr": 115,
                "ID": 2366
            },
            {
                "nameValeu": "Simple DLT",
                "countfiltr": 58,
                "ID": 2024
            },
            {
                "nameValeu": "Nube DLT",
                "countfiltr": 42,
                "ID": 2025
            },
            {
                "nameValeu": "Nevio Moonstone",
                "countfiltr": 73,
                "ID": 2021
            },
            {
                "nameValeu": "Nevio Antonia",
                "countfiltr": 82,
                "ID": 2020
            },
            {
                "nameValeu": "Nevio Ostin",
                "countfiltr": 64,
                "ID": 2022
            },
            {
                "nameValeu": "Nevio 1",
                "countfiltr": 74,
                "ID": 2008
            },
            {
                "nameValeu": "Jamrock DLT",
                "countfiltr": 38,
                "ID": 2026
            },
            {
                "nameValeu": "Nevio 12",
                "countfiltr": 33,
                "ID": 2019
            },
            {
                "nameValeu": "Nevio 7",
                "countfiltr": 62,
                "ID": 2014
            },
            {
                "nameValeu": "Nevio 2",
                "countfiltr": 35,
                "ID": 2009
            },
            {
                "nameValeu": "Nevio 4",
                "countfiltr": 56,
                "ID": 2011
            },
            {
                "nameValeu": "Nevio 5",
                "countfiltr": 42,
                "ID": 2012
            },
            {
                "nameValeu": "Nevio 11",
                "countfiltr": 45,
                "ID": 2018
            },
            {
                "nameValeu": "Me Casa 13",
                "countfiltr": 15,
                "ID": 2027
            },
            {
                "nameValeu": "Nevio 3",
                "countfiltr": 41,
                "ID": 2010
            },
            {
                "nameValeu": "Nevio 9",
                "countfiltr": 44,
                "ID": 2016
            },
            {
                "nameValeu": "Nevio 6",
                "countfiltr": 27,
                "ID": 2013
            },
            {
                "nameValeu": "Nevio 8",
                "countfiltr": 52,
                "ID": 2015
            },
            {
                "nameValeu": "Nevio 10",
                "countfiltr": 40,
                "ID": 2017
            },
            {
                "nameValeu": "Antique WDC",
                "countfiltr": 17,
                "ID": 2028
            },
            {
                "nameValeu": "Etude WDC",
                "countfiltr": 23,
                "ID": 2029
            },
            {
                "nameValeu": "Narnia WDC",
                "countfiltr": 4,
                "ID": 2030
            },
            {
                "nameValeu": "Rodos WDC",
                "countfiltr": 38,
                "ID": 2032
            },
            {
                "nameValeu": "Medici WDC",
                "countfiltr": 13,
                "ID": 2035
            },
            {
                "nameValeu": "Dune EC",
                "countfiltr": 40,
                "ID": 2036
            },
            {
                "nameValeu": "Comfort EC",
                "countfiltr": 58,
                "ID": 2037
            },
            {
                "nameValeu": "Inteval DLT",
                "countfiltr": 39,
                "ID": 2040
            },
            {
                "nameValeu": "Crystal DLT",
                "countfiltr": 111,
                "ID": 2041
            },
            {
                "nameValeu": "Bernini GA",
                "countfiltr": 26,
                "ID": 2042
            },
            {
                "nameValeu": "Nevio Monte",
                "countfiltr": 44,
                "ID": 2043
            },
            {
                "nameValeu": "Me Casa Sale",
                "countfiltr": 45,
                "ID": 2045
            },
            {
                "nameValeu": "Davinci CSB",
                "countfiltr": 15,
                "ID": 2046
            },
            {
                "nameValeu": "Grazioso GA",
                "countfiltr": 33,
                "ID": 2047
            },
            {
                "nameValeu": "Softly GA",
                "countfiltr": 34,
                "ID": 2050
            },
            {
                "nameValeu": "Omni GA",
                "countfiltr": 24,
                "ID": 2048
            },
            {
                "nameValeu": "Sky Garden GA",
                "countfiltr": 20,
                "ID": 2049
            },
            {
                "nameValeu": "Noble Luxury DC",
                "countfiltr": 1,
                "ID": 1834
            },
            {
                "nameValeu": "Orlando GA",
                "countfiltr": 27,
                "ID": 2055
            },
            {
                "nameValeu": "Regent GA",
                "countfiltr": 39,
                "ID": 2056
            },
            {
                "nameValeu": "Myconian Out Door",
                "countfiltr": 20,
                "ID": 2057
            },
            {
                "nameValeu": "Alston",
                "countfiltr": 18,
                "ID": 2058
            },
            {
                "nameValeu": "Troy GA",
                "countfiltr": 28,
                "ID": 2059
            },
            {
                "nameValeu": "Tapiz",
                "countfiltr": 5,
                "ID": 2060
            },
            {
                "nameValeu": "Maldives GA",
                "countfiltr": 55,
                "ID": 2061
            },
            {
                "nameValeu": "Paloma GA",
                "countfiltr": 46,
                "ID": 2062
            },
            {
                "nameValeu": "Gemstone EC",
                "countfiltr": 69,
                "ID": 2064
            },
            {
                "nameValeu": "Littoral DL",
                "countfiltr": 46,
                "ID": 2068
            },
            {
                "nameValeu": "Light Up DL",
                "countfiltr": 48,
                "ID": 2069
            },
            {
                "nameValeu": "Utopia EC",
                "countfiltr": 58,
                "ID": 2065
            },
            {
                "nameValeu": "Cosmos DL",
                "countfiltr": 61,
                "ID": 2070
            },
            {
                "nameValeu": "Ambience DL",
                "countfiltr": 59,
                "ID": 2072
            },
            {
                "nameValeu": "Grain DL",
                "countfiltr": 59,
                "ID": 2071
            },
            {
                "nameValeu": "Manhattan EC",
                "countfiltr": 100,
                "ID": 2063
            },
            {
                "nameValeu": "Maisonin Outlet",
                "countfiltr": 103,
                "ID": 2074
            },
            {
                "nameValeu": "Ornament GA",
                "countfiltr": 14,
                "ID": 2076
            },
            {
                "nameValeu": "Mojito GA",
                "countfiltr": 35,
                "ID": 2078
            },
            {
                "nameValeu": "Gusto GA",
                "countfiltr": 34,
                "ID": 2077
            },
            {
                "nameValeu": "Pradera DCR",
                "countfiltr": 13,
                "ID": 4986
            },
            {
                "nameValeu": "Nomad CSB",
                "countfiltr": 10,
                "ID": 2080
            },
            {
                "nameValeu": "Timeless CSB",
                "countfiltr": 13,
                "ID": 2081
            },
            {
                "nameValeu": "Jolie CSB",
                "countfiltr": 20,
                "ID": 2079
            },
            {
                "nameValeu": "Charisma 5A",
                "countfiltr": 60,
                "ID": 2083
            },
            {
                "nameValeu": "Symphony WDC",
                "countfiltr": 48,
                "ID": 2084
            },
            {
                "nameValeu": "Ginza 5A",
                "countfiltr": 50,
                "ID": 2086
            },
            {
                "nameValeu": "Trilogia REA",
                "countfiltr": 65,
                "ID": 2088
            },
            {
                "nameValeu": "Tulle TRN",
                "countfiltr": 69,
                "ID": 2087
            },
            {
                "nameValeu": "Urban Oasis TRN",
                "countfiltr": 77,
                "ID": 2094
            },
            {
                "nameValeu": "Nuova Grand TRN",
                "countfiltr": 42,
                "ID": 2095
            },
            {
                "nameValeu": "Novello TRN",
                "countfiltr": 55,
                "ID": 2101
            },
            {
                "nameValeu": "Outdoor REA",
                "countfiltr": 45,
                "ID": 2091
            },
            {
                "nameValeu": "Elegance ESPZ",
                "countfiltr": 86,
                "ID": 6544
            },
            {
                "nameValeu": "Greek REA",
                "countfiltr": 22,
                "ID": 2093
            },
            {
                "nameValeu": "Quartet S REA",
                "countfiltr": 52,
                "ID": 2096
            },
            {
                "nameValeu": "Fargo 5A",
                "countfiltr": 49,
                "ID": 2097
            },
            {
                "nameValeu": "Almatex Sale",
                "countfiltr": 33,
                "ID": 2099
            },
            {
                "nameValeu": "Zafiro ALM",
                "countfiltr": 39,
                "ID": 2100
            },
            {
                "nameValeu": "Soto Grande REA",
                "countfiltr": 14,
                "ID": 2104
            },
            {
                "nameValeu": "New Year REA",
                "countfiltr": 27,
                "ID": 2179
            },
            {
                "nameValeu": "Romance REA",
                "countfiltr": 24,
                "ID": 2106
            },
            {
                "nameValeu": "Balu REA",
                "countfiltr": 34,
                "ID": 2110
            },
            {
                "nameValeu": "Devore New REA",
                "countfiltr": 9,
                "ID": 2112
            },
            {
                "nameValeu": "Viona ESPZ",
                "countfiltr": 57,
                "ID": 6543
            },
            {
                "nameValeu": "Paradise GA",
                "countfiltr": 38,
                "ID": 2113
            },
            {
                "nameValeu": "Natural 5A",
                "countfiltr": 45,
                "ID": 2115
            },
            {
                "nameValeu": "Capital GA",
                "countfiltr": 41,
                "ID": 2114
            },
            {
                "nameValeu": "Romano 5A",
                "countfiltr": 40,
                "ID": 2120
            },
            {
                "nameValeu": "Romantic Esperanza",
                "countfiltr": 55,
                "ID": 2122
            },
            {
                "nameValeu": "Le Premier NVL",
                "countfiltr": 69,
                "ID": 2090
            },
            {
                "nameValeu": "Murakami 5A",
                "countfiltr": 50,
                "ID": 2124
            },
            {
                "nameValeu": "Pina 3 ANKA",
                "countfiltr": 24,
                "ID": 2133
            },
            {
                "nameValeu": "Pina 2 ANKA",
                "countfiltr": 7,
                "ID": 2132
            },
            {
                "nameValeu": "Pina 1 ANKA",
                "countfiltr": 3,
                "ID": 2131
            },
            {
                "nameValeu": "Pina 4 ANKA",
                "countfiltr": 7,
                "ID": 2137
            },
            {
                "nameValeu": "Pina 5 ANKA",
                "countfiltr": 2,
                "ID": 2138
            },
            {
                "nameValeu": "Pina 6 ANKA",
                "countfiltr": 1,
                "ID": 2139
            },
            {
                "nameValeu": "Pina 8 ANKA",
                "countfiltr": 1,
                "ID": 2141
            },
            {
                "nameValeu": "Pina 7 ANKA",
                "countfiltr": 3,
                "ID": 2140
            },
            {
                "nameValeu": "Alcantara Alchimia",
                "countfiltr": 42,
                "ID": 2142
            },
            {
                "nameValeu": "Aquarius VIS",
                "countfiltr": 86,
                "ID": 6550
            },
            {
                "nameValeu": "Jardin REA",
                "countfiltr": 34,
                "ID": 2178
            },
            {
                "nameValeu": "Dali ALM",
                "countfiltr": 82,
                "ID": 2180
            },
            {
                "nameValeu": "Louvre ALM",
                "countfiltr": 24,
                "ID": 2181
            },
            {
                "nameValeu": "Vienna 9-1 VIS",
                "countfiltr": 34,
                "ID": 2182
            },
            {
                "nameValeu": "Amare VIS",
                "countfiltr": 35,
                "ID": 2183
            },
            {
                "nameValeu": "Maisonin Essential",
                "countfiltr": 120,
                "ID": 2075
            },
            {
                "nameValeu": "Terranova GA",
                "countfiltr": 46,
                "ID": 2186
            },
            {
                "nameValeu": "Dessange Classic",
                "countfiltr": 174,
                "ID": 2193
            },
            {
                "nameValeu": "Dessange Natural",
                "countfiltr": 214,
                "ID": 2191
            },
            {
                "nameValeu": "Dessange Luxury",
                "countfiltr": 155,
                "ID": 2192
            },
            {
                "nameValeu": "Vitex Child",
                "countfiltr": 37,
                "ID": 107
            },
            {
                "nameValeu": "Vitex Sale",
                "countfiltr": 96,
                "ID": 2195
            },
            {
                "nameValeu": "Vitex Briliance",
                "countfiltr": 90,
                "ID": 116
            },
            {
                "nameValeu": "Vitex Basic",
                "countfiltr": 85,
                "ID": 2196
            },
            {
                "nameValeu": "Easy Elegance VIT",
                "countfiltr": 54,
                "ID": 2197
            },
            {
                "nameValeu": "Fashion for Window VIT",
                "countfiltr": 102,
                "ID": 2199
            },
            {
                "nameValeu": "Fashion for Window 2 VIT",
                "countfiltr": 65,
                "ID": 2200
            },
            {
                "nameValeu": "Instinct CSB",
                "countfiltr": 24,
                "ID": 2204
            },
            {
                "nameValeu": "Easy Elegance 2 VIT",
                "countfiltr": 67,
                "ID": 2198
            },
            {
                "nameValeu": "Red Collection",
                "countfiltr": 523,
                "ID": 2206
            },
            {
                "nameValeu": "Trezor GA",
                "countfiltr": 45,
                "ID": 2208
            },
            {
                "nameValeu": "Nevio Studio Trento",
                "countfiltr": 31,
                "ID": 2210
            },
            {
                "nameValeu": "Nevio Studio Elise",
                "countfiltr": 48,
                "ID": 2209
            },
            {
                "nameValeu": "Nevio Latteo",
                "countfiltr": 44,
                "ID": 2286
            },
            {
                "nameValeu": "Nevio Luna",
                "countfiltr": 46,
                "ID": 2287
            },
            {
                "nameValeu": "Ida DLT",
                "countfiltr": 63,
                "ID": 2215
            },
            {
                "nameValeu": "Mantel Tablecloth VIP",
                "countfiltr": 50,
                "ID": 2217
            },
            {
                "nameValeu": "Floris DLT",
                "countfiltr": 36,
                "ID": 2218
            },
            {
                "nameValeu": "Jardin DCR",
                "countfiltr": 10,
                "ID": 4985
            },
            {
                "nameValeu": "Benissa VIP",
                "countfiltr": 70,
                "ID": 2219
            },
            {
                "nameValeu": "Pelage 121 ULT",
                "countfiltr": 45,
                "ID": 2226
            },
            {
                "nameValeu": "Lustrous 120 ULT",
                "countfiltr": 46,
                "ID": 2227
            },
            {
                "nameValeu": "Impression 122 ULT",
                "countfiltr": 43,
                "ID": 2228
            },
            {
                "nameValeu": "Impression 123 ULT",
                "countfiltr": 65,
                "ID": 2229
            },
            {
                "nameValeu": "Carat VIP",
                "countfiltr": 76,
                "ID": 2220
            },
            {
                "nameValeu": "Mollidis VIP",
                "countfiltr": 33,
                "ID": 2221
            },
            {
                "nameValeu": "Monte VIP",
                "countfiltr": 53,
                "ID": 2222
            },
            {
                "nameValeu": "Piola VIP",
                "countfiltr": 79,
                "ID": 2223
            },
            {
                "nameValeu": "Ballad VIP",
                "countfiltr": 85,
                "ID": 2231
            },
            {
                "nameValeu": "Nenis Molli",
                "countfiltr": 88,
                "ID": 2232
            },
            {
                "nameValeu": "Monalisa VIP",
                "countfiltr": 51,
                "ID": 2233
            },
            {
                "nameValeu": "Monalisa Embrodery VIP",
                "countfiltr": 40,
                "ID": 2235
            },
            {
                "nameValeu": "Sylvie GA",
                "countfiltr": 29,
                "ID": 2237
            },
            {
                "nameValeu": "Satize 2012 ULT",
                "countfiltr": 89,
                "ID": 2239
            },
            {
                "nameValeu": "English Blossom REA",
                "countfiltr": 35,
                "ID": 2240
            },
            {
                "nameValeu": "Winter Drizzle 215 ULT",
                "countfiltr": 67,
                "ID": 2241
            },
            {
                "nameValeu": "Springfield 1321 ULT",
                "countfiltr": 63,
                "ID": 2242
            },
            {
                "nameValeu": "Montage 216 ULT",
                "countfiltr": 46,
                "ID": 2243
            },
            {
                "nameValeu": "Impression 494 ULT",
                "countfiltr": 55,
                "ID": 2244
            },
            {
                "nameValeu": "Elements 217 ULT",
                "countfiltr": 41,
                "ID": 2245
            },
            {
                "nameValeu": "Hues 218 ULT",
                "countfiltr": 42,
                "ID": 2246
            },
            {
                "nameValeu": "Hues 219 ULT",
                "countfiltr": 48,
                "ID": 2247
            },
            {
                "nameValeu": "Amalfi GA",
                "countfiltr": 44,
                "ID": 2248
            },
            {
                "nameValeu": "Agora Acrisol",
                "countfiltr": 24,
                "ID": 2249
            },
            {
                "nameValeu": "Agora Outdoor",
                "countfiltr": 122,
                "ID": 2250
            },
            {
                "nameValeu": "Amethyst Trimmings",
                "countfiltr": 118,
                "ID": 2251
            },
            {
                "nameValeu": "Grada Air",
                "countfiltr": 63,
                "ID": 2252
            },
            {
                "nameValeu": "Legenda DRD",
                "countfiltr": 41,
                "ID": 2254
            },
            {
                "nameValeu": "Desert Hues 212 ULT",
                "countfiltr": 56,
                "ID": 2259
            },
            {
                "nameValeu": "Autumn Haze 213 ULT",
                "countfiltr": 54,
                "ID": 2260
            },
            {
                "nameValeu": "Clear Skies 214 ULT",
                "countfiltr": 57,
                "ID": 2261
            },
            {
                "nameValeu": "The Clouds EC",
                "countfiltr": 48,
                "ID": 2264
            },
            {
                "nameValeu": "Cape Town EC",
                "countfiltr": 70,
                "ID": 2263
            },
            {
                "nameValeu": "Prince GA",
                "countfiltr": 40,
                "ID": 2267
            },
            {
                "nameValeu": "Romantic WDC",
                "countfiltr": 24,
                "ID": 2268
            },
            {
                "nameValeu": "Tocco di Seta GA",
                "countfiltr": 30,
                "ID": 2270
            },
            {
                "nameValeu": "Tartan GA",
                "countfiltr": 32,
                "ID": 2271
            },
            {
                "nameValeu": "Victorian MLN",
                "countfiltr": 31,
                "ID": 2276
            },
            {
                "nameValeu": "Loft MLN",
                "countfiltr": 13,
                "ID": 2277
            },
            {
                "nameValeu": "Naturel MLN",
                "countfiltr": 49,
                "ID": 2279
            },
            {
                "nameValeu": "Basic MLN",
                "countfiltr": 244,
                "ID": 2280
            },
            {
                "nameValeu": "Minimalism MLN",
                "countfiltr": 8,
                "ID": 2281
            },
            {
                "nameValeu": "Runa TXD",
                "countfiltr": 29,
                "ID": 2282
            },
            {
                "nameValeu": "Luminiscence 1 2029 ULT",
                "countfiltr": 90,
                "ID": 2283
            },
            {
                "nameValeu": "Nevio Terra",
                "countfiltr": 40,
                "ID": 2289
            },
            {
                "nameValeu": "Nevio Mercurio",
                "countfiltr": 41,
                "ID": 2288
            },
            {
                "nameValeu": "Alba ATF",
                "countfiltr": 68,
                "ID": 2292
            },
            {
                "nameValeu": "Jade GA",
                "countfiltr": 63,
                "ID": 2300
            },
            {
                "nameValeu": "Felicity DL",
                "countfiltr": 100,
                "ID": 2305
            },
            {
                "nameValeu": "Duck CSF",
                "countfiltr": 159,
                "ID": 2307
            },
            {
                "nameValeu": "Outdoor CSF",
                "countfiltr": 87,
                "ID": 2312
            },
            {
                "nameValeu": "Cotton Deco CSF",
                "countfiltr": 20,
                "ID": 2313
            },
            {
                "nameValeu": "Tablecloth CSF",
                "countfiltr": 46,
                "ID": 2314
            },
            {
                "nameValeu": "Sunbrella Bahia",
                "countfiltr": 48,
                "ID": 2316
            },
            {
                "nameValeu": "SB Pink Center",
                "countfiltr": 12,
                "ID": 2323
            },
            {
                "nameValeu": "SB Divided By Blue",
                "countfiltr": 12,
                "ID": 2322
            },
            {
                "nameValeu": "Sunbrella Odyssey",
                "countfiltr": 29,
                "ID": 2317
            },
            {
                "nameValeu": "SB Interior and Outdoor",
                "countfiltr": 97,
                "ID": 1351
            },
            {
                "nameValeu": "Outfit DLT",
                "countfiltr": 69,
                "ID": 2319
            },
            {
                "nameValeu": "Etude DLT",
                "countfiltr": 40,
                "ID": 2320
            },
            {
                "nameValeu": "SB XL",
                "countfiltr": 35,
                "ID": 1353
            },
            {
                "nameValeu": "SB XL Russia",
                "countfiltr": 11,
                "ID": 2321
            },
            {
                "nameValeu": "Soprano GA",
                "countfiltr": 28,
                "ID": 2326
            },
            {
                "nameValeu": "Aruba GA",
                "countfiltr": 1,
                "ID": 2327
            },
            {
                "nameValeu": "Amenti Garden",
                "countfiltr": 35,
                "ID": 2331
            },
            {
                "nameValeu": "Dublin 5A",
                "countfiltr": 49,
                "ID": 2333
            },
            {
                "nameValeu": "Rhapsody 5A",
                "countfiltr": 33,
                "ID": 2335
            },
            {
                "nameValeu": "Helsinki VNS",
                "countfiltr": 82,
                "ID": 2338
            },
            {
                "nameValeu": "Harrison GA",
                "countfiltr": 40,
                "ID": 2339
            },
            {
                "nameValeu": "Bianca CSB",
                "countfiltr": 8,
                "ID": 2369
            },
            {
                "nameValeu": "Yvie CSB",
                "countfiltr": 8,
                "ID": 2383
            },
            {
                "nameValeu": "Constantia CSB",
                "countfiltr": 8,
                "ID": 2384
            },
            {
                "nameValeu": "Reflection FR EC",
                "countfiltr": 42,
                "ID": 2390
            },
            {
                "nameValeu": "Nyx CSB",
                "countfiltr": 24,
                "ID": 2392
            },
            {
                "nameValeu": "Lykia GA",
                "countfiltr": 33,
                "ID": 2394
            },
            {
                "nameValeu": "Dominante EC",
                "countfiltr": 77,
                "ID": 2399
            },
            {
                "nameValeu": "Siesta WNDC",
                "countfiltr": 30,
                "ID": 2400
            },
            {
                "nameValeu": "Quantum ESPZ",
                "countfiltr": 50,
                "ID": 2401
            },
            {
                "nameValeu": "Baroque GA",
                "countfiltr": 37,
                "ID": 2402
            },
            {
                "nameValeu": "Ellada WNDC",
                "countfiltr": 30,
                "ID": 2403
            },
            {
                "nameValeu": "Indira WNDC",
                "countfiltr": 34,
                "ID": 2404
            },
            {
                "nameValeu": "Argo 5A",
                "countfiltr": 48,
                "ID": 2405
            },
            {
                "nameValeu": "Alice Garden CSB",
                "countfiltr": 8,
                "ID": 2408
            },
            {
                "nameValeu": "Sweet Flower CSB",
                "countfiltr": 8,
                "ID": 2407
            },
            {
                "nameValeu": "BC Sale",
                "countfiltr": 1,
                "ID": 1262
            },
            {
                "nameValeu": "Elegance CSB",
                "countfiltr": 10,
                "ID": 2412
            },
            {
                "nameValeu": "Welfare DLT",
                "countfiltr": 50,
                "ID": 2423
            },
            {
                "nameValeu": "Black Collection DSS",
                "countfiltr": 249,
                "ID": 2425
            },
            {
                "nameValeu": "Asmara TD",
                "countfiltr": 50,
                "ID": 2429
            },
            {
                "nameValeu": "Moments EC",
                "countfiltr": 35,
                "ID": 2430
            },
            {
                "nameValeu": "Maltinto LVN",
                "countfiltr": 15,
                "ID": 4881
            },
            {
                "nameValeu": "Excellent OINT",
                "countfiltr": 51,
                "ID": 4883
            },
            {
                "nameValeu": "Lapena OINT",
                "countfiltr": 52,
                "ID": 4884
            },
            {
                "nameValeu": "Cuadro LIV",
                "countfiltr": 42,
                "ID": 4885
            },
            {
                "nameValeu": "Secundus FCL",
                "countfiltr": 88,
                "ID": 4888
            },
            {
                "nameValeu": "Siesta EC",
                "countfiltr": 108,
                "ID": 4892
            },
            {
                "nameValeu": "Hoku LTX",
                "countfiltr": 22,
                "ID": 4893
            },
            {
                "nameValeu": "Leda LTX",
                "countfiltr": 29,
                "ID": 4894
            },
            {
                "nameValeu": "Mira LTX",
                "countfiltr": 6,
                "ID": 4895
            },
            {
                "nameValeu": "Vega LTX",
                "countfiltr": 28,
                "ID": 4898
            },
            {
                "nameValeu": "Ursa LTX",
                "countfiltr": 28,
                "ID": 4897
            },
            {
                "nameValeu": "Komodo NEV",
                "countfiltr": 36,
                "ID": 4917
            },
            {
                "nameValeu": "Tempo 5A",
                "countfiltr": 29,
                "ID": 4900
            },
            {
                "nameValeu": "Elysium EC",
                "countfiltr": 83,
                "ID": 4901
            },
            {
                "nameValeu": "Minerva GA",
                "countfiltr": 25,
                "ID": 4902
            },
            {
                "nameValeu": "Henrietta CSB",
                "countfiltr": 15,
                "ID": 4903
            },
            {
                "nameValeu": "Ever EC",
                "countfiltr": 106,
                "ID": 4904
            },
            {
                "nameValeu": "Galle GA",
                "countfiltr": 29,
                "ID": 4905
            },
            {
                "nameValeu": "Pepita GA",
                "countfiltr": 39,
                "ID": 4906
            },
            {
                "nameValeu": "Martini GA",
                "countfiltr": 41,
                "ID": 4907
            },
            {
                "nameValeu": "San Marco GA",
                "countfiltr": 30,
                "ID": 4908
            },
            {
                "nameValeu": "Alicante GA",
                "countfiltr": 44,
                "ID": 4909
            },
            {
                "nameValeu": "Fresno DLT",
                "countfiltr": 41,
                "ID": 4910
            },
            {
                "nameValeu": "Principessa CSB",
                "countfiltr": 12,
                "ID": 4911
            },
            {
                "nameValeu": "Giverny NEV",
                "countfiltr": 39,
                "ID": 4914
            },
            {
                "nameValeu": "Grandiflora NEV",
                "countfiltr": 31,
                "ID": 4912
            },
            {
                "nameValeu": "Monteverde NEV",
                "countfiltr": 43,
                "ID": 4913
            },
            {
                "nameValeu": "Bauhaus NEV",
                "countfiltr": 21,
                "ID": 4915
            },
            {
                "nameValeu": "Mumbai NEV",
                "countfiltr": 26,
                "ID": 4918
            },
            {
                "nameValeu": "Luminous NEV",
                "countfiltr": 51,
                "ID": 4916
            },
            {
                "nameValeu": "Magnetic NEV",
                "countfiltr": 73,
                "ID": 4920
            },
            {
                "nameValeu": "Rainbow WDC",
                "countfiltr": 43,
                "ID": 4923
            },
            {
                "nameValeu": "Art Seasons EC",
                "countfiltr": 63,
                "ID": 4924
            },
            {
                "nameValeu": "Domino NEV",
                "countfiltr": 33,
                "ID": 4926
            },
            {
                "nameValeu": "Doric 126 ULT",
                "countfiltr": 51,
                "ID": 4927
            },
            {
                "nameValeu": "Renoir 127 ULT",
                "countfiltr": 153,
                "ID": 4928
            },
            {
                "nameValeu": "Dali 129 ULT",
                "countfiltr": 58,
                "ID": 4930
            },
            {
                "nameValeu": "Mondrian 130 ULT",
                "countfiltr": 59,
                "ID": 4931
            },
            {
                "nameValeu": "Urban 220 ULT",
                "countfiltr": 63,
                "ID": 4932
            },
            {
                "nameValeu": "Dunes 221 ULT",
                "countfiltr": 56,
                "ID": 4933
            },
            {
                "nameValeu": "Coastal 222 ULT",
                "countfiltr": 60,
                "ID": 4934
            },
            {
                "nameValeu": "Shimmer 1342 ULT",
                "countfiltr": 45,
                "ID": 4937
            },
            {
                "nameValeu": "Luminiscence 2 2030 ULT",
                "countfiltr": 80,
                "ID": 4938
            },
            {
                "nameValeu": "Avant 2034 ULT",
                "countfiltr": 52,
                "ID": 4939
            },
            {
                "nameValeu": "Alcazar 2035 ULT",
                "countfiltr": 46,
                "ID": 4940
            },
            {
                "nameValeu": "Arcadia 2036 ULT",
                "countfiltr": 64,
                "ID": 4941
            },
            {
                "nameValeu": "Decameron EC",
                "countfiltr": 51,
                "ID": 4942
            },
            {
                "nameValeu": "Impulse NEV",
                "countfiltr": 41,
                "ID": 4943
            },
            {
                "nameValeu": "Meadows NEV",
                "countfiltr": 46,
                "ID": 4944
            },
            {
                "nameValeu": "Quantum NEV",
                "countfiltr": 59,
                "ID": 4945
            },
            {
                "nameValeu": "Nevio Latteo II",
                "countfiltr": 29,
                "ID": 4946
            },
            {
                "nameValeu": "Rhinestone 2037 ULT",
                "countfiltr": 88,
                "ID": 4947
            },
            {
                "nameValeu": "Keystone NEV",
                "countfiltr": 51,
                "ID": 4949
            },
            {
                "nameValeu": "Vermentino GA",
                "countfiltr": 51,
                "ID": 4950
            },
            {
                "nameValeu": "Sorte VIP",
                "countfiltr": 62,
                "ID": 5005
            },
            {
                "nameValeu": "Super Blackout DCR",
                "countfiltr": 19,
                "ID": 4951
            },
            {
                "nameValeu": "Lucas GA",
                "countfiltr": 41,
                "ID": 4958
            },
            {
                "nameValeu": "Matrix GA",
                "countfiltr": 31,
                "ID": 4964
            },
            {
                "nameValeu": "Naomi DLT",
                "countfiltr": 39,
                "ID": 4970
            },
            {
                "nameValeu": "Stefany DLT",
                "countfiltr": 48,
                "ID": 4971
            },
            {
                "nameValeu": "Outboho DLT",
                "countfiltr": 57,
                "ID": 4972
            },
            {
                "nameValeu": "La Boheme VNST",
                "countfiltr": 64,
                "ID": 4975
            },
            {
                "nameValeu": "Soft TRN",
                "countfiltr": 44,
                "ID": 4976
            },
            {
                "nameValeu": "Sonata TRN",
                "countfiltr": 55,
                "ID": 4977
            },
            {
                "nameValeu": "Abeille TRN",
                "countfiltr": 69,
                "ID": 4978
            },
            {
                "nameValeu": "Monte Baldo TRN",
                "countfiltr": 47,
                "ID": 4979
            },
            {
                "nameValeu": "Osaka MCS",
                "countfiltr": 44,
                "ID": 4980
            },
            {
                "nameValeu": "Lexington CSB",
                "countfiltr": 9,
                "ID": 4981
            },
            {
                "nameValeu": "Romantique CSB",
                "countfiltr": 8,
                "ID": 4982
            },
            {
                "nameValeu": "Porto GA",
                "countfiltr": 22,
                "ID": 4983
            },
            {
                "nameValeu": "Nagano NEV",
                "countfiltr": 48,
                "ID": 4984
            },
            {
                "nameValeu": "Natural Vibes DCR",
                "countfiltr": 38,
                "ID": 6535
            },
            {
                "nameValeu": "Jaipur 5A",
                "countfiltr": 42,
                "ID": 4987
            },
            {
                "nameValeu": "Provence 5A",
                "countfiltr": 54,
                "ID": 4988
            },
            {
                "nameValeu": "Siesta GA",
                "countfiltr": 16,
                "ID": 4989
            },
            {
                "nameValeu": "Natural GA",
                "countfiltr": 27,
                "ID": 4990
            },
            {
                "nameValeu": "Malaga GA",
                "countfiltr": 21,
                "ID": 4992
            },
            {
                "nameValeu": "Aura GA",
                "countfiltr": 57,
                "ID": 4991
            },
            {
                "nameValeu": "Tavira NEV",
                "countfiltr": 32,
                "ID": 4996
            },
            {
                "nameValeu": "Amarante NEV",
                "countfiltr": 30,
                "ID": 4993
            },
            {
                "nameValeu": "Azores NEV",
                "countfiltr": 40,
                "ID": 4994
            },
            {
                "nameValeu": "Ternura NEV",
                "countfiltr": 41,
                "ID": 4995
            },
            {
                "nameValeu": "Bogatell NEV",
                "countfiltr": 77,
                "ID": 4998
            },
            {
                "nameValeu": "Algarve NEV",
                "countfiltr": 55,
                "ID": 4997
            },
            {
                "nameValeu": "Dorset NEV",
                "countfiltr": 78,
                "ID": 4999
            },
            {
                "nameValeu": "Everland NEV",
                "countfiltr": 24,
                "ID": 5000
            },
            {
                "nameValeu": "Sofia Trio",
                "countfiltr": 12,
                "ID": 5001
            },
            {
                "nameValeu": "Gotland DLT",
                "countfiltr": 31,
                "ID": 5002
            },
            {
                "nameValeu": "Tulle WGA",
                "countfiltr": 93,
                "ID": 6525
            },
            {
                "nameValeu": "Belleza VIP",
                "countfiltr": 58,
                "ID": 5004
            },
            {
                "nameValeu": "Golden GA",
                "countfiltr": 28,
                "ID": 5006
            },
            {
                "nameValeu": "Goteborg MCS",
                "countfiltr": 36,
                "ID": 5007
            },
            {
                "nameValeu": "Seasons GA",
                "countfiltr": 22,
                "ID": 5008
            },
            {
                "nameValeu": "Outland DLT",
                "countfiltr": 93,
                "ID": 6515
            },
            {
                "nameValeu": "Korso NEV",
                "countfiltr": 42,
                "ID": 6514
            },
            {
                "nameValeu": "Berbera NEV",
                "countfiltr": 36,
                "ID": 6556
            },
            {
                "nameValeu": "Rainforest CSB",
                "countfiltr": 10,
                "ID": 6522
            },
            {
                "nameValeu": "Flyer CSB",
                "countfiltr": 7,
                "ID": 6523
            },
            {
                "nameValeu": "Bongo GA",
                "countfiltr": 18,
                "ID": 6524
            },
            {
                "nameValeu": "Gronzo MCS",
                "countfiltr": 50,
                "ID": 6520
            },
            {
                "nameValeu": "Lemvig MCS",
                "countfiltr": 63,
                "ID": 6519
            },
            {
                "nameValeu": "Bergen MCS",
                "countfiltr": 52,
                "ID": 6521
            },
            {
                "nameValeu": "Mantra MCS",
                "countfiltr": 20,
                "ID": 6517
            },
            {
                "nameValeu": "Nepal MCS",
                "countfiltr": 22,
                "ID": 6516
            },
            {
                "nameValeu": "Lama MCS",
                "countfiltr": 32,
                "ID": 6518
            },
            {
                "nameValeu": "English Garden 5A",
                "countfiltr": 42,
                "ID": 6527
            },
            {
                "nameValeu": "Trend ALD",
                "countfiltr": 11,
                "ID": 6533
            },
            {
                "nameValeu": "Leaves ALD",
                "countfiltr": 16,
                "ID": 6532
            },
            {
                "nameValeu": "Cambridge ALD",
                "countfiltr": 21,
                "ID": 6530
            },
            {
                "nameValeu": "Geometry ALD",
                "countfiltr": 15,
                "ID": 6531
            },
            {
                "nameValeu": "Table Wiya",
                "countfiltr": 32,
                "ID": 6536
            },
            {
                "nameValeu": "Prestige WDC",
                "countfiltr": 31,
                "ID": 6537
            },
            {
                "nameValeu": "Chenille ESPZ",
                "countfiltr": 45,
                "ID": 6538
            },
            {
                "nameValeu": "Antwerp GA",
                "countfiltr": 33,
                "ID": 6539
            },
            {
                "nameValeu": "Marrakesh GA",
                "countfiltr": 41,
                "ID": 6540
            },
            {
                "nameValeu": "Salvia VIS",
                "countfiltr": 41,
                "ID": 6545
            },
            {
                "nameValeu": "Chicago TD",
                "countfiltr": 42,
                "ID": 6546
            },
            {
                "nameValeu": "Serenity GA",
                "countfiltr": 22,
                "ID": 6547
            },
            {
                "nameValeu": "Vincent GA",
                "countfiltr": 50,
                "ID": 6541
            },
            {
                "nameValeu": "Compliment EC",
                "countfiltr": 84,
                "ID": 6526
            },
            {
                "nameValeu": "Perfecto VIP",
                "countfiltr": 121,
                "ID": 6551
            },
            {
                "nameValeu": "Stella VIP",
                "countfiltr": 77,
                "ID": 6552
            },
            {
                "nameValeu": "Kerala GA",
                "countfiltr": 24,
                "ID": 6553
            },
            {
                "nameValeu": "Natural PD",
                "countfiltr": 16,
                "ID": 6554
            },
            {
                "nameValeu": "Unique NOP",
                "countfiltr": 5,
                "ID": 6555
            },
            {
                "nameValeu": "Lifestyle REA",
                "countfiltr": 44,
                "ID": 6557
            },
            {
                "nameValeu": "Architector ATF",
                "countfiltr": 18,
                "ID": 6560
            },
            {
                "nameValeu": "Daphnia ATF",
                "countfiltr": 40,
                "ID": 6561
            },
            {
                "nameValeu": "Twinkle ATF",
                "countfiltr": 35,
                "ID": 6564
            },
            {
                "nameValeu": "Bild DCR",
                "countfiltr": 6,
                "ID": 6565
            },
            {
                "nameValeu": "Santorini GA",
                "countfiltr": 36,
                "ID": 6566
            },
            {
                "nameValeu": "Albion EC",
                "countfiltr": 92,
                "ID": 6568
            },
            {
                "nameValeu": "Brilliant WDC",
                "countfiltr": 30,
                "ID": 6569
            }
        ]
    },
    {
        "ID": "24",
        "NAME": "Серия",
        "CODE": "series",
        "PROPERTY_TYPE": "L",
        "LIST_TYPE": "L",
        "DISPLAY_TYPE": "F",
        "PROPERTY_VALUE": [
            {
                "nameValeu": "Pireo",
                "countfiltr": 16,
                "ID": 89
            },
            {
                "nameValeu": "Rustica",
                "countfiltr": 3,
                "ID": 122
            },
            {
                "nameValeu": "Sunrise",
                "countfiltr": 12,
                "ID": 123
            },
            {
                "nameValeu": "Cotonelo",
                "countfiltr": 355,
                "ID": 1358
            },
            {
                "nameValeu": "Shadow",
                "countfiltr": 2,
                "ID": 190
            },
            {
                "nameValeu": "W628",
                "countfiltr": 9,
                "ID": 1767
            },
            {
                "nameValeu": "Azov",
                "countfiltr": 33,
                "ID": 117
            },
            {
                "nameValeu": "Anka Saten",
                "countfiltr": 56,
                "ID": 855
            },
            {
                "nameValeu": "Rafael Gandia 280",
                "countfiltr": 3,
                "ID": 1138
            },
            {
                "nameValeu": "ViK Satin",
                "countfiltr": 26,
                "ID": 1109
            },
            {
                "nameValeu": "Rustica Lino",
                "countfiltr": 14,
                "ID": 629
            },
            {
                "nameValeu": "Louvre",
                "countfiltr": 33,
                "ID": 633
            },
            {
                "nameValeu": "Dolce Lino",
                "countfiltr": 8,
                "ID": 100
            },
            {
                "nameValeu": "Tendaggi",
                "countfiltr": 17,
                "ID": 147
            },
            {
                "nameValeu": "Prado",
                "countfiltr": 16,
                "ID": 655
            },
            {
                "nameValeu": "Bering",
                "countfiltr": 2,
                "ID": 90
            },
            {
                "nameValeu": "Java",
                "countfiltr": 7,
                "ID": 106
            },
            {
                "nameValeu": "Energy",
                "countfiltr": 16,
                "ID": 642
            },
            {
                "nameValeu": "Amasra Plain",
                "countfiltr": 12,
                "ID": 871
            },
            {
                "nameValeu": "Avon",
                "countfiltr": 23,
                "ID": 787
            },
            {
                "nameValeu": "Haymana Plain",
                "countfiltr": 11,
                "ID": 845
            },
            {
                "nameValeu": "Ipek Tafta",
                "countfiltr": 14,
                "ID": 738
            },
            {
                "nameValeu": "Tafta Mirage",
                "countfiltr": 21,
                "ID": 737
            },
            {
                "nameValeu": "Shade",
                "countfiltr": 25,
                "ID": 851
            },
            {
                "nameValeu": "Victorian",
                "countfiltr": 2,
                "ID": 798
            },
            {
                "nameValeu": "Bircan",
                "countfiltr": 43,
                "ID": 843
            },
            {
                "nameValeu": "Umbra",
                "countfiltr": 3,
                "ID": 853
            },
            {
                "nameValeu": "Velvet",
                "countfiltr": 7,
                "ID": 795
            },
            {
                "nameValeu": "Krep",
                "countfiltr": 36,
                "ID": 791
            },
            {
                "nameValeu": "Classic Saten",
                "countfiltr": 12,
                "ID": 882
            },
            {
                "nameValeu": "Milano",
                "countfiltr": 27,
                "ID": 883
            },
            {
                "nameValeu": "Blackout Mono",
                "countfiltr": 10,
                "ID": 887
            },
            {
                "nameValeu": "Pireo Net",
                "countfiltr": 7,
                "ID": 888
            },
            {
                "nameValeu": "Astar",
                "countfiltr": 20,
                "ID": 890
            },
            {
                "nameValeu": "Diamond",
                "countfiltr": 22,
                "ID": 891
            },
            {
                "nameValeu": "Kresha",
                "countfiltr": 4,
                "ID": 892
            },
            {
                "nameValeu": "Oxford",
                "countfiltr": 5,
                "ID": 895
            },
            {
                "nameValeu": "Shalimar",
                "countfiltr": 39,
                "ID": 896
            },
            {
                "nameValeu": "Slim",
                "countfiltr": 7,
                "ID": 819
            },
            {
                "nameValeu": "Sunshine",
                "countfiltr": 35,
                "ID": 897
            },
            {
                "nameValeu": "Tivoli Shine",
                "countfiltr": 23,
                "ID": 898
            },
            {
                "nameValeu": "Blackout Anka",
                "countfiltr": 14,
                "ID": 909
            },
            {
                "nameValeu": "Isabella",
                "countfiltr": 22,
                "ID": 917
            },
            {
                "nameValeu": "Marble",
                "countfiltr": 15,
                "ID": 918
            },
            {
                "nameValeu": "Silkette",
                "countfiltr": 4,
                "ID": 916
            },
            {
                "nameValeu": "Rekron Blackout Trevira",
                "countfiltr": 18,
                "ID": 954
            },
            {
                "nameValeu": "Pivot",
                "countfiltr": 10,
                "ID": 970
            },
            {
                "nameValeu": "Tendaggi Sky",
                "countfiltr": 15,
                "ID": 980
            },
            {
                "nameValeu": "Sabena",
                "countfiltr": 7,
                "ID": 999
            },
            {
                "nameValeu": "Combi",
                "countfiltr": 5,
                "ID": 1013
            },
            {
                "nameValeu": "Kezle",
                "countfiltr": 5,
                "ID": 1015
            },
            {
                "nameValeu": "Kim",
                "countfiltr": 9,
                "ID": 1016
            },
            {
                "nameValeu": "T-Theatre",
                "countfiltr": 105,
                "ID": 1094
            },
            {
                "nameValeu": "Refine",
                "countfiltr": 4,
                "ID": 1108
            },
            {
                "nameValeu": "Toto",
                "countfiltr": 24,
                "ID": 1110
            },
            {
                "nameValeu": "Sito",
                "countfiltr": 24,
                "ID": 1111
            },
            {
                "nameValeu": "Rixos",
                "countfiltr": 4,
                "ID": 1115
            },
            {
                "nameValeu": "Tetragon",
                "countfiltr": 22,
                "ID": 1329
            },
            {
                "nameValeu": "Algas Plain",
                "countfiltr": 26,
                "ID": 1120
            },
            {
                "nameValeu": "Piana",
                "countfiltr": 20,
                "ID": 1122
            },
            {
                "nameValeu": "Smooth Saten",
                "countfiltr": 15,
                "ID": 1124
            },
            {
                "nameValeu": "Solluna",
                "countfiltr": 9,
                "ID": 1127
            },
            {
                "nameValeu": "Rafael Gandia 140",
                "countfiltr": 17,
                "ID": 1136
            },
            {
                "nameValeu": "Northside",
                "countfiltr": 17,
                "ID": 1297
            },
            {
                "nameValeu": "Crepe Mild",
                "countfiltr": 7,
                "ID": 1300
            },
            {
                "nameValeu": "Soft Tul",
                "countfiltr": 29,
                "ID": 1301
            },
            {
                "nameValeu": "Double Face",
                "countfiltr": 44,
                "ID": 1302
            },
            {
                "nameValeu": "Decolux Eclipse Dimout",
                "countfiltr": 26,
                "ID": 1303
            },
            {
                "nameValeu": "New Chintz",
                "countfiltr": 19,
                "ID": 1304
            },
            {
                "nameValeu": "Doubio",
                "countfiltr": 18,
                "ID": 1305
            },
            {
                "nameValeu": "Doubio Effe",
                "countfiltr": 16,
                "ID": 1306
            },
            {
                "nameValeu": "Adele",
                "countfiltr": 10,
                "ID": 1308
            },
            {
                "nameValeu": "Matteo",
                "countfiltr": 10,
                "ID": 1309
            },
            {
                "nameValeu": "Violet",
                "countfiltr": 20,
                "ID": 1310
            },
            {
                "nameValeu": "Unlimited",
                "countfiltr": 24,
                "ID": 1326
            },
            {
                "nameValeu": "Slip",
                "countfiltr": 12,
                "ID": 1327
            },
            {
                "nameValeu": "Colorama",
                "countfiltr": 12,
                "ID": 1332
            },
            {
                "nameValeu": "Dolcetto",
                "countfiltr": 9,
                "ID": 1359
            },
            {
                "nameValeu": "Twister",
                "countfiltr": 105,
                "ID": 1360
            },
            {
                "nameValeu": "Vesuvio",
                "countfiltr": 60,
                "ID": 1433
            },
            {
                "nameValeu": "Garda",
                "countfiltr": 40,
                "ID": 1434
            },
            {
                "nameValeu": "Rio Organza",
                "countfiltr": 41,
                "ID": 1436
            },
            {
                "nameValeu": "Rio Taffetta",
                "countfiltr": 48,
                "ID": 1437
            },
            {
                "nameValeu": "Gaudi Drop",
                "countfiltr": 29,
                "ID": 1441
            },
            {
                "nameValeu": "Gaudi Pearl",
                "countfiltr": 30,
                "ID": 1440
            },
            {
                "nameValeu": "Gaudi Sand",
                "countfiltr": 17,
                "ID": 1439
            },
            {
                "nameValeu": "Satin Fashion",
                "countfiltr": 60,
                "ID": 1448
            },
            {
                "nameValeu": "Toledo",
                "countfiltr": 45,
                "ID": 1449
            },
            {
                "nameValeu": "Orione",
                "countfiltr": 58,
                "ID": 1450
            },
            {
                "nameValeu": "W191",
                "countfiltr": 10,
                "ID": 1759
            },
            {
                "nameValeu": "Siena Amy",
                "countfiltr": 25,
                "ID": 1451
            },
            {
                "nameValeu": "Siena Rey",
                "countfiltr": 36,
                "ID": 1452
            },
            {
                "nameValeu": "Zefiro",
                "countfiltr": 29,
                "ID": 1457
            },
            {
                "nameValeu": "Tivoli 5A",
                "countfiltr": 50,
                "ID": 1491
            },
            {
                "nameValeu": "Belle DL",
                "countfiltr": 18,
                "ID": 1586
            },
            {
                "nameValeu": "Mauritius",
                "countfiltr": 20,
                "ID": 1606
            },
            {
                "nameValeu": "Celebrity Espocada",
                "countfiltr": 59,
                "ID": 1618
            },
            {
                "nameValeu": "Organza BC",
                "countfiltr": 12,
                "ID": 1703
            },
            {
                "nameValeu": "Origin BC",
                "countfiltr": 8,
                "ID": 1706
            },
            {
                "nameValeu": "Barbara",
                "countfiltr": 14,
                "ID": 1727
            },
            {
                "nameValeu": "Evangelista",
                "countfiltr": 21,
                "ID": 1728
            },
            {
                "nameValeu": "Fresco",
                "countfiltr": 14,
                "ID": 1729
            },
            {
                "nameValeu": "Satin Factura",
                "countfiltr": 11,
                "ID": 1730
            },
            {
                "nameValeu": "W260",
                "countfiltr": 14,
                "ID": 1757
            },
            {
                "nameValeu": "W2099",
                "countfiltr": 6,
                "ID": 1761
            },
            {
                "nameValeu": "W537130",
                "countfiltr": 14,
                "ID": 1762
            },
            {
                "nameValeu": "W2125",
                "countfiltr": 2,
                "ID": 1763
            },
            {
                "nameValeu": "W1168",
                "countfiltr": 1,
                "ID": 1766
            },
            {
                "nameValeu": "Voile",
                "countfiltr": 4,
                "ID": 312
            },
            {
                "nameValeu": "Rubino",
                "countfiltr": 62,
                "ID": 1807
            },
            {
                "nameValeu": "Glamour DLX",
                "countfiltr": 27,
                "ID": 1821
            },
            {
                "nameValeu": "Bari",
                "countfiltr": 28,
                "ID": 1824
            },
            {
                "nameValeu": "Groove",
                "countfiltr": 18,
                "ID": 1836
            },
            {
                "nameValeu": "Heat CSB",
                "countfiltr": 24,
                "ID": 1982
            },
            {
                "nameValeu": "Devore",
                "countfiltr": 5,
                "ID": 226
            },
            {
                "nameValeu": "Sun",
                "countfiltr": 12,
                "ID": 2005
            },
            {
                "nameValeu": "Alcantara Shape",
                "countfiltr": 50,
                "ID": 2033
            },
            {
                "nameValeu": "Vual Anka",
                "countfiltr": 55,
                "ID": 2067
            },
            {
                "nameValeu": "Dolce New CSB",
                "countfiltr": 9,
                "ID": 2082
            },
            {
                "nameValeu": "Castilla Pina",
                "countfiltr": 38,
                "ID": 2135
            },
            {
                "nameValeu": "Half Panama",
                "countfiltr": 241,
                "ID": 2294
            },
            {
                "nameValeu": "Visillo Con Plomo",
                "countfiltr": 10,
                "ID": 2295
            },
            {
                "nameValeu": "SGH Viscosa Lino",
                "countfiltr": 8,
                "ID": 2296
            },
            {
                "nameValeu": "SB Chartres",
                "countfiltr": 6,
                "ID": 1337
            },
            {
                "nameValeu": "SB Natte",
                "countfiltr": 43,
                "ID": 1342
            },
            {
                "nameValeu": "SB Solids and Stripes",
                "countfiltr": 48,
                "ID": 1345
            },
            {
                "nameValeu": "SB Velum",
                "countfiltr": 18,
                "ID": 1350
            },
            {
                "nameValeu": "X2896",
                "countfiltr": 5,
                "ID": 2332
            },
            {
                "nameValeu": "W2277",
                "countfiltr": 7,
                "ID": 2330
            },
            {
                "nameValeu": "W2646",
                "countfiltr": 21,
                "ID": 2328
            },
            {
                "nameValeu": "Vinaldi Borders",
                "countfiltr": 61,
                "ID": 2398
            },
            {
                "nameValeu": "Unique ADK",
                "countfiltr": 36,
                "ID": 2406
            },
            {
                "nameValeu": "Exclusive ADK",
                "countfiltr": 80,
                "ID": 2426
            }
        ]
    },
    {
        "ID": "67",
        "NAME": "Назначение",
        "CODE": "usage",
        "PROPERTY_TYPE": "L",
        "LIST_TYPE": "L",
        "DISPLAY_TYPE": "F",
        "PROPERTY_VALUE": [
            {
                "nameValeu": "Для гостиной",
                "countfiltr": 59316,
                "ID": 403
            },
            {
                "nameValeu": "Для спальни",
                "countfiltr": 59249,
                "ID": 404
            },
            {
                "nameValeu": "Для детской",
                "countfiltr": 1051,
                "ID": 405
            },
            {
                "nameValeu": "Для кухни",
                "countfiltr": 39253,
                "ID": 402
            },
            {
                "nameValeu": "На улицу",
                "countfiltr": 1306,
                "ID": 406
            },
            {
                "nameValeu": "Для авто",
                "countfiltr": 212,
                "ID": 6562
            }
        ]
    },
    {
        "ID": "66",
        "NAME": "Особые свойства",
        "CODE": "spetial",
        "PROPERTY_TYPE": "L",
        "LIST_TYPE": "L",
        "DISPLAY_TYPE": "F",
        "PROPERTY_VALUE": [
            {
                "nameValeu": "Светонепроницаемая",
                "countfiltr": 4467,
                "ID": 401
            },
            {
                "nameValeu": "Двусторонняя",
                "countfiltr": 1799,
                "ID": 398
            },
            {
                "nameValeu": "Водоотталкивающая",
                "countfiltr": 2003,
                "ID": 397
            },
            {
                "nameValeu": "Негорючая",
                "countfiltr": 3023,
                "ID": 399
            },
            {
                "nameValeu": "Многослойная",
                "countfiltr": 539,
                "ID": 400
            },
            {
                "nameValeu": "Невыгорающая",
                "countfiltr": 1336,
                "ID": 1036
            }
        ]
    },
    {
        "ID": "98",
        "NAME": "Аксессуар",
        "CODE": "accessory",
        "PROPERTY_TYPE": "L",
        "LIST_TYPE": "L",
        "DISPLAY_TYPE": "F",
        "PROPERTY_VALUE": [
            {
                "nameValeu": "Шнур вшивной",
                "countfiltr": 374,
                "ID": 1416
            },
            {
                "nameValeu": "Сутаж",
                "countfiltr": 88,
                "ID": 1418
            },
            {
                "nameValeu": "Бахрома",
                "countfiltr": 560,
                "ID": 1417
            },
            {
                "nameValeu": "Кисть",
                "countfiltr": 521,
                "ID": 1413
            },
            {
                "nameValeu": "Подхват",
                "countfiltr": 376,
                "ID": 1414
            },
            {
                "nameValeu": "Пуговица",
                "countfiltr": 10,
                "ID": 1599
            },
            {
                "nameValeu": "Тесьма",
                "countfiltr": 306,
                "ID": 1622
            },
            {
                "nameValeu": "Шнур",
                "countfiltr": 12,
                "ID": 1722
            },
            {
                "nameValeu": "Розетка",
                "countfiltr": 66,
                "ID": 1947
            },
            {
                "nameValeu": "Аксессуары",
                "countfiltr": 36,
                "ID": 1422
            },
            {
                "nameValeu": "Бордюр",
                "countfiltr": 241,
                "ID": 2396
            }
        ]
    },
    {
        "ID": "99",
        "NAME": "Тест Мартиндейла",
        "CODE": "martindale",
        "PROPERTY_TYPE": "N",
        "LIST_TYPE": "N",
        "DISPLAY_TYPE": "A",
        "PROPERTY_VALUE": [
            0,
            317000
        ]
    }
]